import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./HospitalityManagement.module.css";
import { Button, Caption1, Persona, Tab, TabList, Text, Divider, MenuButtonProps, DrawerProps, Switch, InfoLabel, Link, Subtitle2Stronger, ComboboxProps } from "@fluentui/react-components";
import {
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  SplitButton,
  Combobox,
  Option,
  Label,
  Input,
  Field,
  Spinner,
} from "@fluentui/react-components";
import {
  DrawerBody, DrawerHeader, DrawerHeaderTitle, OverlayDrawer,
  Avatar,
  SearchBox,
  List,
  ListItem,
  tokens,
  SelectionItemId,
  mergeClasses,
  AvatarNamedColor,
  PresenceBadgeStatus,
  Toolbar,
  ToolbarToggleButton,
  Badge,
  ToolbarDivider,
  Tooltip,
  MessageBar,
  MessageBarActions,
  MessageBarBody,

  MessageBarTitle,
  Checkbox,
} from "@fluentui/react-components";
import {
  FolderRegular,
  OpenRegular,
  PeopleRegular,
  DocumentPdfRegular,
  VideoRegular,
  ClockFilled,
  PresenceAvailableFilled,
  Timer16Regular,
  ChevronDown16Regular,
  Settings16Regular,
  ArrowDownloadRegular,
  DocumentArrowDownRegular,
  DocumentFlowchartRegular,
  LinkRegular,
  DocumentDataLinkRegular,
  Pin16Regular,
  Clock24Regular,
  Clock16Regular,
  ChevronLeft16Regular,
  BookInformation24Regular,
  Bed16Regular,
  ArrowSync16Regular,
  Guest16Regular,
  CalendarPerson16Regular,
  BookOpen16Regular,
  DocumentCheckmark16Regular,
  ShoppingBagTag16Regular,
  Call16Regular,
  MailInbox16Regular,
  Checkmark16Regular,
  CalendarCancel16Regular,
  DocumentAdd16Regular,
  AppsBulletListRegular,
} from "@fluentui/react-icons";
import {
  TableBody,
  TableCell,
  TableRow,
  Table,
  TableHeader,
  TableHeaderCell,
  TableCellLayout,
  CardFooter,
} from "@fluentui/react-components";
import {
  ArrowMoveRegular, ArrowMoveInwardRegular,
  ListRtlRegular, CalendarRegular,
  ChevronLeftRegular, ChevronRightRegular,
  BookOpenRegular,
  AirplaneLandingRegular,
  BookContactsRegular,
  ArrowCounterclockwiseDashesRegular,
  LayoutColumnTwoSplitLeftRegular,
  BedFilled,
  AirplaneLandingFilled,
  WeatherMoonRegular,
  BedRegular,
  EditRegular,
  BranchCompareRegular,
  ConferenceRoomRegular,
  PersonWalkingRegular,
  PersonAddRegular,
  DeviceMeetingRoomRegular,
  BreakoutRoomRegular,
  CalendarEmptyRegular,
  PeopleCommunityRegular,
  PersonRegular,
  PeopleQueueRegular,
  AddRegular,
  MoreHorizontalRegular,
  SettingsRegular,
  ChatHelpRegular,
  Dismiss24Regular,
  HomeRegular,
  DismissRegular,
  PersonSupportRegular,
  ChannelAddRegular,
  PeopleTeamRegular,
  PersonVoiceRegular,
  BuildingRegular,
  MailAddRegular,
  PhoneShakeRegular,
  ConnectedRegular,
  PaymentWirelessRegular,
  ClipboardTextEditRegular,
  DocumentCopyRegular,
  DocumentRegular,
  DocumentSaveRegular,
} from '@fluentui/react-icons';
import {
  Card,
  CardHeader,
  CardPreview,
  Skeleton,
  SkeletonItem,
  makeStyles,
  Radio, RadioGroup,
  MenuButton,
  InlineDrawer,
  Title3,
} from "@fluentui/react-components";
import {
  AirplaneRegular,
  AirplaneTakeOffRegular,
  TimeAndWeatherRegular,
  SearchRegular,
  PersonStarRegular,
  CheckboxPersonRegular,
} from "@fluentui/react-icons";

import HiddenSideBar from "../sideBar/hiddenSideBar/SideBarHidden";
import HamburgerButton from "../../constants/ButtonController/Controller";
import { addDays } from "@fluentui/react-calendar-compat";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import type { DatePickerProps } from "@fluentui/react-datepicker-compat";
import { apiCall as coreApiCall } from "../../api/services";
import { initializedReservation, Reservation } from "../../types/ReservationDto";
import useAuth from "../../hooks/useAuth";
import { format, isToday, parseISO, parse } from 'date-fns';

import {
  DonutChart,
  ChartProps,
  ChartDataPoint,
  DataVizPalette,
  getColorFromToken,
} from "@fluentui/react-charts-preview";
import { DonutChartCustomAccessibility } from "./Charts/Donut";

import dayjs from "dayjs"; // Import for date formatting
import { Guest, initializedGuest } from "../../types/Guest";
import { Category } from "../../types/RoomCategory";
import { Company } from "../../types/company";
import { HotelRoomType } from "../../types/HotelRoomTypes";
import { InitRoom, Room } from "../../types/Room";
import PaymentOptions from "./PaymentOption/PaymentOption";
import RoomForms from "./RoomForm/RoomForms";
import { Icon } from "@fluentui/react";
import { HProperty } from "../../types/PropertyLocation";
import luxuryMorden from "../../assets/images/modernLuxury.jpg";

import {
  AlertBadgeRegular,
  CalendarMonthRegular,
  MicRegular,
  Settings24Regular,
  Settings20Regular,
  FilterRegular,
  Add24Regular,
  TopSpeedRegular,
  NoteEditRegular,
  AppTitleRegular,
  PersonAccountsRegular,
  ContactCardLinkRegular,
  SlideTextCallRegular,
  NoteAddRegular,
  FolderPeopleRegular,
  MailArrowForward16Regular,
  Share16Regular,
  Save16Regular,
  Add16Regular,
  BookDismiss16Regular,
  PeopleAdd16Regular,
  FolderList16Regular,
  PersonAdd16Regular,

  Calendar16Regular,
  ChevronRight16Regular,
  BuildingTownhouseRegular,
  CheckboxPerson16Regular,
  PersonAccount16Regular,
} from "@fluentui/react-icons";

import { GuestWorkflow } from "../../types/GuestWorkflow";
import { RoomWorkflow } from "../../types/RoomWorkflow";
import GuestView from "./Guest/Guest";
import { WorkflowCategories } from "../Global/GlobalItems";
import { WorkflowTab } from "../../types/workflowTabs";
import { RoomType } from "../../types/RoomTypes";
import { color } from "@cloudinary/url-gen/qualifiers/background";
import AvailableOffers from "./RoomForm/RoomForms";
import { useMemo } from "react";
import {
  Button as HzButton,
  Dialog as HzDialog,
  DialogActions as HzDialogActions,
  DialogBody as HzDialogBody,
  DialogContent as HzDialogContent,
  DialogSurface as HzDialogSurface,
  DialogTitle as HzDialogTitle,
  DialogTrigger as HzDialogTrigger,
  Field as HzField,
  Input as HzInput,
  Select as HzSelect,
  TabList as HzTabList,
  Tab as HzTab,
  SearchBox as HzSearchBox,
} from "@fluentui/react-components";
import {
  Add20Regular as HzAdd20Regular,
  ArrowDownload20Regular as HzArrowDownload20Regular,
  ArrowSync20Regular as HzArrowSync20Regular,
  ArrowUndo20Regular as HzArrowUndo20Regular,
  Box20Regular as HzBox20Regular,
  Broom20Regular as HzBroom20Regular,
  CalendarClock20Regular as HzCalendarClock20Regular,
  Cart20Regular as HzCart20Regular,
  Checkmark20Regular as HzCheckmark20Regular,
  CheckmarkCircle20Regular as HzCheckmarkCircle20Regular,
  ChevronDown12Regular as HzChevronDown12Regular,
  ChevronLeft20Regular as HzChevronLeft20Regular,
  ChevronRight20Regular as HzChevronRight20Regular,
  ChevronUp12Regular as HzChevronUp12Regular,
  ClipboardTask20Regular as HzClipboardTask20Regular,
  Copy20Regular as HzCopy20Regular,
  Delete20Regular as HzDelete20Regular,
  Dismiss20Regular as HzDismiss20Regular,
  Dismiss24Regular as HzDismiss24Regular,
  Edit20Regular as HzEdit20Regular,
  Key20Regular as HzKey20Regular,
  Money20Regular as HzMoney20Regular,
  Person20Regular as HzPerson20Regular,
  PersonArrowLeft20Regular as HzPersonArrowLeft20Regular,
  PersonArrowRight20Regular as HzPersonArrowRight20Regular,
  PersonStar20Regular as HzPersonStar20Regular,
  PlugConnected20Regular as HzPlugConnected20Regular,
  PlugDisconnected20Regular as HzPlugDisconnected20Regular,
  Prohibited20Regular as HzProhibited20Regular,
  Receipt20Regular as HzReceipt20Regular,
  Send20Regular as HzSend20Regular,
  Sparkle20Regular as HzSparkle20Regular,
  Star20Regular as HzStar20Regular,
  Tag20Regular as HzTag20Regular,
  Warning20Regular as HzWarning20Regular,
  WeatherMoon20Regular as HzWeatherMoon20Regular,
  Wrench20Regular as HzWrench20Regular,
  Mail20Regular as HzMail20Regular,
  Call20Regular as HzCall20Regular,
  Globe20Regular as HzGlobe20Regular,
  Bed20Regular as HzBed20Regular,
  People20Regular as HzPeople20Regular,
} from "@fluentui/react-icons";
import RoomOffers from "./RoomOffers";
import { useHzData, useHzBoot, makeDashApiCall, hzPost, hzPropertyId, hzReload } from "./Api/hzApi";
import ModulesHub from "./Modules/ModulesHub";

/** The reservation form's lookups, now served by the dashboard service (the auth lookups still use the core client). */
const apiCall = makeDashApiCall(coreApiCall as (c: any) => Promise<any>);
const hospitality = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzY4NzJfMTc4NzUiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjMiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyMSI+CjxwYXRoIGQ9Ik0xMiA1Ljk5OTk4QzEyIDQuMzQzMTIgMTAuNjU2OSAyLjk5OTk3IDkuMDAwMDIgMi45OTk5N0gzLjc1MDAxQzIuMDkzMTUgMi45OTk5NyAwLjc1IDQuMzQzMTIgMC43NSA1Ljk5OTk4VjE4QzAuNzUgMTkuNjU2OSAyLjA5MzE1IDIxIDMuNzUwMDEgMjFIOC4yNDcwOUM5LjY3MzgxIDIxIDEwLjkxNDQgMjEuNzk2OCAxMS41NDgzIDIyLjk2OTZDMTEuNjM4NCAyMy4xMzYzIDExLjgwNzYgMjMuMjUgMTEuOTk3MSAyMy4yNUMxMi4xODY2IDIzLjI1IDEyLjM1NTggMjMuMTM2MyAxMi40NDU5IDIyLjk2OTZDMTMuMDc5OCAyMS43OTY4IDE0LjMyMDQgMjEgMTUuNzQ3MSAyMUgyMC4yNUMyMS45MDY5IDIxIDIzLjI1MDEgMTkuNjU2OSAyMy4yNTAxIDE4TDIzLjI1MDEgNS45OTk5OEMyMy4yNTAxIDQuMzQzMTIgMjEuOTA2OSAyLjk5OTk3IDIwLjI1IDIuOTk5OTdIMTVDMTMuMzQzMiAyLjk5OTk3IDEyIDQuMzQzMTIgMTIgNS45OTk5OFoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl82ODcyXzE3ODc1KSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfNjg3Ml8xNzg3NSkiPgo8cGF0aCBkPSJNMC43NSAyMy4yNUgxMkwxMiAyLjk5OTk1SDAuNzVMMC43NSAyMy4yNVoiIGZpbGw9InVybCgjcGFpbnQxX2xpbmVhcl82ODcyXzE3ODc1KSIvPgo8cGF0aCBkPSJNMTIgMThWNS45OTk5OEMxMiA0LjM0MzEyIDEwLjY1NjkgMi45OTk5NyA5LjAwMDAyIDIuOTk5OTdMMy43NTAwMSAyLjk5OTk3QzIuMDkzMTUgMi45OTk5NyAwLjc1IDQuMzQzMTIgMC43NSA1Ljk5OTk4TDAuNzUgMTJDMC43NSAxMy42NTY4IDIuMDkzMTUgMTUgMy43NTAwMSAxNUg5LjAwMDAyQzEwLjY1NjkgMTUgMTIgMTYuMzQzMSAxMiAxOFoiIGZpbGw9InVybCgjcGFpbnQyX2xpbmVhcl82ODcyXzE3ODc1KSIvPgo8cGF0aCBkPSJNMTIgMTJWNS45OTk5OEMxMiA0LjM0MzEyIDEwLjY1NjkgMi45OTk5NyA5LjAwMDAyIDIuOTk5OTdMMy43NTAwMSAyLjk5OTk3QzIuMDkzMTUgMi45OTk5NyAwLjc1IDQuMzQzMTIgMC43NSA1Ljk5OTk4QzAuNzUgNy42NTY4NCAyLjA5MzE1IDguOTk5OTggMy43NTAwMSA4Ljk5OTk5SDkuMDAwMDJDMTAuNjU2OSA4Ljk5OTk5IDEyIDEwLjM0MzEgMTIgMTJaIiBmaWxsPSJ1cmwoI3BhaW50M19saW5lYXJfNjg3Ml8xNzg3NSkiLz4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZGRfNjg3Ml8xNzg3NSkiPgo8cGF0aCBkPSJNMjAuMjUgMjMuMjVDMjEuOTA2OSAyMy4yNSAyMy4yNSAyMS45MDY5IDIzLjI1IDIwLjI1TDIzLjI1IDUuOTk5OThDMjMuMjUgNC4zNDMxMiAyMS45MDY5IDIuOTk5OTcgMjAuMjUgMi45OTk5N0wxNSAyLjk5OTk3QzEzLjM0MzIgMi45OTk5NyAxMiA0LjM0MzEyIDEyIDUuOTk5OThMMTIgMjMuMjVDMTIgMjMuMjUgMTguNzg2NiAyMy4yNSAyMC4yNSAyMy4yNVoiIGZpbGw9InVybCgjcGFpbnQ0X2xpbmVhcl82ODcyXzE3ODc1KSIvPgo8cGF0aCBkPSJNMjAuMjUgMjMuMjVDMjEuOTA2OSAyMy4yNSAyMy4yNSAyMS45MDY5IDIzLjI1IDIwLjI1TDIzLjI1IDUuOTk5OThDMjMuMjUgNC4zNDMxMiAyMS45MDY5IDIuOTk5OTcgMjAuMjUgMi45OTk5N0wxNSAyLjk5OTk3QzEzLjM0MzIgMi45OTk5NyAxMiA0LjM0MzEyIDEyIDUuOTk5OThMMTIgMjMuMjVDMTIgMjMuMjUgMTguNzg2NiAyMy4yNSAyMC4yNSAyMy4yNVoiIGZpbGw9InVybCgjcGFpbnQ1X2xpbmVhcl82ODcyXzE3ODc1KSIvPgo8L2c+CjwvZz4KPGRlZnM+CjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZGRfNjg3Ml8xNzg3NSIgeD0iMTAuNDIyNSIgeT0iMS44MTY4MiIgd2lkdGg9IjE0LjQwNTEiIGhlaWdodD0iMjMuNDA1MSIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIgcmVzdWx0PSJoYXJkQWxwaGEiLz4KPGZlT2Zmc2V0IGR5PSIwLjA3ODg3NjgiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMC4wNzg4NzY4Ii8+CjxmZUNvbG9yTWF0cml4IHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjI0IDAiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJlZmZlY3QxX2Ryb3BTaGFkb3dfNjg3Ml8xNzg3NSIvPgo8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIgcmVzdWx0PSJoYXJkQWxwaGEiLz4KPGZlT2Zmc2V0IGR5PSIwLjM5NDM4NCIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIwLjc4ODc2OCIvPgo8ZmVDb2xvck1hdHJpeCB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4zMiAwIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3dfNjg3Ml8xNzg3NSIgcmVzdWx0PSJlZmZlY3QyX2Ryb3BTaGFkb3dfNjg3Ml8xNzg3NSIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDJfZHJvcFNoYWRvd182ODcyXzE3ODc1IiByZXN1bHQ9InNoYXBlIi8+CjwvZmlsdGVyPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNjg3Ml8xNzg3NSIgeDE9IjYuMDAwMDEiIHkxPSIyLjk5OTk3IiB4Mj0iMzUuNzc4NyIgeTI9IjMxLjY3NCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjQjJGODlCIi8+CjxzdG9wIG9mZnNldD0iMC41MTEwMjYiIHN0b3AtY29sb3I9IiM2MUNCOEEiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMjI5Q0FDIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQxX2xpbmVhcl82ODcyXzE3ODc1IiB4MT0iLTIuMjUwMDEiIHkxPSIxOCIgeDI9IjExLjYyNSIgeTI9IjQuMTI0OTUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzUyNEJCNSIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMyQzU3QzIiLz4KPC9saW5lYXJHcmFkaWVudD4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDJfbGluZWFyXzY4NzJfMTc4NzUiIHgxPSIwLjM3NDk5OCIgeTE9IjE0LjI1IiB4Mj0iMTEuMjUiIHkyPSIzLjM3NDk3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMyRjY1REEiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjM0Q3REVCIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQzX2xpbmVhcl82ODcyXzE3ODc1IiB4MT0iMC4zNzQ5OTgiIHkxPSIxNSIgeDI9IjEyIiB5Mj0iMy4zNzQ5NyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMDA5NEYwIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzE0QjFGRiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50NF9saW5lYXJfNjg3Ml8xNzg3NSIgeDE9IjcuODc1MDIiIHkxPSIyMS4zNzUiIHgyPSI2LjE4NjA1IiB5Mj0iNy40MDM0NSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMTRCMUZGIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzNERDlFQiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50NV9saW5lYXJfNjg3Ml8xNzg3NSIgeDE9IjcuNDk5OTkiIHkxPSIyMSIgeDI9IjI0Ljc1IiB5Mj0iMy43NDk5OCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjM0REOUVCIiBzdG9wLW9wYWNpdHk9IjAiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNzhGMkQ0Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";


interface CarouselItem {
  id: number;
  date: string;
  weekLabel: string;
  hiTemp: string;
  lowTemp: string;
  isSelected?: boolean;
  isOverview?: boolean;
}

const columns = [
  { columnKey: "RoomNumber", label: "Room Number" },
  { columnKey: "Status", label: "Room Status" },
  { columnKey: "Rate", label: "Room Rate" },
  { columnKey: "Description", label: "Description" },
  { columnKey: "RoomName", label: "Room Name" },
  { columnKey: "Guests", label: "Guest Name" }, // Correct guest column
  { columnKey: "BookingStatus", label: "Booking Status" },
  { columnKey: "LockedStatus", label: "Manage Booking" },
];

const hardCodedRooms = [
  {
    RoomNumber: "101",
    RoomCategory: "Suite",
    Status: "Clean",
    Rate: "$120/night",
    Description: "Spacious room with ocean view",
    RoomName: "Ocean Suite",
    Guests: { label: "Max Mustermann", status: "available" }, // Guest exists
    BookingStatus: "Booked",
    LockedStatus: "Locked",
  },
  {
    RoomNumber: "102",
    RoomCategory: "Suite",
    Status: "Available",
    Rate: "$120/night",
    Description: "Spacious room with ocean view",
    RoomName: "City Comfort",
    Guests: null, // Changed empty values to null
    BookingStatus: "Available",
    LockedStatus: "Unlocked",
  },
];


const invitationData = [
  {
    id: 1,
    title: "Andela Developer Webinar",
    date: "July 29, 2025",
    note: "Send an invitation or reminder message",
    summary: "This webiner is focused on empowering developers with the latest opportunities.",
  },

];

const useStyles = makeStyles({
  control: {
    maxWidth: "300px",
    maxHeight: "240px",
  },
  tooltip: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundInverted,
  },
});



  
/* the Upcoming / In-house list comes from the backend (see loadWorkflows) */
const workflowTabs: WorkflowTab[] = [];

const today = new Date();

const dayLabel = (offset: number) => {
  if (offset === -1) return 'Yesterday';
  if (offset === 0) return 'Today';
  const d = new Date(today);
  d.setDate(d.getDate() + offset);
  return d.toLocaleDateString('en-US', { weekday: 'short' }); // Mon, Tue, ...
};

const dateNum = (offset: number) => {
  const d = new Date(today);
  d.setDate(d.getDate() + offset);
  return String(d.getDate());
};

const CarouselItems: CarouselItem[] = [
  { id: 1, date: dateNum(-1), weekLabel: dayLabel(-1), hiTemp: '72', lowTemp: '58', isSelected: true },
  { id: 2, date: dateNum(0),  weekLabel: dayLabel(0),  hiTemp: '75', lowTemp: '60', isOverview: true },
  { id: 3, date: dateNum(1),  weekLabel: dayLabel(1),  hiTemp: '78', lowTemp: '61' },
  { id: 4, date: dateNum(2),  weekLabel: dayLabel(2),  hiTemp: '74', lowTemp: '59' },
  { id: 5, date: dateNum(3),  weekLabel: dayLabel(3),  hiTemp: '69', lowTemp: '55' },
  { id: 6, date: dateNum(4),  weekLabel: dayLabel(4),  hiTemp: '71', lowTemp: '57' },
  { id: 7, date: dateNum(5),  weekLabel: dayLabel(5),  hiTemp: '80', lowTemp: '63' },
  { id: 8, date: dateNum(6),  weekLabel: dayLabel(6),  hiTemp: '77', lowTemp: '60' },
  { id: 9, date: dateNum(7),  weekLabel: dayLabel(7),  hiTemp: '73', lowTemp: '58' },
];
/***
 * Menu Items for Hospitality Management
 */
export type WorkflowCategory = typeof WorkflowCategories[keyof typeof WorkflowCategories];

const menuItems: WorkflowCategory[] = [
  WorkflowCategories.Upcoming,
  WorkflowCategories.CheckedInGuests,
  WorkflowCategories.CheckingOutToday,
  WorkflowCategories.OccupiedRooms,
  WorkflowCategories.AvailableRooms,
];

/***
 * 
 */

/* =====================================================================
   Hospitality pages (every tab except HMS)
   Sample data lives in the browser. The assistant is a local rules engine:
   swap hzAsk() for a real model call when the backend is ready.
   ===================================================================== */
type Val = string | number;
interface Row {
  id: string;
  [k: string]: Val;
}
type HzData = Record<string, Row[]>;
interface Opt {
  v: string;
  l: string;
}
interface Fld {
  key: string;
  label: string;
  kind: "text" | "number" | "date" | "select";
  options?: Opt[] | ((d: HzData) => Opt[]);
  required?: boolean;
  full?: boolean;
}
interface Col {
  key: string;
  label: string;
  kind?: "money" | "date" | "status" | "num" | "pct" | "mono" | "bar";
  get?: (r: Row, d: HzData) => Val;
  right?: boolean;
}
interface Draft {
  title: string;
  body: string;
  guest?: string;
  note?: boolean;
}
interface Res {
  patch?: Record<string, Val>;
  other?: { ent: string; id: string; patch: Record<string, Val> }[];
  creates?: { ent: string; id?: string; values: Record<string, Val> }[];
  draft?: Draft;
  msg: string;
  err?: string;
}
interface Act {
  label: string;
  icon: React.ReactNode;
  show: (r: Row, d: HzData) => boolean;
  run: (r: Row, d: HzData, v: Record<string, Val>) => Res;
  prompt?: { title: string; submit: string; fields: Fld[]; init: (r: Row, d: HzData) => Record<string, Val> };
}
interface Tile {
  label: string;
  value: string;
  note?: string;
}
interface Entity {
  id: string;
  src: string;
  title: string;
  subtitle: string;
  noun: string;
  prefix?: string;
  idField?: string;
  initial?: Record<string, Val>;
  where?: (r: Row, d: HzData) => boolean;
  cols: Col[];
  fields: Fld[];
  acts: Act[];
  readOnly?: boolean;
  noDelete?: boolean;
  filterKey?: string;
  filterLabel?: string;
  validate?: (v: Record<string, Val>, d: HzData, existing: Row | null) => string | null;
  canDelete?: (r: Row, d: HzData) => string | null;
  summary?: (list: Row[], d: HzData) => Tile[];
  detail?: (r: Row, d: HzData) => React.ReactNode;
}
interface PageProps {
  data: HzData;
  setData: React.Dispatch<React.SetStateAction<HzData>>;
  say: (msg: string, err?: boolean) => void;
}

/* ---------- helpers ---------- */
const NGN = new Intl.NumberFormat("en-NG", { style: "currency", currency: "NGN", maximumFractionDigits: 0 });
const money = (n: number) => NGN.format(Math.round(n) || 0);
const compact = (n: number) => (Math.abs(n) >= 1e6 ? `₦${(n / 1e6).toFixed(1)}M` : Math.abs(n) >= 1e3 ? `₦${Math.round(n / 1e3)}K` : money(n));
const pad2 = (n: number) => String(n).padStart(2, "0");
const isoD = (dt: Date) => `${dt.getFullYear()}-${pad2(dt.getMonth() + 1)}-${pad2(dt.getDate())}`;
const parseD = (s: string) => {
  const [y, m, dd] = s.split("-").map(Number);
  return new Date(y ?? 1970, (m ?? 1) - 1, dd ?? 1);
};
const hzAddDays = (s: string, n: number) => {
  const dt = parseD(s);
  dt.setDate(dt.getDate() + n);
  return isoD(dt);
};
const off = (n: number) => hzAddDays(isoD(new Date()), n);
const fdate = (s: string) => (s ? parseD(s).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "");
const fshort = (s: string) => parseD(s).toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
const dow = (s: string) => parseD(s).toLocaleDateString("en-GB", { weekday: "short" });
const daysBetween = (a: string, b: string) => Math.round((parseD(b).getTime() - parseD(a).getTime()) / 86400000);
const num = (v: Val | undefined): number => (typeof v === "number" ? v : Number(v) || 0);
const rows = (d: HzData, k: string): Row[] => d[k] ?? [];
const sum = (list: Row[], f: (r: Row) => number) => list.reduce((t, r) => t + f(r), 0);
const R = (id: string, o: Record<string, Val>): Row => ({ id, ...o });
const opts = (...a: string[]): Opt[] => a.map((v) => ({ v, l: v }));
const cap = (s: string) => `${s[0]?.toUpperCase() ?? ""}${s.slice(1)}`;
const pct = (a: number, b: number) => (b > 0 ? Math.round((a / b) * 100) : 0);
const nameOf = (d: HzData, k: string, id: Val | undefined) => String(rows(d, k).find((r) => r.id === String(id))?.name ?? id ?? "");
const nextId = (prefix: string, list: Row[]): string => {
  const mx = list.reduce((m, r) => Math.max(m, Number(r.id.slice(prefix.length)) || 0), 0);
  return prefix + String(mx + 1).padStart(4, "0");
};
const PFX: Record<string, string> = { guests: "GS-", reservations: "RS-", charges: "CG-", workorders: "WO-", moves: "SM-", messages: "MS-", orders: "PO-", audits: "NA-" };

const TONE: Record<string, string> = {
  Active: "green", Confirmed: "green", "Checked in": "green", Occupied: "green", Clean: "green", Inspected: "green", Completed: "green", Resolved: "green", Positive: "green", Connected: "green", "In stock": "green", Received: "green", Definite: "green", Accepted: "green", Booked: "green", Claimed: "green", "In parity": "green", "On duty": "green", Paid: "green", Settled: "green",
  Pending: "amber", Tentative: "amber", Dirty: "amber", Neutral: "amber", Low: "amber", Medium: "amber", Waiting: "amber", Offered: "amber", Ordered: "amber", "In progress": "blue", "On leave": "amber", Open: "blue", Paused: "amber", Draft: "grey", Scheduled: "blue", Stored: "blue", New: "blue", Vacant: "grey", "Checked out": "grey", Gold: "amber", Silver: "grey", Platinum: "blue", Member: "grey", None: "grey", Responded: "green", "Off duty": "grey", Expired: "grey", Disposed: "grey", Cancelled: "grey", Rejected: "grey", Inactive: "grey", Credit: "blue",
  "Out of order": "red", "No-show": "red", Negative: "red", High: "red", Out: "red", Escalated: "red", Error: "red", Blacklisted: "red", "Out of parity": "red", Disconnected: "red", "On hold": "red", Owing: "red",
};
const Pill: React.FC<{ text: string }> = ({ text }) => <span className={`${styles.hzPill} ${styles["hzTone_" + (TONE[text] || "grey")]}`}>{text}</span>;

/* ---------- property rules ---------- */
const ACTIVE = ["Pending", "Confirmed", "Checked in"];
const resActive = (r: Row) => ACTIVE.includes(String(r.status));
const nightsOf = (r: Row) => Math.max(daysBetween(String(r.arrive), String(r.depart)), 1);
const resTotal = (r: Row) => num(r.rate) * nightsOf(r);
const holds = (r: Row, date: string) => String(r.arrive) <= date && date < String(r.depart);
const roomsOf = (d: HzData, rt: string) => rows(d, "rooms").filter((x) => x.type === rt && x.state !== "Out of order");
const inService = (d: HzData) => rows(d, "rooms").filter((x) => x.state !== "Out of order").length;
const booked = (d: HzData, date: string, rt?: string) => rows(d, "reservations").filter((r) => (resActive(r) || (r.status === "Checked out" && String(r.depart) > date)) && holds(r, date) && (!rt || r.roomType === rt)).length;
const availOn = (d: HzData, rt: string, date: string) => roomsOf(d, rt).length - booked(d, date, rt);
const occOn = (d: HzData, date: string) => pct(booked(d, date), inService(d));
const stopSold = (d: HzData, rt: string, date: string) => rows(d, "restrictions").some((x) => x.id === `${rt}|${date}`);
const isOccupied = (d: HzData, room: string) => rows(d, "reservations").some((r) => r.status === "Checked in" && r.room === room);
const roomFree = (d: HzData, room: string, a: string, b: string, except?: string) =>
  !rows(d, "reservations").some((r) => r.id !== except && resActive(r) && r.room === room && String(r.arrive) < b && a < String(r.depart));
const charges = (d: HzData, res: string) => rows(d, "charges").filter((c) => c.res === res);
const balanceOf = (d: HzData, res: string) => sum(charges(d, res), (c) => (c.kind === "Payment" ? -num(c.amount) : num(c.amount)));
const hzGuestName = (d: HzData, id: Val | undefined) => nameOf(d, "guests", id);
const tierFor = (pts: number) => (pts >= 5000 ? "Platinum" : pts >= 2000 ? "Gold" : pts >= 500 ? "Silver" : pts > 0 ? "Member" : "None");
const nextTier = (pts: number): { name: string; gap: number } | null =>
  pts < 500 ? { name: "Silver", gap: 500 - pts } : pts < 2000 ? { name: "Gold", gap: 2000 - pts } : pts < 5000 ? { name: "Platinum", gap: 5000 - pts } : null;
const stockState = (r: Row) => (num(r.qty) <= 0 ? "Out" : num(r.qty) <= num(r.reorder) ? "Low" : "In stock");
const roomCharges = (d: HzData, from: string, to: string) => rows(d, "charges").filter((c) => c.dept === "Room" && c.kind === "Charge" && String(c.date) >= from && String(c.date) <= to);

/* best room for a reservation: inspected first, VIPs get the higher floor */
const autoRoom = (d: HzData, r: Row): string | null => {
  const vip = rows(d, "guests").find((g) => g.id === r.guest)?.vip === "Yes";
  const pool = rows(d, "rooms")
    .filter((x) => x.type === r.roomType && x.state !== "Out of order" && roomFree(d, x.id, String(r.arrive), String(r.depart), r.id) && (String(r.arrive) > off(0) || !isOccupied(d, x.id)))
    .sort((a, b) => {
      const sa = (a.state === "Inspected" ? 0 : a.state === "Clean" ? 1 : 2) - (b.state === "Inspected" ? 0 : b.state === "Clean" ? 1 : 2);
      return sa || (vip ? num(b.floor) - num(a.floor) : num(a.floor) - num(b.floor)) || a.id.localeCompare(b.id);
    });
  return pool[0]?.id ?? null;
};

/* ---------- intelligence (local rules) ---------- */
interface Suggest { date: string; occ: number; adj: number; why: string }
const priceAdvice = (d: HzData, days = 14): Suggest[] => {
  const out: Suggest[] = [];
  for (let i = 0; i < days; i++) {
    const date = off(i);
    const occ = occOn(d, date);
    const weekend = ["Fri", "Sat"].includes(dow(date));
    let adj = occ >= 90 ? 20 : occ >= 80 ? 12 : occ >= 65 ? 6 : occ <= 20 ? -15 : occ <= 35 ? -10 : 0;
    if (weekend && occ >= 50 && adj < 15) adj += 5;
    const why = occ >= 80 ? `Demand is high (${occ}% booked), protect rate` : occ >= 65 ? `Filling well (${occ}%)` : occ <= 35 ? `Soft demand (${occ}%), stimulate bookings` : weekend ? "Weekend uplift" : `Normal demand (${occ}%)`;
    out.push({ date, occ, adj, why });
  }
  return out;
};
const rateAdj = (d: HzData, date: string) => num(rows(d, "pricing").find((p) => p.id === date)?.adj);
const reorderList = (d: HzData): { item: Row; qty: number; cost: number }[] =>
  rows(d, "stock")
    .filter((s) => num(s.qty) <= num(s.reorder) && !rows(d, "orders").some((o) => o.item === s.id && ["Draft", "Ordered"].includes(String(o.status))))
    .map((s) => ({ item: s, qty: Math.max(num(s.par) - num(s.qty), 1), cost: Math.max(num(s.par) - num(s.qty), 1) * num(s.cost) }));

const guestSummary = (d: HzData, g: Row): string => {
  const stays = rows(d, "reservations").filter((r) => r.guest === g.id);
  const done = stays.filter((r) => r.status === "Checked out");
  const nextStay = stays.filter((r) => ["Confirmed", "Pending"].includes(String(r.status))).sort((a, b) => String(a.arrive).localeCompare(String(b.arrive)))[0];
  const spend = sum(rows(d, "charges").filter((c) => stays.some((s) => s.id === c.res) && c.kind === "Charge"), (c) => num(c.amount));
  const fb = rows(d, "feedback").filter((f) => f.guest === g.id);
  const open = rows(d, "complaints").filter((c) => c.guest === g.id && c.status !== "Resolved");
  const lines = [
    `${g.name} is ${g.vip === "Yes" ? "a VIP" : "a"} ${String(g.tier).toLowerCase() === "none" ? "non-member" : String(g.tier) + " member"} guest from ${g.nationality}.`,
    `${done.length} completed stay${done.length === 1 ? "" : "s"}, ${money(spend)} total spend${fb.length ? `, average rating ${(sum(fb, (f) => num(f.rating)) / fb.length).toFixed(1)}/5` : ""}.`,
    nextStay ? `Next stay ${fdate(String(nextStay.arrive))} for ${nightsOf(nextStay)} night${nightsOf(nextStay) === 1 ? "" : "s"}.` : "No upcoming stay.",
    g.prefs ? `Preferences: ${g.prefs}.` : "",
    open.length ? `${open.length} open complaint${open.length === 1 ? "" : "s"}, resolve before arrival.` : "",
    g.status === "Blacklisted" ? "Flagged: do not accept new bookings." : "",
  ];
  return lines.filter(Boolean).join(" ");
};
const draftMessage = (kind: "welcome" | "apology" | "review" | "thanks", name: string, extra: string): Draft => {
  const first = name.split(" ")[0] ?? name;
  if (kind === "apology")
    return { title: `Apology to ${name}`, guest: name, body: `Dear ${first},\n\nThank you for telling us about ${extra || "your experience"}. That is not the standard we hold ourselves to, and I am sorry. The duty manager has looked into it and we would like to make it right during your stay or on your next visit.\n\nPlease reply to this message or call the front desk and we will arrange it personally.\n\nWarm regards,\nGuest Relations` };
  if (kind === "review")
    return { title: `Reply to ${name}'s review`, guest: name, body: `Dear ${first},\n\nThank you for taking the time to share your feedback${extra ? ` about ${extra}` : ""}. We read every review and have passed your comments to the team responsible. We hope to welcome you back soon.\n\nGuest Relations` };
  if (kind === "thanks")
    return { title: `Thank you, ${name}`, guest: name, body: `Dear ${first},\n\nThank you for staying with us${extra ? ` (${extra})` : ""}. We hope you had a comfortable stay and would be glad to host you again. Loyalty members earn points on every night.\n\nGuest Relations` };
  return { title: `Welcome message for ${name}`, guest: name, body: `Dear ${first},\n\nWe look forward to welcoming you${extra ? ` on ${extra}` : ""}. Your room will be ready from 2:00 PM and early check-in can be arranged on request. Let us know about airport pickup, dietary needs or anything else that would make your stay easier.\n\nSee you soon,\nFront Desk` };
};

const hzInsights = (d: HzData): string[] => {
  const out: string[] = [];
  const today = off(0);
  const arr = rows(d, "reservations").filter((r) => r.status === "Confirmed" && r.arrive === today);
  const noRoom = arr.filter((r) => !r.room);
  if (arr.length) out.push(`${arr.length} arrival${arr.length === 1 ? "" : "s"} today${noRoom.length ? `, ${noRoom.length} still without a room` : ", all with rooms assigned"}.`);
  const dirty = rows(d, "rooms").filter((x) => x.state === "Dirty" && !isOccupied(d, x.id));
  if (dirty.length) out.push(`${dirty.length} vacant room${dirty.length === 1 ? " is" : "s are"} dirty. Clean ${arr.length} first for today's arrivals.`);
  const late = rows(d, "reservations").filter((r) => r.status === "Checked in" && String(r.depart) < today);
  if (late.length) out.push(`${late.length} guest${late.length === 1 ? " is" : "s are"} past their departure date.`);
  const owing = rows(d, "reservations").filter((r) => r.status === "Checked in" && String(r.depart) <= today && balanceOf(d, r.id) > 0);
  if (owing.length) out.push(`${owing.length} departing guest${owing.length === 1 ? " has" : "s have"} an unsettled folio (${money(sum(owing, (r) => balanceOf(d, r.id)))}).`);
  const peak = priceAdvice(d).filter((s) => s.adj >= 12);
  if (peak.length) out.push(`Demand is strong on ${peak.slice(0, 3).map((s) => fshort(s.date)).join(", ")}. Review rates in Revenue AI.`);
  const low = reorderList(d);
  if (low.length) out.push(`${low.length} stock item${low.length === 1 ? " is" : "s are"} below reorder level.`);
  const neg = rows(d, "feedback").filter((f) => num(f.rating) <= 2 && f.status === "Open");
  if (neg.length) out.push(`${neg.length} negative review${neg.length === 1 ? "" : "s"} awaiting a reply.`);
  const ooo = rows(d, "rooms").filter((x) => x.state === "Out of order");
  if (ooo.length) out.push(`${ooo.length} room${ooo.length === 1 ? " is" : "s are"} out of order (${ooo.map((x) => x.id).join(", ")}).`);
  const out2 = rows(d, "waitlist").filter((w) => w.status === "Waiting" && availOn(d, String(w.roomType), String(w.arrive)) > 0);
  if (out2.length) out.push(`${out2.length} waitlisted guest${out2.length === 1 ? " now has" : "s now have"} availability.`);
  return out.length ? out : ["Nothing needs attention right now."];
};

const kpis = (d: HzData, days = 7) => {
  const from = off(-days + 1);
  const rc = roomCharges(d, from, off(0));
  const rev = sum(rc, (c) => num(c.amount));
  const sold = rc.length;
  const avail = inService(d) * days;
  const total = sum(rows(d, "charges").filter((c) => c.kind === "Charge" && String(c.date) >= from && String(c.date) <= off(0)), (c) => num(c.amount));
  return { rev, sold, adr: sold ? rev / sold : 0, revpar: avail ? rev / avail : 0, occ: pct(sold, avail), total };
};

const hzAsk = (q: string, d: HzData): string => {
  const t = q.toLowerCase();
  const today = off(0);
  const has = (...w: string[]) => w.some((x) => t.includes(x));
  const guest = rows(d, "guests").find((g) => t.includes(String(g.name).toLowerCase()) || t.includes(String(g.name).toLowerCase().split(" ")[0] ?? "#"));
  if (guest && has("draft", "write", "message", "email", "welcome")) {
    const next = rows(d, "reservations").find((r) => r.guest === guest.id && r.status === "Confirmed");
    const m = draftMessage("welcome", String(guest.name), next ? fdate(String(next.arrive)) : "");
    return `${m.title}\n\n${m.body}`;
  }
  if (guest) return guestSummary(d, guest);
  if (has("focus", "today", "priorit", "brief", "attention")) return ["Today's briefing:", ...hzInsights(d).map((s, i) => `${i + 1}. ${s}`)].join("\n");
  if (has("arriv", "check-in", "check in")) {
    const a = rows(d, "reservations").filter((r) => r.status === "Confirmed" && String(r.arrive) <= today);
    return a.length ? `${a.length} arrival${a.length === 1 ? "" : "s"} due:\n${a.map((r) => `• ${hzGuestName(d, r.guest)}, ${nameOf(d, "roomtypes", r.roomType)}${r.room ? `, room ${r.room}` : ", no room yet"}`).join("\n")}` : "No arrivals are waiting to check in.";
  }
  if (has("depart", "check-out", "checkout", "check out")) {
    const a = rows(d, "reservations").filter((r) => r.status === "Checked in" && String(r.depart) <= today);
    return a.length ? `${a.length} departure${a.length === 1 ? "" : "s"} due:\n${a.map((r) => `• ${hzGuestName(d, r.guest)}, room ${r.room}, balance ${money(balanceOf(d, r.id))}`).join("\n")}` : "No departures are due.";
  }
  if (has("in-house", "in house", "staying")) {
    const a = rows(d, "reservations").filter((r) => r.status === "Checked in");
    return `${a.length} guest${a.length === 1 ? " is" : "s are"} in house:\n${a.slice(0, 10).map((r) => `• ${hzGuestName(d, r.guest)}, room ${r.room}, until ${fshort(String(r.depart))}`).join("\n")}`;
  }
  if (has("occup", "available", "availability", "vacan")) {
    const lines = rows(d, "roomtypes").map((rt) => `• ${rt.name}: ${availOn(d, rt.id, today)} free tonight, ${availOn(d, rt.id, off(1))} tomorrow`);
    return `Occupancy tonight is ${occOn(d, today)}% (${booked(d, today)} of ${inService(d)} rooms).\n${lines.join("\n")}`;
  }
  if (has("housekeep", "dirty", "clean")) {
    const dirty = rows(d, "rooms").filter((x) => x.state === "Dirty");
    const insp = rows(d, "rooms").filter((x) => x.state === "Clean");
    return `${dirty.length} room${dirty.length === 1 ? "" : "s"} to clean${dirty.length ? ` (${dirty.map((x) => x.id).join(", ")})` : ""}. ${insp.length} clean and awaiting inspection.`;
  }
  if (has("maint", "repair", "out of order", "broken")) {
    const w = rows(d, "workorders").filter((x) => x.status !== "Completed");
    return w.length ? `${w.length} open work order${w.length === 1 ? "" : "s"}:\n${w.map((x) => `• Room ${x.room}: ${x.issue} (${x.priority})`).join("\n")}` : "No open work orders.";
  }
  if (has("revenue", "adr", "revpar", "sales", "income", "performance")) {
    const k = kpis(d, 7);
    return `Last 7 days: room revenue ${money(k.rev)}, ADR ${money(k.adr)}, RevPAR ${money(k.revpar)}, occupancy ${k.occ}%. Total revenue including extras ${money(k.total)}.`;
  }
  if (has("rate", "price", "pricing", "demand")) {
    const s = priceAdvice(d).filter((x) => x.adj !== 0).slice(0, 6);
    return s.length ? `Suggested rate changes:\n${s.map((x) => `• ${dow(x.date)} ${fshort(x.date)}: ${x.adj > 0 ? "+" : ""}${x.adj}% (${x.why})`).join("\n")}` : "Rates look right for the next two weeks.";
  }
  if (has("stock", "inventory", "reorder", "supplies", "low")) {
    const l = reorderList(d);
    return l.length ? `${l.length} item${l.length === 1 ? "" : "s"} to reorder:\n${l.map((x) => `• ${x.item.name}: ${x.item.qty} left, order ${x.qty} ${x.item.unit} (${money(x.cost)})`).join("\n")}` : "Everything is above its reorder level.";
  }
  if (has("complain", "feedback", "review", "rating", "sentiment")) {
    const f = rows(d, "feedback");
    const avg = f.length ? sum(f, (x) => num(x.rating)) / f.length : 0;
    const neg = f.filter((x) => num(x.rating) <= 2);
    const c = rows(d, "complaints").filter((x) => x.status !== "Resolved");
    return `Average rating ${avg.toFixed(1)}/5 from ${f.length} reviews. ${neg.length} negative. ${c.length} complaint${c.length === 1 ? " is" : "s are"} still open.`;
  }
  if (has("vip", "loyal")) {
    const v = rows(d, "guests").filter((g) => g.vip === "Yes");
    return `${v.length} VIP guest${v.length === 1 ? "" : "s"}: ${v.map((g) => g.name).join(", ")}.`;
  }
  if (has("channel", "ota", "booking.com", "expedia")) {
    const c = rows(d, "channels");
    return c.map((x) => `• ${x.name}: ${x.status}, ${x.parity}, ${x.commission}% commission`).join("\n");
  }
  return "I can help with arrivals, departures, availability, housekeeping, maintenance, revenue, rates, stock, guest feedback and individual guests. Try one of the suggestions.";
};

/* ---------- engine ---------- */
const audit = (d: HzData, entTitle: string, rec: string, action: string, detail: string): HzData => ({
  ...d,
  audit: [R(`AU-${String(rows(d, "audit").length + 1).padStart(4, "0")}`, { when: new Date().toLocaleString("en-GB"), user: "You", entity: entTitle, record: rec, action, detail }), ...rows(d, "audit")],
});
const apply = (d: HzData, src: string, id: string, res: Res): HzData => {
  const next: HzData = { ...d };
  next[src] = rows(d, src).map((r) => (r.id === id ? ({ ...r, ...(res.patch ?? {}) } as Row) : r));
  (res.other ?? []).forEach((o) => {
    next[o.ent] = rows(next, o.ent).map((r) => (r.id === o.id ? ({ ...r, ...o.patch } as Row) : r));
  });
  (res.creates ?? []).forEach((c) => {
    const list = rows(next, c.ent);
    next[c.ent] = [...list, { ...c.values, id: c.id ?? nextId(PFX[c.ent] ?? "", list) } as Row];
  });
  return next;
};
const setStatus = (label: string, icon: React.ReactNode, from: string[], to: string, msg: (r: Row) => string): Act => ({
  label,
  icon,
  show: (r) => from.includes(String(r.status)),
  run: (r) => ({ patch: { status: to }, msg: msg(r) }),
});
const toggleActs = (nameKey: string): Act[] => [
  setStatus("Deactivate", <HzDismiss20Regular />, ["Active"], "Inactive", (r) => `${String(r[nameKey])} deactivated`),
  setStatus("Activate", <HzCheckmark20Regular />, ["Inactive"], "Active", (r) => `${String(r[nameKey])} activated`),
];

/* ---------- form dialog ---------- */
const RecordDialog: React.FC<{ title: string; submit: string; fields: Fld[]; data: HzData; initial: Record<string, Val>; onClose: () => void; onSave: (v: Record<string, Val>) => string | null; extra?: (v: Record<string, string>) => React.ReactNode }> = ({ title, submit, fields, data, initial, onClose, onSave, extra }) => {
  const [v, setV] = useState<Record<string, string>>(() => {
    const o: Record<string, string> = {};
    fields.forEach((f) => {
      const cur = initial[f.key];
      o[f.key] = cur !== undefined ? String(cur) : f.kind === "date" ? off(0) : "";
    });
    return o;
  });
  const [err, setErr] = useState<string | null>(null);
  const go = () => {
    const missing = fields.find((f) => f.required && !(v[f.key] ?? "").trim());
    if (missing) return setErr(`${missing.label} is required.`);
    const out: Record<string, Val> = {};
    fields.forEach((f) => {
      const raw = (v[f.key] ?? "").trim();
      out[f.key] = f.kind === "number" ? Number(raw) || 0 : raw;
    });
    const bad = onSave(out);
    if (bad) setErr(bad);
  };
  return (
    <HzDialog open onOpenChange={(_, dd) => !dd.open && onClose()}>
      <HzDialogSurface className={styles.hzDialog}>
        <HzDialogBody>
          <HzDialogTitle action={<HzDialogTrigger action="close"><HzButton size="small" appearance="subtle" aria-label="Close" icon={<HzDismiss24Regular />} /></HzDialogTrigger>}>{title}</HzDialogTitle>
          <HzDialogContent>
            <div className={styles.hzForm}>
              {fields.map((f) => {
                const options = typeof f.options === "function" ? f.options(data) : f.options ?? [];
                return (
                  <div key={f.key} className={f.full ? styles.hzFormFull : undefined}>
                    <HzField label={f.label} required={!!f.required}>
                      {f.kind === "select" ? (
                        <HzSelect value={v[f.key] ?? ""} onChange={(_, dd) => setV({ ...v, [f.key]: dd.value })}>
                          <option value="">Select…</option>
                          {options.map((o) => <option key={o.v} value={o.v}>{o.l}</option>)}
                        </HzSelect>
                      ) : (
                        <HzInput type={f.kind === "number" ? "number" : f.kind === "date" ? "date" : "text"} value={v[f.key] ?? ""} onChange={(_, dd) => setV({ ...v, [f.key]: dd.value })} />
                      )}
                    </HzField>
                  </div>
                );
              })}
            </div>
            {extra ? extra(v) : null}
            {err && <div className={styles.hzErr} role="alert">{err}</div>}
          </HzDialogContent>
          <HzDialogActions>
            <HzDialogTrigger action="close"><HzButton size="small">Cancel</HzButton></HzDialogTrigger>
            <HzButton size="small" className={styles.hzPrimary} appearance="primary" onClick={go}>{submit}</HzButton>
          </HzDialogActions>
        </HzDialogBody>
      </HzDialogSurface>
    </HzDialog>
  );
};

const val = (c: Col, r: Row, d: HzData): Val => (c.get ? c.get(r, d) : r[c.key] ?? "");
const hzShow = (c: Col, v: Val): string => {
  switch (c.kind) {
    case "money": return money(num(v));
    case "date": return v ? fdate(String(v)) : "";
    case "pct": case "bar": return `${num(v)}%`;
    case "num": return num(v).toLocaleString("en-NG");
    default: return String(v);
  }
};
const Tiles: React.FC<{ tiles: Tile[] }> = ({ tiles }) => (
  <div className={styles.hzTiles}>
    {tiles.map((t) => (
      <div key={t.label} className={styles.hzTile}>
        <span className={styles.hzTileLabel}>{t.label}</span>
        <span className={styles.hzTileValue}>{t.value}</span>
        {t.note ? <span className={styles.hzTileNote}>{t.note}</span> : null}
      </div>
    ))}
  </div>
);
const UseBar: React.FC<{ pct: number; good?: boolean }> = ({ pct }) => (
  <span className={styles.hzUse}>
    <span className={styles.hzUseTrack}><span className={`${styles.hzUseFill} ${pct >= 70 ? styles.hzUseHigh : pct >= 40 ? styles.hzUseMid : ""}`} style={{ width: `${Math.min(pct, 100)}%` }} /></span>
    <span>{pct}</span>
  </span>
);

const EntityPage: React.FC<PageProps & { ent: Entity }> = ({ ent, data, setData, say }) => {
  const [q, setQ] = useState("");
  const [filterV, setFilterV] = useState("All");
  const [sort, setSort] = useState<{ key: string; dir: 1 | -1 } | null>(null);
  const [selId, setSelId] = useState<string | null>(null);
  const [form, setForm] = useState<"new" | "edit" | null>(null);
  const [prompt, setPrompt] = useState<Act | null>(null);
  const [draft, setDraft] = useState<Draft | null>(null);
  const [confirmDel, setConfirmDel] = useState(false);

  const list = rows(data, ent.src).filter((r) => (ent.where ? ent.where(r, data) : true));
  const filterCol = ent.cols.find((c) => c.key === ent.filterKey) ?? ent.cols.find((c) => c.kind === "status");
  const choices = filterCol ? Array.from(new Set(list.map((r) => String(val(filterCol, r, data))))).filter(Boolean).sort() : [];
  const view = useMemo(() => {
    const needle = q.trim().toLowerCase();
    let out = list.filter((r) => {
      if (filterCol && filterV !== "All" && String(val(filterCol, r, data)) !== filterV) return false;
      return !needle || ent.cols.some((c) => hzShow(c, val(c, r, data)).toLowerCase().includes(needle));
    });
    if (sort) {
      const col = ent.cols.find((c) => c.key === sort.key);
      if (col) {
        const dir = sort.dir;
        out = [...out].sort((a, b) => {
          const x = val(col, a, data);
          const y = val(col, b, data);
          return (typeof x === "number" && typeof y === "number" ? x - y : String(x).localeCompare(String(y))) * dir;
        });
      }
    }
    return out;
  }, [list, q, filterV, sort, ent, filterCol, data]);

  const sel = list.find((r) => r.id === selId) ?? null;
  const canChange = !ent.readOnly && !!sel;
  const tiles = ent.summary ? ent.summary(list, data) : null;

  const runAct = (a: Act, values: Record<string, Val>): string | null => {
    if (!sel) return null;
    const res = a.run(sel, data, values);
    if (res.err) return res.err;
    if (res.draft) {
      setDraft(res.draft);
      return null;
    }
    setData((d) => audit(apply(d, ent.src, sel.id, res), ent.title, sel.id, a.label, res.msg));
    say(res.msg);
    return null;
  };
  const save = (values: Record<string, Val>): string | null => {
    const bad = ent.validate ? ent.validate(values, data, form === "edit" ? sel : null) : null;
    if (bad) return bad;
    if (form === "edit" && sel) {
      setData((d) => audit({ ...d, [ent.src]: rows(d, ent.src).map((r) => (r.id === sel.id ? ({ ...r, ...values } as Row) : r)) }, ent.title, sel.id, "Edited", "Record changed"));
      say(`${cap(ent.noun)} ${sel.id} saved`);
    } else {
      const id = ent.idField ? String(values[ent.idField] ?? "").trim() : nextId(ent.prefix ?? "", list);
      if (ent.idField && rows(data, ent.src).some((r) => r.id === id)) return `${cap(ent.noun)} ${id} already exists.`;
      const row: Row = { ...values, ...(ent.initial ?? {}), id };
      setData((d) => audit({ ...d, [ent.src]: [...rows(d, ent.src), row] }, ent.title, id, "Created", `${id} created`));
      setSelId(id);
      say(`${id} created`);
    }
    setForm(null);
    return null;
  };
  const tryDelete = () => {
    if (!sel) return;
    const why = ent.canDelete ? ent.canDelete(sel, data) : null;
    if (why) return say(why, true);
    setConfirmDel(true);
  };
  const remove = () => {
    if (!sel) return;
    setData((d) => audit({ ...d, [ent.src]: rows(d, ent.src).filter((r) => r.id !== sel.id) }, ent.title, sel.id, "Deleted", `${sel.id} deleted`));
    say(`${sel.id} deleted`);
    setSelId(null);
    setConfirmDel(false);
  };
  const exportCsv = () => {
    const esc = (s: string) => `"${s.replace(/"/g, '""')}"`;
    const lines = [ent.cols.map((c) => esc(c.label)).join(",")].concat(view.map((r) => ent.cols.map((c) => esc(hzShow(c, val(c, r, data)))).join(",")));
    const url = URL.createObjectURL(new Blob([lines.join("\n")], { type: "text/csv" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = `${ent.id.toLowerCase().replace(/\s+/g, "-")}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };
  const sortBy = (key: string) => setSort((s) => (s && s.key === key ? (s.dir === 1 ? { key, dir: -1 } : null) : { key, dir: 1 }));

  const copyDraft = async () => {
    try {
      await navigator.clipboard.writeText(draft?.body ?? "");
      say("Draft copied");
    } catch {
      say("Copy isn't available in this browser", true);
    }
  };
  const logDraft = () => {
    if (!draft) return;
    const g = rows(data, "guests").find((x) => x.name === draft.guest);
    setData((d) => audit({ ...d, messages: [...rows(d, "messages"), R(nextId("MS-", rows(d, "messages")), { guest: g?.id ?? "", subject: draft.title, channel: "Email", date: off(0), by: "You" })] }, "Guest messages", "—", "Message logged", draft.title));
    say("Message logged as sent");
    setDraft(null);
  };

  return (
    <>
      {tiles && <Tiles tiles={tiles} />}
      <div className={styles.hzCard}>
        <div className={styles.hzPane} role="toolbar" aria-label="Actions">
          {!ent.readOnly && (
            <>
              <HzButton size="small" className={styles.hzPrimary} appearance="primary" icon={<HzAdd20Regular />} onClick={() => setForm("new")}>New</HzButton>
              <HzButton size="small" appearance="subtle" icon={<HzEdit20Regular />} disabled={!canChange} onClick={() => setForm("edit")}>Edit</HzButton>
              {!ent.noDelete && <HzButton size="small" appearance="subtle" icon={<HzDelete20Regular />} disabled={!canChange} onClick={tryDelete}>Delete</HzButton>}
            </>
          )}
          {!ent.readOnly && ent.acts.length > 0 && <span className={styles.hzSep} />}
          {ent.acts.map((a) => (
            <HzButton key={a.label} size="small" appearance="subtle" icon={a.icon as React.ReactElement} disabled={!sel || !a.show(sel, data)} onClick={() => { if (a.prompt) setPrompt(a); else { const bad = runAct(a, {}); if (bad) say(bad, true); } }}>{a.label}</HzButton>
          ))}
          <span className={styles.hzGrow} />
          <HzButton size="small" appearance="subtle" icon={<HzArrowDownload20Regular />} onClick={exportCsv}>Export</HzButton>
        </div>
        <div className={styles.hzFilters}>
          <HzSearchBox className={styles.hzSearch} placeholder={`Search ${ent.title.toLowerCase()}`} value={q} onChange={(_, dd) => setQ(dd.value)} />
          {filterCol && (
            <HzSelect size="small" className={styles.hzSel} value={filterV} onChange={(_, dd) => setFilterV(dd.value)} aria-label="Filter">
              <option value="All">{ent.filterLabel ?? "All statuses"}</option>
              {choices.map((s) => <option key={s}>{s}</option>)}
            </HzSelect>
          )}
        </div>
        <div className={styles.hzWork}>
          <div className={styles.hzGridWrap}>
            <table className={styles.hzGrid}>
              <thead>
                <tr>
                  {ent.cols.map((c) => (
                    <th key={c.key} className={c.right ? styles.hzRight : undefined} aria-sort={sort?.key === c.key ? (sort.dir === 1 ? "ascending" : "descending") : "none"}>
                      <button type="button" className={styles.hzTh} onClick={() => sortBy(c.key)}>
                        {c.label}
                        {sort?.key === c.key && (sort.dir === 1 ? <HzChevronUp12Regular /> : <HzChevronDown12Regular />)}
                      </button>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {view.map((r) => (
                  <tr key={r.id} className={r.id === selId ? styles.hzRowSel : undefined} aria-selected={r.id === selId} tabIndex={0} onClick={() => setSelId(r.id)} onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && (e.preventDefault(), setSelId(r.id))}>
                    {ent.cols.map((c) => {
                      const v = val(c, r, data);
                      return (
                        <td key={c.key} className={`${c.right ? styles.hzRight : ""} ${c.kind === "mono" ? styles.hzMono : ""}`}>
                          {c.kind === "status" ? (v ? <Pill text={String(v)} /> : null) : c.kind === "bar" ? <UseBar pct={num(v)} /> : hzShow(c, v)}
                        </td>
                      );
                    })}
                  </tr>
                ))}
                {view.length === 0 && <tr><td colSpan={ent.cols.length} className={styles.hzEmpty}>Nothing here yet.</td></tr>}
              </tbody>
            </table>
          </div>
          {sel && (
            <aside className={styles.hzDetail} aria-label="Details">
              <div className={styles.hzDetailHead}>
                <strong>{sel.id}</strong>
                <HzButton size="small" appearance="subtle" icon={<HzDismiss20Regular />} aria-label="Close details" onClick={() => setSelId(null)} />
              </div>
              <dl className={styles.hzDl}>
                {ent.cols.filter((c) => c.key !== "id").map((c) => {
                  const v = val(c, sel, data);
                  return (
                    <div key={c.key} className={styles.hzDlRow}>
                      <dt>{c.label}</dt>
                      <dd>{c.kind === "status" ? (v ? <Pill text={String(v)} /> : "—") : c.kind === "bar" ? <UseBar pct={num(v)} /> : hzShow(c, v)}</dd>
                    </div>
                  );
                })}
              </dl>
              {ent.detail && ent.detail(sel, data)}
            </aside>
          )}
        </div>
        <div className={styles.hzFoot}><span>{view.length} of {list.length} records</span></div>
      </div>

      {form && <RecordDialog key={`${form}${sel?.id ?? ""}`} title={form === "edit" ? `Edit ${ent.noun}` : `New ${ent.noun}`} submit={form === "edit" ? "Save" : "Create"} fields={ent.fields} data={data} initial={form === "edit" && sel ? (sel as Record<string, Val>) : {}} onClose={() => setForm(null)} onSave={save} />}
      {prompt && prompt.prompt && sel && (
        <RecordDialog key={prompt.label} title={prompt.prompt.title} submit={prompt.prompt.submit} fields={prompt.prompt.fields} data={data} initial={prompt.prompt.init(sel, data)} onClose={() => setPrompt(null)}
          onSave={(vals) => { const bad = runAct(prompt, vals); if (!bad) setPrompt(null); return bad; }} />
      )}
      <HzDialog open={!!draft} onOpenChange={(_, dd) => !dd.open && setDraft(null)}>
        <HzDialogSurface className={styles.hzDialog}>
          <HzDialogBody>
            <HzDialogTitle action={<HzDialogTrigger action="close"><HzButton size="small" appearance="subtle" aria-label="Close" icon={<HzDismiss24Regular />} /></HzDialogTrigger>}>
              <span className={styles.hzAiHead}><HzSparkle20Regular /> {draft?.title}</span>
            </HzDialogTitle>
            <HzDialogContent>
              <pre className={styles.hzDraft}>{draft?.body}</pre>
              <p className={styles.hzHint}>{draft?.note ? "Generated from the property data." : "AI-written draft. Review it before sending."}</p>
            </HzDialogContent>
            <HzDialogActions>
              <HzButton size="small" icon={<HzCopy20Regular />} onClick={copyDraft}>Copy</HzButton>
              {!draft?.note && <HzButton size="small" className={styles.hzPrimary} appearance="primary" onClick={logDraft}>Mark as sent</HzButton>}
            </HzDialogActions>
          </HzDialogBody>
        </HzDialogSurface>
      </HzDialog>
      <HzDialog open={confirmDel} onOpenChange={(_, dd) => !dd.open && setConfirmDel(false)}>
        <HzDialogSurface className={styles.hzDialogSm}>
          <HzDialogBody>
            <HzDialogTitle>Delete {ent.noun}?</HzDialogTitle>
            <HzDialogContent>{sel ? `${sel.id} will be removed. This can't be undone.` : ""}</HzDialogContent>
            <HzDialogActions>
              <HzDialogTrigger action="close"><HzButton size="small">Cancel</HzButton></HzDialogTrigger>
              <HzButton size="small" className={styles.hzDanger} appearance="primary" onClick={remove}>Delete</HzButton>
            </HzDialogActions>
          </HzDialogBody>
        </HzDialogSurface>
      </HzDialog>
    </>
  );
};


/* ---------- shared actions ---------- */
const FolioLines: React.FC<{ d: HzData; res: string }> = ({ d, res }) => {
  const list = charges(d, res);
  return (
    <div className={styles.hzMiniBox}>
      <h4 className={styles.hzMiniTitle}>Folio</h4>
      {list.length === 0 && <p className={styles.hzHint}>No charges posted yet.</p>}
      {list.map((c) => (
        <div key={c.id} className={styles.hzMiniRow}>
          <span>{fshort(String(c.date))} · {String(c.desc)}</span>
          <strong className={c.kind === "Payment" ? styles.hzCredit : undefined}>{c.kind === "Payment" ? "−" : ""}{money(num(c.amount))}</strong>
        </div>
      ))}
      <div className={`${styles.hzMiniRow} ${styles.hzMiniTotal}`}><span>Balance</span><strong>{money(balanceOf(d, res))}</strong></div>
    </div>
  );
};

const guestOpts = (d: HzData): Opt[] => rows(d, "guests").filter((g) => g.status === "Active").map((g) => ({ v: g.id, l: String(g.name) }));
const typeOpts = (d: HzData): Opt[] => rows(d, "roomtypes").filter((t) => t.status === "Active").map((t) => ({ v: t.id, l: String(t.name) }));
const planOpts = (d: HzData): Opt[] => rows(d, "rateplans").filter((p) => p.status === "Active").map((p) => ({ v: p.id, l: String(p.name) }));
const staffOpts = (dept: string) => (d: HzData): Opt[] => rows(d, "staff").filter((s) => s.dept === dept && s.status !== "On leave").map((s) => ({ v: String(s.name), l: String(s.name) }));
const SOURCES = opts("Direct", "Walk-in", "Corporate", "Travel agent", "Booking.com", "Expedia", "Airbnb", "Agoda");
const positive = (key: string, label: string) => (v: Record<string, Val>) => (num(v[key]) > 0 ? null : `${label} must be greater than zero.`);
const range = (a: string, b: string) => (b > a ? null : "Departure must be after arrival.");

/* every night of the stay must have a room of that type free */
const noRoomFor = (d: HzData, rt: string, a: string, b: string, skip?: Row | null): string | null => {
  for (let x = a; x < b; x = hzAddDays(x, 1)) {
    if (stopSold(d, rt, x)) return `${nameOf(d, "roomtypes", rt)} is closed for sale on ${fdate(x)}.`;
    const mine = skip && resActive(skip) && skip.roomType === rt && holds(skip, x) ? 1 : 0;
    if (availOn(d, rt, x) + mine <= 0) return `No ${nameOf(d, "roomtypes", rt)} available on ${fdate(x)}.`;
  }
  return null;
};

const hzCheckIn = (r: Row, d: HzData): Res => {
  const today = off(0);
  const g = rows(d, "guests").find((x) => x.id === r.guest);
  if (g?.status === "Blacklisted") return { msg: "", err: "This guest is blacklisted. Speak to the duty manager." };
  if (String(r.arrive) > today) return { msg: "", err: `Arrival is ${fdate(String(r.arrive))}. Early check-in isn't allowed from here.` };
  if (!r.room) return { msg: "", err: "Assign a room first." };
  const room = rows(d, "rooms").find((x) => x.id === r.room);
  if (!room || room.state === "Out of order") return { msg: "", err: `Room ${String(r.room)} is out of order.` };
  if (room.state === "Dirty") return { msg: "", err: `Room ${String(r.room)} hasn't been cleaned yet.` };
  if (isOccupied(d, String(r.room))) return { msg: "", err: `Room ${String(r.room)} is still occupied.` };
  return { patch: { status: "Checked in", arrive: String(r.arrive) > today ? today : String(r.arrive) }, msg: `${hzGuestName(d, r.guest)} checked in to room ${String(r.room)}` };
};
const hzCheckOut = (r: Row, d: HzData): Res => {
  const bal = balanceOf(d, r.id);
  if (bal > 0) return { msg: "", err: `Settle the folio first (${money(bal)} due).` };
  const g = rows(d, "guests").find((x) => x.id === r.guest);
  const earned = Math.floor(resTotal(r) / 1000);
  const other: NonNullable<Res["other"]> = [{ ent: "rooms", id: String(r.room), patch: { state: "Dirty" } }];
  if (g) other.push({ ent: "guests", id: g.id, patch: { points: num(g.points) + earned, tier: tierFor(num(g.points) + earned) } });
  const today = off(0);
  return { patch: { status: "Checked out", depart: String(r.depart) > today ? today : String(r.depart) }, other, msg: `${hzGuestName(d, r.guest)} checked out, room ${String(r.room)} now dirty, ${earned} points earned` };
};
const actCheckIn: Act = { label: "Check in", icon: <HzPersonArrowRight20Regular />, show: (r) => r.status === "Confirmed", run: (r, d) => hzCheckIn(r, d) };
const actCheckOut: Act = { label: "Check out", icon: <HzPersonArrowLeft20Regular />, show: (r) => r.status === "Checked in", run: (r, d) => hzCheckOut(r, d) };
const chargeFields = (dept: boolean): Fld[] => [
  ...(dept ? [{ key: "dept", label: "Department", kind: "select" as const, options: opts("Room", "F&B", "Laundry", "Spa", "Minibar", "Transport", "Other"), required: true }] : []),
  { key: "desc", label: "Description", kind: "text", required: true, full: true },
  { key: "amount", label: "Amount (₦)", kind: "number", required: true },
];
const actPostCharge: Act = {
  label: "Post charge",
  icon: <HzReceipt20Regular />,
  show: (r) => r.status === "Checked in",
  run: (r, _d, v) => (num(v.amount) <= 0 ? { msg: "", err: "Amount must be greater than zero." } : { creates: [{ ent: "charges", values: { res: r.id, desc: String(v.desc), dept: String(v.dept), kind: "Charge", amount: num(v.amount), date: off(0) } }], msg: `${money(num(v.amount))} posted to ${r.id}` }),
  prompt: { title: "Post charge", submit: "Post", fields: chargeFields(true), init: () => ({ dept: "F&B" }) },
};
const actPayment: Act = {
  label: "Record payment",
  icon: <HzMoney20Regular />,
  show: (r, d) => (r.status === "Checked in" || r.status === "Confirmed") && (r.status === "Confirmed" || balanceOf(d, r.id) > 0),
  run: (r, d, v) => {
    const amt = num(v.amount);
    if (amt <= 0) return { msg: "", err: "Amount must be greater than zero." };
    if (r.status === "Checked in" && amt > balanceOf(d, r.id)) return { msg: "", err: `That is more than the balance (${money(balanceOf(d, r.id))}).` };
    return { creates: [{ ent: "charges", values: { res: r.id, desc: `Payment (${String(v.method)})`, dept: "Payment", kind: "Payment", amount: amt, date: off(0) } }], msg: `${money(amt)} received for ${r.id}` };
  },
  prompt: { title: "Record payment", submit: "Receive", fields: [{ key: "method", label: "Method", kind: "select", options: opts("Cash", "Card", "Transfer", "Corporate bill"), required: true }, { key: "amount", label: "Amount (₦)", kind: "number", required: true }], init: (r, d) => ({ method: "Card", amount: Math.max(balanceOf(d, r.id), 0) }) },
};
const actSettle: Act = {
  label: "Settle in full",
  icon: <HzCheckmarkCircle20Regular />,
  show: (r, d) => r.status === "Checked in" && balanceOf(d, r.id) > 0,
  run: (r, d, v) => ({ creates: [{ ent: "charges", values: { res: r.id, desc: `Payment (${String(v.method)})`, dept: "Payment", kind: "Payment", amount: balanceOf(d, r.id), date: off(0) } }], msg: `${r.id} settled, ${money(balanceOf(d, r.id))} received` }),
  prompt: { title: "Settle folio", submit: "Settle", fields: [{ key: "method", label: "Method", kind: "select", options: opts("Cash", "Card", "Transfer", "Corporate bill"), required: true }], init: () => ({ method: "Card" }) },
};

const awardAct = (label: string, sign: 1 | -1): Act => ({
  label,
  icon: <HzStar20Regular />,
  show: (r) => (sign === 1 ? r.status === "Active" : num(r.points) > 0),
  run: (r, _d, v) => {
    const p = num(v.points);
    if (p <= 0) return { msg: "", err: "Points must be greater than zero." };
    if (sign === -1 && p > num(r.points)) return { msg: "", err: `${String(r.name)} only has ${num(r.points)} points.` };
    const total = num(r.points) + sign * p;
    return { patch: { points: total, tier: tierFor(total) }, msg: `${sign === 1 ? "Awarded" : "Redeemed"} ${p} points, ${String(r.name)} now ${tierFor(total)}` };
  },
  prompt: { title: label, submit: "Confirm", fields: [{ key: "points", label: "Points", kind: "number", required: true }], init: () => ({ points: 100 }) },
});

/* ---------- page definitions ---------- */
const ENTS: Entity[] = [
  {
    id: "Reservations", src: "reservations", title: "Reservations", subtitle: "Bookings from every source, from enquiry to check-out.", noun: "reservation", prefix: "RS-",
    initial: { status: "Pending", room: "", agent: "" },
    cols: [
      { key: "id", label: "Ref", kind: "mono" },
      { key: "guest", label: "Guest", get: (r, d) => hzGuestName(d, r.guest) },
      { key: "roomType", label: "Room type", get: (r, d) => nameOf(d, "roomtypes", r.roomType) },
      { key: "room", label: "Room" },
      { key: "arrive", label: "Arrive", kind: "date" },
      { key: "depart", label: "Depart", kind: "date" },
      { key: "nights", label: "Nights", kind: "num", right: true, get: (r) => nightsOf(r) },
      { key: "total", label: "Total", kind: "money", right: true, get: (r) => resTotal(r) },
      { key: "source", label: "Source" },
      { key: "status", label: "Status", kind: "status" },
    ],
    fields: [
      { key: "guest", label: "Guest", kind: "select", options: guestOpts, required: true },
      { key: "roomType", label: "Room type", kind: "select", options: typeOpts, required: true },
      { key: "arrive", label: "Arrival", kind: "date", required: true },
      { key: "depart", label: "Departure", kind: "date", required: true },
      { key: "adults", label: "Guests", kind: "number", required: true },
      { key: "plan", label: "Rate plan", kind: "select", options: planOpts, required: true },
      { key: "rate", label: "Nightly rate (₦)", kind: "number", required: true },
      { key: "source", label: "Source", kind: "select", options: SOURCES, required: true },
    ],
    validate: (v, d, ex) => {
      const bad = range(String(v.arrive), String(v.depart)) ?? positive("rate", "Rate")(v) ?? positive("adults", "Guests")(v);
      if (bad) return bad;
      if (ex && !["Pending", "Confirmed"].includes(String(ex.status))) return "Only pending or confirmed reservations can be edited.";
      if (rows(d, "guests").find((g) => g.id === v.guest)?.status === "Blacklisted") return "This guest is blacklisted.";
      const changed = !ex || ex.roomType !== v.roomType || ex.arrive !== v.arrive || ex.depart !== v.depart;
      if (changed) {
        const full = noRoomFor(d, String(v.roomType), String(v.arrive), String(v.depart), ex);
        if (full) return full;
      }
      if (ex?.room && changed && !roomFree(d, String(ex.room), String(v.arrive), String(v.depart), ex.id)) return `Room ${String(ex.room)} is taken on those dates. Clear the room first.`;
      return null;
    },
    canDelete: (r) => (r.status === "Pending" || r.status === "Cancelled" ? null : "Only pending or cancelled reservations can be deleted. Cancel it first."),
    filterKey: "status",
    summary: (list, d) => [
      { label: "Arrivals today", value: String(list.filter((r) => r.arrive === off(0) && ["Confirmed", "Pending"].includes(String(r.status))).length) },
      { label: "In house", value: String(list.filter((r) => r.status === "Checked in").length) },
      { label: "Departures today", value: String(list.filter((r) => r.status === "Checked in" && r.depart === off(0)).length) },
      { label: "Pending", value: String(list.filter((r) => r.status === "Pending").length), note: money(sum(list.filter((r) => r.status === "Pending"), resTotal)) },
      { label: "Occupancy tonight", value: `${occOn(d, off(0))}%` },
    ],
    acts: [
      setStatus("Confirm", <HzCheckmark20Regular />, ["Pending"], "Confirmed", (r) => `${r.id} confirmed`),
      {
        label: "Assign room", icon: <HzKey20Regular />, show: (r) => r.status === "Pending" || r.status === "Confirmed",
        run: (r, d, v) => {
          const room = String(v.room);
          if (!roomFree(d, room, String(r.arrive), String(r.depart), r.id)) return { msg: "", err: `Room ${room} is taken for those dates.` };
          return { patch: { room }, msg: `Room ${room} assigned to ${r.id}` };
        },
        prompt: {
          title: "Assign room", submit: "Assign",
          fields: [{ key: "room", label: "Room", kind: "select", required: true, options: (d) => rows(d, "rooms").filter((x) => x.state !== "Out of order").map((x) => ({ v: x.id, l: `${x.id} · ${nameOf(d, "roomtypes", x.type)} · ${String(x.state)}` })) }],
          init: (r) => ({ room: String(r.room ?? "") }),
        },
      },
      {
        label: "Auto-assign", icon: <HzSparkle20Regular />, show: (r) => (r.status === "Pending" || r.status === "Confirmed") && !r.room,
        run: (r, d) => {
          const room = autoRoom(d, r);
          return room ? { patch: { room }, msg: `Assistant picked room ${room} for ${hzGuestName(d, r.guest)}` } : { msg: "", err: `No ${nameOf(d, "roomtypes", r.roomType)} is free for those dates.` };
        },
      },
      actCheckIn,
      actCheckOut,
      {
        label: "Extend stay", icon: <HzCalendarClock20Regular />, show: (r) => r.status === "Checked in",
        run: (r, d, v) => {
          const to = String(v.depart);
          if (to <= String(r.depart)) return { msg: "", err: "New departure must be after the current one." };
          if (!roomFree(d, String(r.room), String(r.depart), to, r.id)) return { msg: "", err: `Room ${String(r.room)} is booked after ${fdate(String(r.depart))}.` };
          return { patch: { depart: to }, msg: `${r.id} extended to ${fdate(to)}` };
        },
        prompt: { title: "Extend stay", submit: "Extend", fields: [{ key: "depart", label: "New departure", kind: "date", required: true }], init: (r) => ({ depart: hzAddDays(String(r.depart), 1) }) },
      },
      actPayment,
      { label: "Welcome message", icon: <HzSend20Regular />, show: (r) => r.status === "Confirmed" || r.status === "Pending", run: (r, d) => ({ msg: "", draft: draftMessage("welcome", hzGuestName(d, r.guest), fdate(String(r.arrive))) }) },
      setStatus("No-show", <HzProhibited20Regular />, ["Confirmed"], "No-show", (r) => `${r.id} marked no-show`),
      { label: "Cancel", icon: <HzDismiss20Regular />, show: (r) => r.status === "Pending" || r.status === "Confirmed", run: (r) => ({ patch: { status: "Cancelled", room: "" }, msg: `${r.id} cancelled` }) },
    ],
    detail: (r, d) => (
      <>
        <dl className={styles.hzDl}>
          <div className={styles.hzDlRow}><dt>Rate plan</dt><dd>{nameOf(d, "rateplans", r.plan)}</dd></div>
          <div className={styles.hzDlRow}><dt>Guests</dt><dd>{num(r.adults)}</dd></div>
          <div className={styles.hzDlRow}><dt>Nightly rate</dt><dd>{money(num(r.rate))}</dd></div>
        </dl>
        <FolioLines d={d} res={r.id} />
      </>
    ),
  },
  {
    id: "Group blocks", src: "groups", title: "Group blocks", subtitle: "Room blocks for events, tours and delegations.", noun: "group block", prefix: "GB-",
    initial: { status: "Tentative", pickup: 0 },
    cols: [
      { key: "id", label: "Ref", kind: "mono" }, { key: "name", label: "Group" }, { key: "organizer", label: "Organiser" },
      { key: "arrive", label: "Arrive", kind: "date" }, { key: "depart", label: "Depart", kind: "date" },
      { key: "blocked", label: "Rooms", kind: "num", right: true }, { key: "pickup", label: "Picked up", kind: "num", right: true },
      { key: "use", label: "Pick-up", kind: "bar", get: (r) => pct(num(r.pickup), num(r.blocked)) },
      { key: "cutoff", label: "Cut-off", kind: "date" }, { key: "status", label: "Status", kind: "status" },
    ],
    fields: [
      { key: "name", label: "Group name", kind: "text", required: true }, { key: "organizer", label: "Organiser", kind: "text", required: true },
      { key: "arrive", label: "Arrival", kind: "date", required: true }, { key: "depart", label: "Departure", kind: "date", required: true },
      { key: "blocked", label: "Rooms blocked", kind: "number", required: true }, { key: "rate", label: "Group rate (₦)", kind: "number", required: true },
      { key: "cutoff", label: "Release date", kind: "date", required: true },
    ],
    validate: (v) => range(String(v.arrive), String(v.depart)) ?? positive("blocked", "Rooms")(v) ?? positive("rate", "Rate")(v) ?? (String(v.cutoff) > String(v.arrive) ? "Release date must be on or before arrival." : null),
    canDelete: (r) => (r.status === "Tentative" || r.status === "Cancelled" ? null : "Only tentative or cancelled blocks can be deleted."),
    filterKey: "status",
    summary: (list) => [
      { label: "Active blocks", value: String(list.filter((r) => ["Tentative", "Definite"].includes(String(r.status))).length) },
      { label: "Rooms blocked", value: String(sum(list.filter((r) => ["Tentative", "Definite"].includes(String(r.status))), (r) => num(r.blocked))) },
      { label: "Rooms picked up", value: String(sum(list.filter((r) => r.status === "Definite"), (r) => num(r.pickup))) },
      { label: "Block value", value: compact(sum(list.filter((r) => r.status === "Definite"), (r) => num(r.blocked) * num(r.rate) * Math.max(daysBetween(String(r.arrive), String(r.depart)), 1))) },
    ],
    acts: [
      setStatus("Confirm", <HzCheckmark20Regular />, ["Tentative"], "Definite", (r) => `${String(r.name)} confirmed as definite`),
      {
        label: "Add pick-up", icon: <HzAdd20Regular />, show: (r) => ["Tentative", "Definite"].includes(String(r.status)),
        run: (r, _d, v) => {
          const n = num(v.rooms);
          if (n <= 0) return { msg: "", err: "Enter at least one room." };
          if (num(r.pickup) + n > num(r.blocked)) return { msg: "", err: `Only ${num(r.blocked) - num(r.pickup)} rooms are left in this block.` };
          return { patch: { pickup: num(r.pickup) + n }, msg: `${n} room${n === 1 ? "" : "s"} picked up for ${String(r.name)}` };
        },
        prompt: { title: "Add pick-up", submit: "Add", fields: [{ key: "rooms", label: "Rooms picked up", kind: "number", required: true }], init: () => ({ rooms: 1 }) },
      },
      { label: "Release unused", icon: <HzArrowUndo20Regular />, show: (r) => ["Tentative", "Definite"].includes(String(r.status)) && num(r.pickup) < num(r.blocked), run: (r) => ({ patch: { blocked: num(r.pickup) }, msg: `${num(r.blocked) - num(r.pickup)} unused rooms released` }) },
      setStatus("Cancel", <HzDismiss20Regular />, ["Tentative", "Definite"], "Cancelled", (r) => `${String(r.name)} cancelled`),
    ],
  },
  {
    id: "Waitlist", src: "waitlist", title: "Waitlist", subtitle: "Guests waiting for a room to open up.", noun: "waitlist request", prefix: "WL-",
    initial: { status: "Waiting" },
    cols: [
      { key: "id", label: "Ref", kind: "mono" }, { key: "name", label: "Guest" }, { key: "phone", label: "Phone" },
      { key: "roomType", label: "Room type", get: (r, d) => nameOf(d, "roomtypes", r.roomType) },
      { key: "arrive", label: "Arrive", kind: "date" }, { key: "depart", label: "Depart", kind: "date" },
      { key: "avail", label: "Free now", kind: "num", right: true, get: (r, d) => (r.status === "Waiting" || r.status === "Offered" ? Math.max(availOn(d, String(r.roomType), String(r.arrive)), 0) : 0) },
      { key: "status", label: "Status", kind: "status" },
    ],
    fields: [
      { key: "name", label: "Guest name", kind: "text", required: true }, { key: "phone", label: "Phone", kind: "text", required: true },
      { key: "roomType", label: "Room type", kind: "select", options: typeOpts, required: true },
      { key: "party", label: "Guests", kind: "number", required: true },
      { key: "arrive", label: "Arrival", kind: "date", required: true }, { key: "depart", label: "Departure", kind: "date", required: true },
    ],
    validate: (v) => range(String(v.arrive), String(v.depart)) ?? positive("party", "Guests")(v),
    filterKey: "status",
    acts: [
      setStatus("Offer room", <HzSend20Regular />, ["Waiting"], "Offered", (r) => `Offer sent to ${String(r.name)}`),
      {
        label: "Convert to booking", icon: <HzCheckmark20Regular />, show: (r) => r.status === "Waiting" || r.status === "Offered",
        run: (r, d) => {
          const full = noRoomFor(d, String(r.roomType), String(r.arrive), String(r.depart));
          if (full) return { msg: "", err: full };
          const rt = rows(d, "roomtypes").find((t) => t.id === r.roomType);
          const plan = rows(d, "rateplans").find((p) => p.roomType === r.roomType && p.status === "Active");
          const existing = rows(d, "guests").find((g) => String(g.name).toLowerCase() === String(r.name).toLowerCase());
          const gid = existing?.id ?? nextId("GS-", rows(d, "guests"));
          const creates: NonNullable<Res["creates"]> = [];
          if (!existing) creates.push({ ent: "guests", id: gid, values: { name: String(r.name), phone: String(r.phone), email: "", nationality: "Nigeria", vip: "No", tier: "None", points: 0, prefs: "", status: "Active" } });
          creates.push({ ent: "reservations", values: { guest: gid, roomType: String(r.roomType), room: "", arrive: String(r.arrive), depart: String(r.depart), adults: num(r.party), plan: plan?.id ?? "", rate: num(plan?.rate ?? rt?.base), source: "Direct", agent: "", status: "Confirmed" } });
          return { patch: { status: "Booked" }, creates, msg: `${String(r.name)} booked from the waitlist` };
        },
      },
      setStatus("Expire", <HzDismiss20Regular />, ["Waiting", "Offered"], "Expired", (r) => `${String(r.name)}'s request expired`),
    ],
  },
  {
    id: "Housekeeping", src: "rooms", title: "Housekeeping", subtitle: "Room status board, cleaning and inspection.", noun: "room", idField: "number", initial: { state: "Dirty", attendant: "" },
    cols: [
      { key: "id", label: "Room", kind: "mono" },
      { key: "type", label: "Type", get: (r, d) => nameOf(d, "roomtypes", r.type) },
      { key: "floor", label: "Floor", kind: "num", right: true },
      { key: "occ", label: "Occupancy", kind: "status", get: (r, d) => (isOccupied(d, r.id) ? "Occupied" : "Vacant") },
      { key: "state", label: "Housekeeping", kind: "status" },
      { key: "attendant", label: "Attendant" },
    ],
    fields: [
      { key: "number", label: "Room number", kind: "text", required: true },
      { key: "type", label: "Room type", kind: "select", options: typeOpts, required: true },
      { key: "floor", label: "Floor", kind: "number", required: true },
    ],
    validate: (v, d, ex) => (ex ? null : /^\d{3,4}$/.test(String(v.number)) ? (v.number ? null : "Room number is required.") : "Use a 3 or 4 digit room number, for example 205.") ?? null,
    canDelete: (r, d) => (rows(d, "reservations").some((x) => x.room === r.id && resActive(x)) ? "This room has active reservations." : null),
    filterKey: "state", filterLabel: "All housekeeping",
    summary: (list, d) => [
      { label: "Vacant & ready", value: String(list.filter((r) => ["Clean", "Inspected"].includes(String(r.state)) && !isOccupied(d, r.id)).length) },
      { label: "To clean", value: String(list.filter((r) => r.state === "Dirty").length), note: `${list.filter((r) => r.state === "Dirty" && isOccupied(d, r.id)).length} occupied` },
      { label: "Awaiting inspection", value: String(list.filter((r) => r.state === "Clean").length) },
      { label: "Out of order", value: String(list.filter((r) => r.state === "Out of order").length) },
    ],
    acts: [
      { label: "Mark clean", icon: <HzBroom20Regular />, show: (r) => r.state === "Dirty", run: (r) => ({ patch: { state: "Clean" }, msg: `Room ${r.id} cleaned` }) },
      { label: "Inspect", icon: <HzCheckmarkCircle20Regular />, show: (r) => r.state === "Clean", run: (r) => ({ patch: { state: "Inspected" }, msg: `Room ${r.id} passed inspection` }) },
      { label: "Mark dirty", icon: <HzBroom20Regular />, show: (r) => r.state === "Clean" || r.state === "Inspected", run: (r) => ({ patch: { state: "Dirty" }, msg: `Room ${r.id} marked dirty` }) },
      {
        label: "Assign attendant", icon: <HzPerson20Regular />, show: (r) => r.state !== "Out of order",
        run: (r, _d, v) => ({ patch: { attendant: String(v.attendant) }, msg: `${String(v.attendant)} assigned to room ${r.id}` }),
        prompt: { title: "Assign attendant", submit: "Assign", fields: [{ key: "attendant", label: "Housekeeper", kind: "select", options: staffOpts("Housekeeping"), required: true }], init: (r) => ({ attendant: String(r.attendant ?? "") }) },
      },
      {
        label: "Out of order", icon: <HzWrench20Regular />, show: (r, d) => r.state !== "Out of order" && !isOccupied(d, r.id),
        run: (r, d, v) => {
          if (rows(d, "reservations").some((x) => x.room === r.id && resActive(x) && String(x.depart) > off(0))) return { msg: "", err: `Room ${r.id} has upcoming reservations. Move them first.` };
          return { patch: { state: "Out of order" }, creates: [{ ent: "workorders", values: { room: r.id, issue: String(v.issue), priority: String(v.priority), assigned: "", status: "Open", reported: off(0) } }], msg: `Room ${r.id} taken out of order, work order raised` };
        },
        prompt: { title: "Take out of order", submit: "Confirm", fields: [{ key: "issue", label: "Problem", kind: "text", required: true, full: true }, { key: "priority", label: "Priority", kind: "select", options: opts("Low", "Medium", "High"), required: true }], init: () => ({ priority: "Medium" }) },
      },
      {
        label: "Return to service", icon: <HzArrowUndo20Regular />, show: (r) => r.state === "Out of order",
        run: (r, d) => ({ patch: { state: "Dirty" }, other: rows(d, "workorders").filter((w) => w.room === r.id && w.status !== "Completed").map((w) => ({ ent: "workorders", id: w.id, patch: { status: "Completed" } })), msg: `Room ${r.id} back in service, needs cleaning` }),
      },
    ],
  },
  {
    id: "Maintenance", src: "workorders", title: "Maintenance", subtitle: "Repair requests and work orders.", noun: "work order", prefix: "WO-",
    initial: { status: "Open", assigned: "" },
    cols: [
      { key: "id", label: "Ref", kind: "mono" }, { key: "room", label: "Room" }, { key: "issue", label: "Issue" },
      { key: "priority", label: "Priority", kind: "status" }, { key: "assigned", label: "Assigned to" },
      { key: "reported", label: "Reported", kind: "date" }, { key: "status", label: "Status", kind: "status" },
    ],
    fields: [
      { key: "room", label: "Room or area", kind: "text", required: true }, { key: "issue", label: "Issue", kind: "text", required: true, full: true },
      { key: "priority", label: "Priority", kind: "select", options: opts("Low", "Medium", "High"), required: true },
      { key: "reported", label: "Reported on", kind: "date", required: true },
    ],
    canDelete: (r) => (r.status === "Completed" ? null : "Complete or reassign the work order instead of deleting it."),
    filterKey: "status",
    summary: (list) => [
      { label: "Open", value: String(list.filter((r) => r.status === "Open").length) },
      { label: "In progress", value: String(list.filter((r) => r.status === "In progress").length) },
      { label: "High priority", value: String(list.filter((r) => r.priority === "High" && r.status !== "Completed").length) },
      { label: "Completed", value: String(list.filter((r) => r.status === "Completed").length) },
    ],
    acts: [
      {
        label: "Assign & start", icon: <HzWrench20Regular />, show: (r) => r.status === "Open",
        run: (_r, _d, v) => ({ patch: { assigned: String(v.assigned), status: "In progress" }, msg: `Work started by ${String(v.assigned)}` }),
        prompt: { title: "Assign technician", submit: "Start", fields: [{ key: "assigned", label: "Technician", kind: "select", options: staffOpts("Maintenance"), required: true }], init: () => ({}) },
      },
      {
        label: "Complete", icon: <HzCheckmark20Regular />, show: (r) => r.status === "In progress" || r.status === "Open",
        run: (r, d) => {
          const stillOpen = rows(d, "workorders").some((w) => w.room === r.room && w.id !== r.id && w.status !== "Completed");
          const room = rows(d, "rooms").find((x) => x.id === r.room);
          const free = room?.state === "Out of order" && !stillOpen;
          return { patch: { status: "Completed" }, other: free && room ? [{ ent: "rooms", id: room.id, patch: { state: "Dirty" } }] : [], msg: free ? `Work order done, room ${r.room} back in service for cleaning` : `${r.id} completed` };
        },
      },
      setStatus("Reopen", <HzArrowUndo20Regular />, ["Completed"], "Open", (r) => `${r.id} reopened`),
    ],
  },
  {
    id: "Staff & shifts", src: "staff", title: "Staff & shifts", subtitle: "Who is on duty, by department and shift.", noun: "staff member", prefix: "ST-",
    initial: { status: "On duty" },
    cols: [
      { key: "id", label: "ID", kind: "mono" }, { key: "name", label: "Name" }, { key: "dept", label: "Department" },
      { key: "role", label: "Role" }, { key: "shift", label: "Shift" }, { key: "phone", label: "Phone" }, { key: "status", label: "Status", kind: "status" },
    ],
    fields: [
      { key: "name", label: "Name", kind: "text", required: true }, { key: "dept", label: "Department", kind: "select", options: opts("Front desk", "Housekeeping", "Maintenance", "F&B", "Security", "Management"), required: true },
      { key: "role", label: "Role", kind: "text", required: true }, { key: "shift", label: "Shift", kind: "select", options: opts("Morning", "Afternoon", "Night"), required: true },
      { key: "phone", label: "Phone", kind: "text" },
    ],
    filterKey: "dept", filterLabel: "All departments",
    summary: (list) => ["Front desk", "Housekeeping", "Maintenance", "F&B"].map((dp) => ({ label: dp, value: String(list.filter((s) => s.dept === dp && s.status === "On duty").length), note: `${list.filter((s) => s.dept === dp).length} staff` })),
    acts: [
      setStatus("Set on duty", <HzCheckmark20Regular />, ["Off duty", "On leave"], "On duty", (r) => `${String(r.name)} on duty`),
      setStatus("Set off duty", <HzDismiss20Regular />, ["On duty"], "Off duty", (r) => `${String(r.name)} off duty`),
      setStatus("On leave", <HzCalendarClock20Regular />, ["On duty", "Off duty"], "On leave", (r) => `${String(r.name)} on leave`),
    ],
  },
  {
    id: "Lost & found", src: "lostfound", title: "Lost & found", subtitle: "Items found around the property.", noun: "item", prefix: "LF-",
    initial: { status: "Stored", claimedBy: "" },
    cols: [
      { key: "id", label: "Ref", kind: "mono" }, { key: "item", label: "Item" }, { key: "location", label: "Found at" },
      { key: "found", label: "Found on", kind: "date" }, { key: "finder", label: "Found by" }, { key: "claimedBy", label: "Claimed by" }, { key: "status", label: "Status", kind: "status" },
    ],
    fields: [
      { key: "item", label: "Item", kind: "text", required: true, full: true }, { key: "location", label: "Found at", kind: "text", required: true },
      { key: "found", label: "Found on", kind: "date", required: true }, { key: "finder", label: "Found by", kind: "text", required: true },
    ],
    canDelete: (r) => (r.status === "Stored" ? "Mark it claimed or disposed instead of deleting." : null),
    filterKey: "status",
    acts: [
      {
        label: "Mark claimed", icon: <HzCheckmark20Regular />, show: (r) => r.status === "Stored",
        run: (r, _d, v) => ({ patch: { status: "Claimed", claimedBy: String(v.who) }, msg: `${String(r.item)} returned to ${String(v.who)}` }),
        prompt: { title: "Return item", submit: "Confirm", fields: [{ key: "who", label: "Collected by", kind: "text", required: true, full: true }], init: () => ({}) },
      },
      setStatus("Dispose", <HzDelete20Regular />, ["Stored"], "Disposed", (r) => `${String(r.item)} disposed`),
    ],
  },
  {
    id: "Guests", src: "guests", title: "Guests", subtitle: "Guest profiles, preferences and stay history.", noun: "guest", prefix: "GS-",
    initial: { points: 0, tier: "None", status: "Active" },
    cols: [
      { key: "id", label: "ID", kind: "mono" }, { key: "name", label: "Name" }, { key: "phone", label: "Phone" }, { key: "nationality", label: "Nationality" },
      { key: "vip", label: "VIP" }, { key: "tier", label: "Loyalty", kind: "status" },
      { key: "stays", label: "Stays", kind: "num", right: true, get: (r, d) => rows(d, "reservations").filter((x) => x.guest === r.id && x.status === "Checked out").length },
      { key: "status", label: "Status", kind: "status" },
    ],
    fields: [
      { key: "name", label: "Full name", kind: "text", required: true }, { key: "phone", label: "Phone", kind: "text", required: true },
      { key: "email", label: "Email", kind: "text" }, { key: "nationality", label: "Nationality", kind: "text", required: true },
      { key: "vip", label: "VIP", kind: "select", options: opts("No", "Yes"), required: true },
      { key: "prefs", label: "Preferences", kind: "text", full: true },
    ],
    validate: (v, d, ex) => {
      const email = String(v.email ?? "");
      if (email && !/^\S+@\S+\.\S+$/.test(email)) return "Enter a valid email address.";
      return rows(d, "guests").some((g) => g.id !== ex?.id && String(g.name).toLowerCase() === String(v.name).toLowerCase() && g.phone === v.phone) ? "A guest with this name and phone already exists." : null;
    },
    canDelete: (r, d) => (rows(d, "reservations").some((x) => x.guest === r.id) ? "This guest has reservations, so the profile can't be deleted." : null),
    filterKey: "tier", filterLabel: "All tiers",
    summary: (list) => [
      { label: "Guests", value: String(list.length) }, { label: "VIPs", value: String(list.filter((g) => g.vip === "Yes").length) },
      { label: "Loyalty members", value: String(list.filter((g) => g.tier !== "None").length) }, { label: "Blacklisted", value: String(list.filter((g) => g.status === "Blacklisted").length) },
    ],
    acts: [
      { label: "AI summary", icon: <HzSparkle20Regular />, show: () => true, run: (r, d) => ({ msg: "", draft: { title: `Summary: ${String(r.name)}`, body: guestSummary(d, r), note: true } }) },
      {
        label: "Draft message", icon: <HzSend20Regular />, show: (r) => r.status === "Active",
        run: (r, d, v) => {
          const next = rows(d, "reservations").find((x) => x.guest === r.id && x.status === "Confirmed");
          const kind = String(v.kind) as "welcome" | "thanks" | "apology";
          return { msg: "", draft: draftMessage(kind, String(r.name), kind === "welcome" ? (next ? fdate(String(next.arrive)) : "") : "") };
        },
        prompt: { title: "Draft a message", submit: "Draft", fields: [{ key: "kind", label: "Message", kind: "select", options: [{ v: "welcome", l: "Welcome before arrival" }, { v: "thanks", l: "Thank you after stay" }, { v: "apology", l: "Apology" }], required: true }], init: () => ({ kind: "welcome" }) },
      },
      awardAct("Award points", 1),
      { label: "Make VIP", icon: <HzPersonStar20Regular />, show: (r) => r.vip !== "Yes", run: (r) => ({ patch: { vip: "Yes" }, msg: `${String(r.name)} is now a VIP` }) },
      { label: "Remove VIP", icon: <HzDismiss20Regular />, show: (r) => r.vip === "Yes", run: (r) => ({ patch: { vip: "No" }, msg: `VIP removed from ${String(r.name)}` }) },
      {
        label: "Blacklist", icon: <HzProhibited20Regular />, show: (r, d) => r.status === "Active" && !rows(d, "reservations").some((x) => x.guest === r.id && x.status === "Checked in"),
        run: (r, d) => (rows(d, "reservations").some((x) => x.guest === r.id && ["Confirmed", "Pending"].includes(String(x.status))) ? { msg: "", err: "Cancel this guest's upcoming reservations first." } : { patch: { status: "Blacklisted" }, msg: `${String(r.name)} blacklisted` }),
      },
      setStatus("Restore", <HzArrowUndo20Regular />, ["Blacklisted"], "Active", (r) => `${String(r.name)} restored`),
    ],
    detail: (r, d) => {
      const stays = rows(d, "reservations").filter((x) => x.guest === r.id);
      return (
        <div className={styles.hzMiniBox}>
          <h4 className={styles.hzMiniTitle}>Stays</h4>
          {stays.length === 0 && <p className={styles.hzHint}>No stays yet.</p>}
          {stays.map((s) => (<div key={s.id} className={styles.hzMiniRow}><span>{fshort(String(s.arrive))} · {nightsOf(s)}n · {nameOf(d, "roomtypes", s.roomType)}</span><Pill text={String(s.status)} /></div>))}
          {r.prefs ? <p className={styles.hzHint}>{String(r.prefs)}</p> : null}
        </div>
      );
    },
  },
  {
    id: "Folios & billing", src: "reservations", title: "Folios & billing", subtitle: "Charges, payments and balances for in-house and departed guests.", noun: "folio", readOnly: true,
    where: (r) => r.status === "Checked in" || r.status === "Checked out",
    cols: [
      { key: "id", label: "Folio", kind: "mono" },
      { key: "guest", label: "Guest", get: (r, d) => hzGuestName(d, r.guest) }, { key: "room", label: "Room" },
      { key: "arrive", label: "Arrived", kind: "date" }, { key: "depart", label: "Departs", kind: "date" },
      { key: "charged", label: "Charged", kind: "money", right: true, get: (r, d) => sum(charges(d, r.id).filter((c) => c.kind === "Charge"), (c) => num(c.amount)) },
      { key: "paid", label: "Paid", kind: "money", right: true, get: (r, d) => sum(charges(d, r.id).filter((c) => c.kind === "Payment"), (c) => num(c.amount)) },
      { key: "bal", label: "Balance", kind: "money", right: true, get: (r, d) => balanceOf(d, r.id) },
      { key: "state", label: "Settlement", kind: "status", get: (r, d) => (balanceOf(d, r.id) > 0 ? "Owing" : balanceOf(d, r.id) < 0 ? "Credit" : "Settled") },
    ],
    fields: [], filterKey: "state", filterLabel: "All settlements",
    summary: (list, d) => [
      { label: "In-house folios", value: String(list.filter((r) => r.status === "Checked in").length) },
      { label: "Outstanding", value: compact(sum(list.filter((r) => balanceOf(d, r.id) > 0), (r) => balanceOf(d, r.id))) },
      { label: "Revenue today", value: compact(sum(rows(d, "charges").filter((c) => c.kind === "Charge" && c.date === off(0)), (c) => num(c.amount))) },
      { label: "Received today", value: compact(sum(rows(d, "charges").filter((c) => c.kind === "Payment" && c.date === off(0)), (c) => num(c.amount))) },
    ],
    acts: [actPostCharge, actPayment, actSettle, actCheckOut],
    detail: (r, d) => <FolioLines d={d} res={r.id} />,
  },
  {
    id: "Loyalty", src: "guests", title: "Loyalty", subtitle: "Points, tiers and rewards for returning guests.", noun: "member", readOnly: true,
    where: (r) => r.tier !== "None",
    cols: [
      { key: "name", label: "Member" }, { key: "tier", label: "Tier", kind: "status" }, { key: "points", label: "Points", kind: "num", right: true },
      { key: "next", label: "Next tier", get: (r) => { const n = nextTier(num(r.points)); return n ? `${n.name} in ${n.gap} pts` : "Top tier"; } },
      { key: "prog", label: "Progress", kind: "bar", get: (r) => { const p = num(r.points); return p >= 5000 ? 100 : p >= 2000 ? pct(p - 2000, 3000) : p >= 500 ? pct(p - 500, 1500) : pct(p, 500); } },
      { key: "vip", label: "VIP" },
    ],
    fields: [], filterKey: "tier", filterLabel: "All tiers",
    summary: (list) => [
      { label: "Members", value: String(list.length) }, { label: "Platinum", value: String(list.filter((g) => g.tier === "Platinum").length) },
      { label: "Gold", value: String(list.filter((g) => g.tier === "Gold").length) }, { label: "Points outstanding", value: num(sum(list, (g) => num(g.points))).toLocaleString("en-NG") },
    ],
    acts: [awardAct("Award points", 1), awardAct("Redeem points", -1)],
  },
  {
    id: "Feedback", src: "feedback", title: "Feedback & reviews", subtitle: "Guest ratings from surveys and review sites.", noun: "review", prefix: "FB-",
    initial: { status: "Open" },
    cols: [
      { key: "id", label: "Ref", kind: "mono" }, { key: "guest", label: "Guest", get: (r, d) => hzGuestName(d, r.guest) },
      { key: "rating", label: "Rating", kind: "num", right: true, get: (r) => `${num(r.rating)} / 5` },
      { key: "mood", label: "Sentiment", kind: "status", get: (r) => (num(r.rating) >= 4 ? "Positive" : num(r.rating) === 3 ? "Neutral" : "Negative") },
      { key: "channel", label: "Channel" }, { key: "comment", label: "Comment" }, { key: "date", label: "Date", kind: "date" }, { key: "status", label: "Status", kind: "status" },
    ],
    fields: [
      { key: "guest", label: "Guest", kind: "select", options: (d) => rows(d, "guests").map((g) => ({ v: g.id, l: String(g.name) })), required: true },
      { key: "rating", label: "Rating (1 to 5)", kind: "number", required: true },
      { key: "channel", label: "Channel", kind: "select", options: opts("Survey", "Google", "TripAdvisor", "Booking.com", "Front desk"), required: true },
      { key: "date", label: "Date", kind: "date", required: true }, { key: "comment", label: "Comment", kind: "text", required: true, full: true },
    ],
    validate: (v) => (num(v.rating) >= 1 && num(v.rating) <= 5 ? null : "Rating must be between 1 and 5."),
    filterKey: "status",
    summary: (list) => {
      const avg = list.length ? sum(list, (f) => num(f.rating)) / list.length : 0;
      return [{ label: "Average rating", value: avg.toFixed(1) }, { label: "Reviews", value: String(list.length) }, { label: "Positive", value: `${pct(list.filter((f) => num(f.rating) >= 4).length, list.length)}%` }, { label: "Need a reply", value: String(list.filter((f) => f.status === "Open").length) }];
    },
    acts: [
      { label: "Draft reply", icon: <HzSparkle20Regular />, show: (r) => r.status === "Open" || r.status === "Escalated", run: (r, d) => ({ msg: "", draft: draftMessage(num(r.rating) <= 2 ? "apology" : "review", hzGuestName(d, r.guest), num(r.rating) <= 2 ? String(r.comment).toLowerCase() : "your stay") }) },
      setStatus("Mark responded", <HzCheckmark20Regular />, ["Open", "Escalated"], "Responded", (r) => `${r.id} marked responded`),
      {
        label: "Escalate", icon: <HzWarning20Regular />, show: (r) => r.status === "Open" && num(r.rating) <= 3,
        run: (r) => ({ patch: { status: "Escalated" }, creates: [{ ent: "complaints", values: { guest: String(r.guest), dept: "Guest relations", issue: String(r.comment), severity: num(r.rating) <= 2 ? "High" : "Medium", owner: "Guest relations", opened: off(0), status: "Open" } }], msg: `${r.id} escalated, complaint opened` }),
      },
    ],
  },
  {
    id: "Messages", src: "messages", title: "Guest messages", subtitle: "Log of messages sent to guests.", noun: "message", readOnly: true,
    cols: [
      { key: "id", label: "Ref", kind: "mono" }, { key: "date", label: "Date", kind: "date" },
      { key: "guest", label: "Guest", get: (r, d) => (r.guest ? hzGuestName(d, r.guest) : "—") }, { key: "subject", label: "Subject" }, { key: "channel", label: "Channel" }, { key: "by", label: "Sent by" },
    ],
    fields: [], acts: [],
  },
  {
    id: "Corporate accounts", src: "corporates", title: "Corporate accounts", subtitle: "Negotiated rates and credit for companies.", noun: "account", prefix: "CP-",
    initial: { status: "Active" },
    cols: [
      { key: "id", label: "ID", kind: "mono" }, { key: "name", label: "Company" }, { key: "contact", label: "Contact" },
      { key: "discount", label: "Discount", kind: "pct", right: true }, { key: "limit", label: "Credit limit", kind: "money", right: true },
      { key: "terms", label: "Terms" },
      { key: "stays", label: "Stays", kind: "num", right: true, get: (r, d) => rows(d, "reservations").filter((x) => x.corp === r.id).length },
      { key: "status", label: "Status", kind: "status" },
    ],
    fields: [
      { key: "name", label: "Company", kind: "text", required: true }, { key: "contact", label: "Contact person", kind: "text", required: true },
      { key: "email", label: "Email", kind: "text", required: true }, { key: "discount", label: "Discount %", kind: "number", required: true },
      { key: "limit", label: "Credit limit (₦)", kind: "number", required: true }, { key: "terms", label: "Payment terms", kind: "select", options: opts("Prepaid", "Net 15", "Net 30", "Net 45"), required: true },
    ],
    validate: (v) => (num(v.discount) < 0 || num(v.discount) > 60 ? "Discount must be between 0 and 60%." : /^\S+@\S+\.\S+$/.test(String(v.email)) ? null : "Enter a valid email address."),
    canDelete: (r, d) => (rows(d, "reservations").some((x) => x.corp === r.id) ? "This company has stays on record. Put it on hold instead." : null),
    filterKey: "status",
    summary: (list, d) => [
      { label: "Accounts", value: String(list.length) }, { label: "Active", value: String(list.filter((c) => c.status === "Active").length) },
      { label: "Credit extended", value: compact(sum(list, (c) => num(c.limit))) }, { label: "Corporate revenue", value: compact(sum(rows(d, "reservations").filter((x) => x.corp), resTotal)) },
    ],
    acts: [setStatus("Put on hold", <HzProhibited20Regular />, ["Active"], "On hold", (r) => `${String(r.name)} put on hold`), setStatus("Reactivate", <HzCheckmark20Regular />, ["On hold"], "Active", (r) => `${String(r.name)} reactivated`)],
  },
  {
    id: "Travel agents", src: "agents", title: "Travel agents", subtitle: "Agents, tour operators and commission owed.", noun: "agent", prefix: "TA-",
    initial: { status: "Active" },
    cols: [
      { key: "id", label: "ID", kind: "mono" }, { key: "name", label: "Agency" }, { key: "type", label: "Type" }, { key: "contact", label: "Contact" },
      { key: "commission", label: "Commission", kind: "pct", right: true },
      { key: "stays", label: "Bookings", kind: "num", right: true, get: (r, d) => rows(d, "reservations").filter((x) => x.agent === r.id && x.status !== "Cancelled").length },
      { key: "due", label: "Commission due", kind: "money", right: true, get: (r, d) => sum(rows(d, "reservations").filter((x) => x.agent === r.id && x.status === "Checked out"), (x) => (resTotal(x) * num(r.commission)) / 100) },
      { key: "status", label: "Status", kind: "status" },
    ],
    fields: [
      { key: "name", label: "Agency", kind: "text", required: true }, { key: "type", label: "Type", kind: "select", options: opts("Travel agent", "Tour operator", "Online agent"), required: true },
      { key: "contact", label: "Contact person", kind: "text", required: true }, { key: "commission", label: "Commission %", kind: "number", required: true },
    ],
    validate: (v) => (num(v.commission) < 0 || num(v.commission) > 40 ? "Commission must be between 0 and 40%." : null),
    canDelete: (r, d) => (rows(d, "reservations").some((x) => x.agent === r.id) ? "This agent has bookings. Deactivate instead." : null),
    filterKey: "status",
    acts: toggleActs("name"),
  },
  {
    id: "Promotions", src: "promos", title: "Promotions", subtitle: "Promo codes and seasonal offers.", noun: "promotion", prefix: "PR-",
    initial: { status: "Active", used: 0 },
    cols: [
      { key: "id", label: "ID", kind: "mono" }, { key: "code", label: "Code", kind: "mono" }, { key: "name", label: "Offer" },
      { key: "value", label: "Discount", get: (r) => (r.kind === "Percent" ? `${num(r.value)}%` : money(num(r.value))), right: true },
      { key: "from", label: "From", kind: "date" }, { key: "to", label: "To", kind: "date" },
      { key: "use", label: "Used", kind: "bar", get: (r) => pct(num(r.used), num(r.limit)) },
      { key: "state", label: "Status", kind: "status", get: (r) => (r.status === "Paused" ? "Paused" : String(r.to) < off(0) ? "Expired" : String(r.from) > off(0) ? "Scheduled" : "Active") },
    ],
    fields: [
      { key: "code", label: "Code", kind: "text", required: true }, { key: "name", label: "Offer name", kind: "text", required: true },
      { key: "kind", label: "Type", kind: "select", options: opts("Percent", "Fixed"), required: true }, { key: "value", label: "Value", kind: "number", required: true },
      { key: "from", label: "Valid from", kind: "date", required: true }, { key: "to", label: "Valid to", kind: "date", required: true }, { key: "limit", label: "Usage limit", kind: "number", required: true },
    ],
    validate: (v, d, ex) => {
      const bad = range(String(v.from), String(v.to)) ?? positive("value", "Discount")(v) ?? positive("limit", "Usage limit")(v);
      if (bad) return bad.replace("Departure must be after arrival.", "End date must be after the start date.");
      if (v.kind === "Percent" && num(v.value) > 100) return "A percentage can't exceed 100.";
      return rows(d, "promos").some((p) => p.id !== ex?.id && String(p.code).toUpperCase() === String(v.code).toUpperCase()) ? "That code is already in use." : null;
    },
    canDelete: (r) => (num(r.used) > 0 ? "This code has been used. Pause it instead." : null),
    filterKey: "state", filterLabel: "All statuses",
    acts: [setStatus("Pause", <HzDismiss20Regular />, ["Active"], "Paused", (r) => `${String(r.code)} paused`), setStatus("Resume", <HzCheckmark20Regular />, ["Paused"], "Active", (r) => `${String(r.code)} resumed`)],
  },
  {
    id: "Complaints", src: "complaints", title: "Complaints", subtitle: "Service recovery and follow-up.", noun: "complaint", prefix: "CM-",
    initial: { status: "Open" },
    cols: [
      { key: "id", label: "Ref", kind: "mono" }, { key: "guest", label: "Guest", get: (r, d) => hzGuestName(d, r.guest) }, { key: "dept", label: "Department" },
      { key: "issue", label: "Issue" }, { key: "severity", label: "Severity", kind: "status" }, { key: "owner", label: "Owner" },
      { key: "opened", label: "Opened", kind: "date" }, { key: "status", label: "Status", kind: "status" },
    ],
    fields: [
      { key: "guest", label: "Guest", kind: "select", options: (d) => rows(d, "guests").map((g) => ({ v: g.id, l: String(g.name) })), required: true },
      { key: "dept", label: "Department", kind: "select", options: opts("Front desk", "Housekeeping", "Maintenance", "F&B", "Security", "Guest relations"), required: true },
      { key: "issue", label: "What happened", kind: "text", required: true, full: true }, { key: "severity", label: "Severity", kind: "select", options: opts("Low", "Medium", "High"), required: true },
      { key: "owner", label: "Owner", kind: "text", required: true }, { key: "opened", label: "Opened", kind: "date", required: true },
    ],
    canDelete: (r) => (r.status === "Resolved" ? null : "Resolve the complaint before deleting it."),
    filterKey: "status",
    summary: (list) => [
      { label: "Open", value: String(list.filter((c) => c.status === "Open").length) }, { label: "In progress", value: String(list.filter((c) => c.status === "In progress").length) },
      { label: "Escalated", value: String(list.filter((c) => c.status === "Escalated").length) }, { label: "Resolved", value: String(list.filter((c) => c.status === "Resolved").length) },
    ],
    acts: [
      setStatus("Start", <HzWrench20Regular />, ["Open"], "In progress", (r) => `${r.id} in progress`),
      { label: "Draft apology", icon: <HzSparkle20Regular />, show: (r) => r.status !== "Resolved", run: (r, d) => ({ msg: "", draft: draftMessage("apology", hzGuestName(d, r.guest), String(r.issue).toLowerCase()) }) },
      setStatus("Escalate", <HzWarning20Regular />, ["Open", "In progress"], "Escalated", (r) => `${r.id} escalated to management`),
      {
        label: "Resolve", icon: <HzCheckmark20Regular />, show: (r) => r.status !== "Resolved",
        run: (r, _d, v) => ({ patch: { status: "Resolved", resolution: String(v.resolution) }, msg: `${r.id} resolved` }),
        prompt: { title: "Resolve complaint", submit: "Resolve", fields: [{ key: "resolution", label: "What was done", kind: "text", required: true, full: true }], init: () => ({}) },
      },
    ],
  },
  {
    id: "Rate plans", src: "rateplans", title: "Rate plans", subtitle: "Prices, meal plans and cancellation rules.", noun: "rate plan", prefix: "RP-",
    initial: { status: "Active" },
    cols: [
      { key: "id", label: "ID", kind: "mono" }, { key: "name", label: "Plan" }, { key: "code", label: "Code", kind: "mono" },
      { key: "roomType", label: "Room type", get: (r, d) => nameOf(d, "roomtypes", r.roomType) }, { key: "basis", label: "Basis" },
      { key: "rate", label: "Rate", kind: "money", right: true }, { key: "minStay", label: "Min stay", kind: "num", right: true },
      { key: "cancel", label: "Cancellation" }, { key: "status", label: "Status", kind: "status" },
    ],
    fields: [
      { key: "name", label: "Plan name", kind: "text", required: true }, { key: "code", label: "Code", kind: "text", required: true },
      { key: "roomType", label: "Room type", kind: "select", options: typeOpts, required: true }, { key: "basis", label: "Meal basis", kind: "select", options: opts("Room only", "Bed & breakfast", "Half board", "Full board"), required: true },
      { key: "rate", label: "Nightly rate (₦)", kind: "number", required: true }, { key: "minStay", label: "Minimum stay", kind: "number", required: true },
      { key: "cancel", label: "Cancellation", kind: "select", options: opts("Free until 24h", "Free until 7 days", "Non-refundable"), required: true },
    ],
    validate: (v, d, ex) => positive("rate", "Rate")(v) ?? positive("minStay", "Minimum stay")(v) ?? (rows(d, "rateplans").some((p) => p.id !== ex?.id && String(p.code).toUpperCase() === String(v.code).toUpperCase()) ? "That code is already used by another plan." : null),
    canDelete: (r, d) => (rows(d, "reservations").some((x) => x.plan === r.id) ? "Reservations use this plan. Deactivate it instead." : null),
    filterKey: "status",
    acts: toggleActs("name"),
  },
  {
    id: "Room types", src: "roomtypes", title: "Room types", subtitle: "Categories, base prices and capacity.", noun: "room type", prefix: "RT-",
    initial: { status: "Active" },
    cols: [
      { key: "id", label: "ID", kind: "mono" }, { key: "name", label: "Name" }, { key: "code", label: "Code", kind: "mono" },
      { key: "rooms", label: "Rooms", kind: "num", right: true, get: (r, d) => rows(d, "rooms").filter((x) => x.type === r.id).length },
      { key: "base", label: "Base rate", kind: "money", right: true }, { key: "maxOcc", label: "Sleeps", kind: "num", right: true }, { key: "beds", label: "Beds" }, { key: "status", label: "Status", kind: "status" },
    ],
    fields: [
      { key: "name", label: "Name", kind: "text", required: true }, { key: "code", label: "Code", kind: "text", required: true },
      { key: "base", label: "Base rate (₦)", kind: "number", required: true }, { key: "maxOcc", label: "Sleeps", kind: "number", required: true },
      { key: "beds", label: "Beds", kind: "text", required: true }, { key: "amenities", label: "Amenities", kind: "text", full: true },
    ],
    validate: (v, d, ex) => positive("base", "Base rate")(v) ?? positive("maxOcc", "Capacity")(v) ?? (rows(d, "roomtypes").some((t) => t.id !== ex?.id && String(t.code).toUpperCase() === String(v.code).toUpperCase()) ? "That code is already used." : null),
    canDelete: (r, d) => (rows(d, "rooms").some((x) => x.type === r.id) ? "Rooms use this type. Deactivate it instead." : null),
    filterKey: "status",
    acts: toggleActs("name"),
  },
  {
    id: "Channels", src: "channels", title: "Channel manager", subtitle: "Online travel agencies and your own booking engine.", noun: "channel", prefix: "CN-",
    initial: { status: "Connected", parity: "In parity", allocation: 5 },
    cols: [
      { key: "id", label: "ID", kind: "mono" }, { key: "name", label: "Channel" }, { key: "status", label: "Connection", kind: "status" },
      { key: "parity", label: "Rate parity", kind: "status" }, { key: "commission", label: "Commission", kind: "pct", right: true },
      { key: "allocation", label: "Rooms allocated", kind: "num", right: true },
      { key: "bookings", label: "Bookings", kind: "num", right: true, get: (r, d) => rows(d, "reservations").filter((x) => x.source === r.name && x.status !== "Cancelled").length },
      { key: "lastSync", label: "Last sync" },
    ],
    fields: [
      { key: "name", label: "Channel name", kind: "text", required: true }, { key: "commission", label: "Commission %", kind: "number", required: true }, { key: "allocation", label: "Rooms allocated", kind: "number", required: true },
    ],
    validate: (v) => (num(v.commission) < 0 || num(v.commission) > 40 ? "Commission must be between 0 and 40%." : num(v.allocation) < 0 ? "Allocation can't be negative." : null),
    canDelete: (r, d) => (rows(d, "reservations").some((x) => x.source === r.name) ? "This channel has bookings. Disconnect it instead." : null),
    filterKey: "status", filterLabel: "All connections",
    summary: (list, d) => [
      { label: "Connected", value: `${list.filter((c) => c.status === "Connected").length} of ${list.length}` }, { label: "Out of parity", value: String(list.filter((c) => c.parity === "Out of parity").length) },
      { label: "OTA bookings", value: String(rows(d, "reservations").filter((x) => list.some((c) => c.name === x.source) && x.status !== "Cancelled").length) },
      { label: "Commission due", value: compact(sum(list, (c) => sum(rows(d, "reservations").filter((x) => x.source === c.name && x.status === "Checked out"), (x) => (resTotal(x) * num(c.commission)) / 100))) },
    ],
    acts: [
      { label: "Sync now", icon: <HzArrowSync20Regular />, show: (r) => r.status !== "Disconnected", run: (r) => ({ patch: { status: "Connected", lastSync: new Date().toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) }, msg: `${String(r.name)} synced` }) },
      { label: "Fix parity", icon: <HzTag20Regular />, show: (r) => r.parity === "Out of parity", run: (r) => ({ patch: { parity: "In parity" }, msg: `${String(r.name)} rates pushed, now in parity` }) },
      setStatus("Disconnect", <HzPlugDisconnected20Regular />, ["Connected", "Error"], "Disconnected", (r) => `${String(r.name)} disconnected`),
      { label: "Connect", icon: <HzPlugConnected20Regular />, show: (r) => r.status === "Disconnected", run: (r) => ({ patch: { status: "Connected", lastSync: "Just now" }, msg: `${String(r.name)} connected` }) },
    ],
  },
  {
    id: "Web bookings", src: "webbookings", title: "Web bookings", subtitle: "Requests that arrive from channels and your website.", noun: "request", prefix: "OB-",
    initial: { status: "New" },
    cols: [
      { key: "id", label: "Ref", kind: "mono" }, { key: "name", label: "Guest" }, { key: "channel", label: "Channel" },
      { key: "roomType", label: "Room type", get: (r, d) => nameOf(d, "roomtypes", r.roomType) },
      { key: "arrive", label: "Arrive", kind: "date" }, { key: "depart", label: "Depart", kind: "date" },
      { key: "amount", label: "Amount", kind: "money", right: true }, { key: "status", label: "Status", kind: "status" },
    ],
    fields: [
      { key: "name", label: "Guest name", kind: "text", required: true }, { key: "email", label: "Email", kind: "text", required: true },
      { key: "channel", label: "Channel", kind: "select", options: SOURCES.filter((s) => !["Walk-in", "Corporate", "Travel agent"].includes(s.v)), required: true },
      { key: "roomType", label: "Room type", kind: "select", options: typeOpts, required: true },
      { key: "arrive", label: "Arrival", kind: "date", required: true }, { key: "depart", label: "Departure", kind: "date", required: true },
      { key: "adults", label: "Guests", kind: "number", required: true }, { key: "amount", label: "Total (₦)", kind: "number", required: true },
    ],
    validate: (v) => range(String(v.arrive), String(v.depart)) ?? positive("amount", "Total")(v) ?? positive("adults", "Guests")(v) ?? (/^\S+@\S+\.\S+$/.test(String(v.email)) ? null : "Enter a valid email address."),
    canDelete: (r) => (r.status === "New" ? "Accept or reject the request instead." : null),
    filterKey: "status",
    summary: (list) => [
      { label: "New requests", value: String(list.filter((r) => r.status === "New").length) }, { label: "Accepted", value: String(list.filter((r) => r.status === "Accepted").length) },
      { label: "Value waiting", value: compact(sum(list.filter((r) => r.status === "New"), (r) => num(r.amount))) },
    ],
    acts: [
      {
        label: "Accept", icon: <HzCheckmark20Regular />, show: (r) => r.status === "New",
        run: (r, d) => {
          const full = noRoomFor(d, String(r.roomType), String(r.arrive), String(r.depart));
          if (full) return { msg: "", err: full };
          const existing = rows(d, "guests").find((g) => String(g.name).toLowerCase() === String(r.name).toLowerCase());
          const gid = existing?.id ?? nextId("GS-", rows(d, "guests"));
          const n = Math.max(daysBetween(String(r.arrive), String(r.depart)), 1);
          const plan = rows(d, "rateplans").find((p) => p.roomType === r.roomType && p.status === "Active");
          const creates: NonNullable<Res["creates"]> = [];
          if (!existing) creates.push({ ent: "guests", id: gid, values: { name: String(r.name), phone: "", email: String(r.email), nationality: "Nigeria", vip: "No", tier: "None", points: 0, prefs: "", status: "Active" } });
          creates.push({ ent: "reservations", values: { guest: gid, roomType: String(r.roomType), room: "", arrive: String(r.arrive), depart: String(r.depart), adults: num(r.adults), plan: plan?.id ?? "", rate: Math.round(num(r.amount) / n), source: String(r.channel), agent: "", status: "Confirmed" } });
          return { patch: { status: "Accepted" }, creates, msg: `${String(r.name)} accepted and booked` };
        },
      },
      setStatus("Reject", <HzDismiss20Regular />, ["New"], "Rejected", (r) => `${r.id} rejected`),
    ],
  },
  {
    id: "Audit log", src: "audit", title: "Audit log", subtitle: "Every change made on these pages.", noun: "entry", readOnly: true,
    cols: [{ key: "id", label: "Ref", kind: "mono" }, { key: "when", label: "When" }, { key: "user", label: "User" }, { key: "entity", label: "Page" }, { key: "record", label: "Record" }, { key: "action", label: "Action" }, { key: "detail", label: "Detail" }],
    fields: [], acts: [],
  },
  {
    id: "Stock items", src: "stock", title: "Stock items", subtitle: "Linen, toiletries, minibar and supplies on hand.", noun: "item", prefix: "SK-",
    cols: [
      { key: "id", label: "SKU", kind: "mono" }, { key: "name", label: "Item" }, { key: "category", label: "Category" },
      { key: "qty", label: "On hand", kind: "num", right: true }, { key: "unit", label: "Unit" }, { key: "par", label: "Par", kind: "num", right: true }, { key: "reorder", label: "Reorder at", kind: "num", right: true },
      { key: "value", label: "Value", kind: "money", right: true, get: (r) => num(r.qty) * num(r.cost) },
      { key: "state", label: "Level", kind: "status", get: (r) => stockState(r) },
    ],
    fields: [
      { key: "name", label: "Item", kind: "text", required: true }, { key: "category", label: "Category", kind: "select", options: opts("Linen", "Toiletries", "Minibar", "F&B", "Cleaning", "Engineering"), required: true },
      { key: "unit", label: "Unit", kind: "text", required: true }, { key: "qty", label: "On hand", kind: "number", required: true },
      { key: "par", label: "Par level", kind: "number", required: true }, { key: "reorder", label: "Reorder at", kind: "number", required: true },
      { key: "cost", label: "Unit cost (₦)", kind: "number", required: true },
      { key: "supplier", label: "Supplier", kind: "select", options: (d) => rows(d, "suppliers").filter((s) => s.status === "Active").map((s) => ({ v: s.id, l: String(s.name) })), required: true },
    ],
    validate: (v) => (num(v.qty) < 0 ? "On hand can't be negative." : num(v.reorder) > num(v.par) ? "Reorder level can't be above the par level." : positive("cost", "Unit cost")(v)),
    canDelete: (r, d) => (num(r.qty) > 0 ? "Issue or adjust the remaining stock to zero first." : rows(d, "orders").some((o) => o.item === r.id && ["Draft", "Ordered"].includes(String(o.status))) ? "There is an open purchase order for this item." : null),
    filterKey: "state", filterLabel: "All levels",
    summary: (list) => [
      { label: "Items", value: String(list.length) }, { label: "Stock value", value: compact(sum(list, (r) => num(r.qty) * num(r.cost))) },
      { label: "Low", value: String(list.filter((r) => stockState(r) === "Low").length) }, { label: "Out of stock", value: String(list.filter((r) => stockState(r) === "Out").length) },
    ],
    acts: [
      {
        label: "Receive", icon: <HzAdd20Regular />, show: () => true,
        run: (r, _d, v) => (num(v.qty) <= 0 ? { msg: "", err: "Quantity must be greater than zero." } : { patch: { qty: num(r.qty) + num(v.qty) }, creates: [{ ent: "moves", values: { item: r.id, kind: "Receive", qty: num(v.qty), ref: String(v.ref || "Manual receipt"), date: off(0), by: "You" } }], msg: `${num(v.qty)} ${String(r.unit)} of ${String(r.name)} received` }),
        prompt: { title: "Receive stock", submit: "Receive", fields: [{ key: "qty", label: "Quantity", kind: "number", required: true }, { key: "ref", label: "Delivery note / reference", kind: "text" }], init: () => ({}) },
      },
      {
        label: "Issue", icon: <HzArrowUndo20Regular />, show: (r) => num(r.qty) > 0,
        run: (r, _d, v) => (num(v.qty) <= 0 ? { msg: "", err: "Quantity must be greater than zero." } : num(v.qty) > num(r.qty) ? { msg: "", err: `Only ${num(r.qty)} ${String(r.unit)} on hand.` } : { patch: { qty: num(r.qty) - num(v.qty) }, creates: [{ ent: "moves", values: { item: r.id, kind: "Issue", qty: num(v.qty), ref: String(v.dept), date: off(0), by: "You" } }], msg: `${num(v.qty)} ${String(r.unit)} issued to ${String(v.dept)}` }),
        prompt: { title: "Issue stock", submit: "Issue", fields: [{ key: "qty", label: "Quantity", kind: "number", required: true }, { key: "dept", label: "To department", kind: "select", options: opts("Housekeeping", "F&B", "Front desk", "Maintenance", "Spa", "Laundry"), required: true }], init: () => ({ dept: "Housekeeping" }) },
      },
      {
        label: "Stock count", icon: <HzClipboardTask20Regular />, show: () => true,
        run: (r, _d, v) => (num(v.qty) < 0 ? { msg: "", err: "Count can't be negative." } : { patch: { qty: num(v.qty) }, creates: [{ ent: "moves", values: { item: r.id, kind: "Adjust", qty: num(v.qty) - num(r.qty), ref: "Stock count", date: off(0), by: "You" } }], msg: `${String(r.name)} counted at ${num(v.qty)}` }),
        prompt: { title: "Stock count", submit: "Save count", fields: [{ key: "qty", label: "Counted quantity", kind: "number", required: true }], init: (r) => ({ qty: num(r.qty) }) },
      },
    ],
  },
  {
    id: "Purchase orders", src: "orders", title: "Purchase orders", subtitle: "Orders to suppliers and goods received.", noun: "order", prefix: "PO-",
    initial: { status: "Draft" },
    cols: [
      { key: "id", label: "PO", kind: "mono" }, { key: "supplier", label: "Supplier", get: (r, d) => nameOf(d, "suppliers", r.supplier) }, { key: "item", label: "Item", get: (r, d) => nameOf(d, "stock", r.item) },
      { key: "qty", label: "Qty", kind: "num", right: true }, { key: "total", label: "Total", kind: "money", right: true, get: (r) => num(r.qty) * num(r.cost) },
      { key: "date", label: "Raised", kind: "date" }, { key: "expected", label: "Expected", kind: "date" }, { key: "status", label: "Status", kind: "status" },
    ],
    fields: [
      { key: "item", label: "Item", kind: "select", options: (d) => rows(d, "stock").map((s) => ({ v: s.id, l: String(s.name) })), required: true },
      { key: "qty", label: "Quantity", kind: "number", required: true }, { key: "cost", label: "Unit cost (₦)", kind: "number", required: true },
      { key: "supplier", label: "Supplier", kind: "select", options: (d) => rows(d, "suppliers").filter((s) => s.status === "Active").map((s) => ({ v: s.id, l: String(s.name) })), required: true },
      { key: "date", label: "Raised", kind: "date", required: true }, { key: "expected", label: "Expected", kind: "date", required: true },
    ],
    validate: (v) => positive("qty", "Quantity")(v) ?? positive("cost", "Unit cost")(v) ?? (String(v.expected) < String(v.date) ? "Expected date can't be before the order date." : null),
    canDelete: (r) => (r.status === "Draft" || r.status === "Cancelled" ? null : "Only draft or cancelled orders can be deleted."),
    filterKey: "status",
    summary: (list) => [
      { label: "Draft", value: String(list.filter((o) => o.status === "Draft").length) }, { label: "On order", value: String(list.filter((o) => o.status === "Ordered").length), note: compact(sum(list.filter((o) => o.status === "Ordered"), (o) => num(o.qty) * num(o.cost))) },
      { label: "Overdue", value: String(list.filter((o) => o.status === "Ordered" && String(o.expected) < off(0)).length) }, { label: "Received", value: String(list.filter((o) => o.status === "Received").length) },
    ],
    acts: [
      setStatus("Place order", <HzSend20Regular />, ["Draft"], "Ordered", (r) => `${r.id} sent to supplier`),
      {
        label: "Receive goods", icon: <HzBox20Regular />, show: (r) => r.status === "Ordered",
        run: (r, d) => {
          const it = rows(d, "stock").find((s) => s.id === r.item);
          return { patch: { status: "Received" }, other: it ? [{ ent: "stock", id: it.id, patch: { qty: num(it.qty) + num(r.qty) } }] : [], creates: [{ ent: "moves", values: { item: String(r.item), kind: "Receive", qty: num(r.qty), ref: r.id, date: off(0), by: "You" } }], msg: `${r.id} received, stock updated` };
        },
      },
      setStatus("Cancel", <HzDismiss20Regular />, ["Draft", "Ordered"], "Cancelled", (r) => `${r.id} cancelled`),
    ],
  },
  {
    id: "Suppliers", src: "suppliers", title: "Suppliers", subtitle: "Vendors and payment terms.", noun: "supplier", prefix: "SP-",
    initial: { status: "Active" },
    cols: [
      { key: "id", label: "ID", kind: "mono" }, { key: "name", label: "Supplier" }, { key: "category", label: "Supplies" }, { key: "contact", label: "Contact" }, { key: "phone", label: "Phone" }, { key: "terms", label: "Terms" },
      { key: "items", label: "Items", kind: "num", right: true, get: (r, d) => rows(d, "stock").filter((s) => s.supplier === r.id).length }, { key: "status", label: "Status", kind: "status" },
    ],
    fields: [
      { key: "name", label: "Supplier", kind: "text", required: true }, { key: "category", label: "Supplies", kind: "text", required: true }, { key: "contact", label: "Contact", kind: "text", required: true },
      { key: "phone", label: "Phone", kind: "text", required: true }, { key: "terms", label: "Terms", kind: "select", options: opts("Cash on delivery", "Net 15", "Net 30"), required: true },
    ],
    canDelete: (r, d) => (rows(d, "stock").some((s) => s.supplier === r.id) || rows(d, "orders").some((o) => o.supplier === r.id) ? "Items or orders use this supplier. Deactivate instead." : null),
    filterKey: "status",
    acts: toggleActs("name"),
  },
  {
    id: "Stock movements", src: "moves", title: "Stock movements", subtitle: "Every receipt, issue and count.", noun: "movement", readOnly: true,
    cols: [
      { key: "id", label: "Ref", kind: "mono" }, { key: "date", label: "Date", kind: "date" }, { key: "item", label: "Item", get: (r, d) => nameOf(d, "stock", r.item) },
      { key: "kind", label: "Type" }, { key: "qty", label: "Qty", kind: "num", right: true }, { key: "ref", label: "Reference" }, { key: "by", label: "By" },
    ],
    fields: [], acts: [], filterKey: "kind", filterLabel: "All types",
  },
];


/* ---------- custom pages ---------- */
const HzPanel: React.FC<{ title: string; note?: string; children: React.ReactNode; wide?: boolean; action?: React.ReactNode }> = ({ title, note, children, wide, action }) => (
  <section className={`${styles.hzPanel} ${wide ? styles.hzWide : ""}`}>
    <div className={styles.hzPanelHead}>
      <h3 className={styles.hzPanelTitle}>{title}</h3>
      {action}
    </div>
    {note && <p className={styles.hzPanelNote}>{note}</p>}
    {children}
  </section>
);
const commit = (p: PageProps, src: string, row: Row, res: Res, title: string, label: string) => {
  if (res.err) return p.say(res.err, true);
  p.setData((d) => audit(apply(d, src, row.id, res), title, row.id, label, res.msg));
  p.say(res.msg);
};
const initials = (n: string) => n.split(" ").map((x) => x[0]).slice(0, 2).join("").toUpperCase();

/* Front desk: arrivals, in house, departures */
const FrontDeskPage: React.FC<PageProps> = (p) => {
  const { data: d } = p;
  const today = off(0);
  const all = rows(d, "reservations");
  const arrivals = all.filter((r) => ["Confirmed", "Pending"].includes(String(r.status)) && String(r.arrive) <= today && String(r.depart) > today);
  const departures = all.filter((r) => r.status === "Checked in" && String(r.depart) <= today);
  const inHouse = all.filter((r) => r.status === "Checked in" && String(r.depart) > today);
  const person = (r: Row, meta: string, actions: React.ReactNode) => (
    <li key={r.id} className={styles.hzFdRow}>
      <span className={styles.hzFdAvatar}>{initials(hzGuestName(d, r.guest))}</span>
      <span className={styles.hzFdInfo}>
        <strong>{hzGuestName(d, r.guest)}{rows(d, "guests").find((g) => g.id === r.guest)?.vip === "Yes" ? <span className={styles.hzVip}>VIP</span> : null}</strong>
        <small>{meta}</small>
      </span>
      <span className={styles.hzFdActs}>{actions}</span>
    </li>
  );
  return (
    <>
      <Tiles tiles={[
        { label: "Arrivals", value: String(arrivals.length), note: `${arrivals.filter((r) => !r.room).length} need a room` },
        { label: "In house", value: String(inHouse.length + departures.length) },
        { label: "Departures", value: String(departures.length), note: money(sum(departures, (r) => Math.max(balanceOf(d, r.id), 0))) + " to collect" },
        { label: "Vacant & ready", value: String(rows(d, "rooms").filter((x) => ["Clean", "Inspected"].includes(String(x.state)) && !isOccupied(d, x.id)).length) },
      ]} />
      <div className={styles.hzCols3}>
        <HzPanel title={`Arrivals (${arrivals.length})`} note="Guests due today">
          <ul className={styles.hzFdList}>
            {arrivals.map((r) => person(r, `${nameOf(d, "roomtypes", r.roomType)} · ${nightsOf(r)}n · ${r.room ? `Room ${String(r.room)}` : "No room yet"}`, (
              <>
                {!r.room && <HzButton size="small" icon={<HzSparkle20Regular />} onClick={() => { const room = autoRoom(d, r); commit(p, "reservations", r, room ? { patch: { room }, msg: `Assistant picked room ${room} for ${hzGuestName(d, r.guest)}` } : { msg: "", err: `No ${nameOf(d, "roomtypes", r.roomType)} is free.` }, "Reservations", "Auto-assign"); }}>Assign</HzButton>}
                <HzButton size="small" appearance="primary" className={styles.hzPrimary} icon={<HzPersonArrowRight20Regular />} onClick={() => commit(p, "reservations", r, r.status === "Pending" ? { msg: "", err: "Confirm this reservation first." } : hzCheckIn(r, d), "Reservations", "Check in")}>Check in</HzButton>
              </>
            )))}
            {arrivals.length === 0 && <li className={styles.hzEmptyLi}>No arrivals waiting.</li>}
          </ul>
        </HzPanel>
        <HzPanel title={`Departures (${departures.length})`} note="Settle the folio, then check out">
          <ul className={styles.hzFdList}>
            {departures.map((r) => person(r, `Room ${String(r.room)} · ${money(Math.max(balanceOf(d, r.id), 0))} due`, (
              <>
                {balanceOf(d, r.id) > 0 && <HzButton size="small" icon={<HzCheckmarkCircle20Regular />} onClick={() => commit(p, "charges", r, { creates: [{ ent: "charges", values: { res: r.id, desc: "Payment (Card)", dept: "Payment", kind: "Payment", amount: balanceOf(d, r.id), date: today } }], msg: `${r.id} settled, ${money(balanceOf(d, r.id))} received` }, "Folios & billing", "Settle")}>Settle</HzButton>}
                <HzButton size="small" appearance="primary" className={styles.hzPrimary} icon={<HzPersonArrowLeft20Regular />} onClick={() => commit(p, "reservations", r, hzCheckOut(r, d), "Reservations", "Check out")}>Check out</HzButton>
              </>
            )))}
            {departures.length === 0 && <li className={styles.hzEmptyLi}>No departures due.</li>}
          </ul>
        </HzPanel>
        <HzPanel title={`In house (${inHouse.length})`} note="Staying past today">
          <ul className={styles.hzFdList}>
            {inHouse.map((r) => person(r, `Room ${String(r.room)} · until ${fshort(String(r.depart))} · ${money(Math.max(balanceOf(d, r.id), 0))} due`, <Pill text="Checked in" />))}
            {inHouse.length === 0 && <li className={styles.hzEmptyLi}>Nobody else in house.</li>}
          </ul>
        </HzPanel>
      </div>
    </>
  );
};

/* Tape chart */
const TapePage: React.FC<PageProps> = ({ data: d }) => {
  const [start, setStart] = useState(0);
  const [sel, setSel] = useState<string | null>(null);
  const N = 14;
  const first = off(start);
  const days = Array.from({ length: N }, (_, i) => hzAddDays(first, i));
  const live = rows(d, "reservations").filter((r) => ["Pending", "Confirmed", "Checked in", "Checked out"].includes(String(r.status)));
  const unassigned = live.filter((r) => !r.room && resActive(r));
  const picked = live.find((r) => r.id === sel);
  const cls = (s: string) => (s === "Checked in" ? styles.hzBarIn : s === "Confirmed" ? styles.hzBarConf : s === "Pending" ? styles.hzBarPend : styles.hzBarOut);
  return (
    <div className={styles.hzCard}>
      <div className={styles.hzPane}>
        <HzButton size="small" appearance="subtle" icon={<HzChevronLeft20Regular />} onClick={() => setStart(start - 7)} aria-label="Previous week" />
        <HzButton size="small" appearance="subtle" onClick={() => setStart(0)}>Today</HzButton>
        <HzButton size="small" appearance="subtle" icon={<HzChevronRight20Regular />} onClick={() => setStart(start + 7)} aria-label="Next week" />
        <strong className={styles.hzRange}>{fdate(first)} to {fdate(days[N - 1] ?? first)}</strong>
        <span className={styles.hzGrow} />
        <span className={styles.hzKey}><i className={styles.hzBarIn} />In house</span>
        <span className={styles.hzKey}><i className={styles.hzBarConf} />Confirmed</span>
        <span className={styles.hzKey}><i className={styles.hzBarPend} />Pending</span>
        <span className={styles.hzKey}><i className={styles.hzBarOut} />Departed</span>
      </div>
      <div className={styles.hzTape}>
        <div className={styles.hzTapeHead}>
          <span className={styles.hzTapeRoom}>Room</span>
          <div className={styles.hzTapeDays}>
            {days.map((x) => <span key={x} className={`${styles.hzTapeDay} ${x === off(0) ? styles.hzToday : ""}`}><small>{dow(x)}</small>{parseD(x).getDate()}</span>)}
          </div>
        </div>
        {rows(d, "rooms").map((room) => {
          const ooo = room.state === "Out of order";
          const mine = live.filter((r) => r.room === room.id && String(r.arrive) < (days[N - 1] ? hzAddDays(days[N - 1] ?? first, 1) : first) && String(r.depart) > first);
          return (
            <div key={room.id} className={styles.hzTapeRow}>
              <span className={styles.hzTapeRoom}><strong>{room.id}</strong><small>{nameOf(d, "roomtypes", room.type)}</small></span>
              <div className={styles.hzTapeLane} style={{ gridTemplateColumns: `repeat(${N}, 1fr)` }}>
                {ooo && <span className={styles.hzBarOoo} style={{ gridColumn: `1 / span ${N}` }}>Out of order</span>}
                {mine.map((r) => {
                  const a = Math.max(daysBetween(first, String(r.arrive)), 0);
                  const b = Math.min(daysBetween(first, String(r.depart)), N);
                  return (
                    <button key={r.id} type="button" className={`${styles.hzBar} ${cls(String(r.status))} ${sel === r.id ? styles.hzBarSel : ""}`} style={{ gridColumn: `${a + 1} / span ${Math.max(b - a, 1)}` }} onClick={() => setSel(r.id === sel ? null : r.id)} title={`${hzGuestName(d, r.guest)} · ${fshort(String(r.arrive))} to ${fshort(String(r.depart))}`}>
                      {hzGuestName(d, r.guest)}
                    </button>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles.hzFoot}>
        {picked ? (
          <span><strong>{hzGuestName(d, picked.guest)}</strong> · {picked.id} · Room {String(picked.room)} · {fdate(String(picked.arrive))} to {fdate(String(picked.depart))} · {money(resTotal(picked))} · <Pill text={String(picked.status)} /></span>
        ) : (
          <span>{unassigned.length ? `${unassigned.length} reservation${unassigned.length === 1 ? "" : "s"} without a room: ${unassigned.slice(0, 4).map((r) => hzGuestName(d, r.guest)).join(", ")}${unassigned.length > 4 ? "…" : ""}` : "Every active reservation has a room."} Select a bar for details.</span>
        )}
      </div>
    </div>
  );
};

/* Night audit */
const NightAuditPage: React.FC<PageProps> = (p) => {
  const { data: d } = p;
  const today = off(0);
  const stay = rows(d, "reservations").filter((r) => r.status === "Checked in" && String(r.depart) > today);
  const todo = stay.filter((r) => !rows(d, "charges").some((c) => c.res === r.id && c.dept === "Room" && c.date === today));
  const noShows = rows(d, "reservations").filter((r) => r.status === "Confirmed" && String(r.arrive) < today);
  const lateArr = rows(d, "reservations").filter((r) => r.status === "Confirmed" && r.arrive === today);
  const ran = rows(d, "audits").some((a) => a.date === today);
  const expected = sum(todo, (r) => num(r.rate));
  const run = () => {
    p.setData((x) => {
      let next: HzData = { ...x, charges: [...rows(x, "charges")] };
      todo.forEach((r) => { next = { ...next, charges: [...rows(next, "charges"), R(nextId("CG-", rows(next, "charges")), { res: r.id, desc: `Room charge · ${fdate(today)}`, dept: "Room", kind: "Charge", amount: num(r.rate), date: today })] }; });
      noShows.forEach((r) => { next = { ...next, reservations: rows(next, "reservations").map((y) => (y.id === r.id ? { ...y, status: "No-show", room: "" } : y)) }; });
      next = { ...next, audits: [R(nextId("NA-", rows(next, "audits")), { date: today, rooms: todo.length, revenue: expected, noshows: noShows.length, occ: occOn(next, today), by: "You" }), ...rows(next, "audits")] };
      return audit(next, "Night audit", today, "Night audit", `${todo.length} room charges posted, ${noShows.length} no-shows`);
    });
    p.say(`Night audit complete: ${todo.length} room charges, ${noShows.length} no-shows`);
  };
  return (
    <>
      <Tiles tiles={[
        { label: "Business date", value: fdate(today) }, { label: "Rooms to charge", value: String(todo.length), note: money(expected) },
        { label: "No-shows to mark", value: String(noShows.length) }, { label: "Last audit", value: rows(d, "audits")[0] ? fdate(String(rows(d, "audits")[0]?.date)) : "Never" },
      ]} />
      <div className={styles.hzCols2}>
        <HzPanel title="Before you run it" note="The audit posts tonight's room charge to every in-house folio and marks overdue arrivals as no-shows." action={<HzButton size="small" appearance="primary" className={styles.hzPrimary} icon={<HzWeatherMoon20Regular />} disabled={ran} onClick={run}>{ran ? "Already run today" : "Run night audit"}</HzButton>}>
          <ul className={styles.hzCheck}>
            <li className={lateArr.length ? styles.hzWarn : styles.hzOk}>{lateArr.length ? <HzWarning20Regular /> : <HzCheckmarkCircle20Regular />}{lateArr.length ? `${lateArr.length} arrival${lateArr.length === 1 ? " hasn't" : "s haven't"} checked in yet (${lateArr.map((r) => hzGuestName(d, r.guest)).join(", ")})` : "All of today's arrivals are checked in"}</li>
            <li className={noShows.length ? styles.hzWarn : styles.hzOk}>{noShows.length ? <HzWarning20Regular /> : <HzCheckmarkCircle20Regular />}{noShows.length ? `${noShows.length} earlier arrival${noShows.length === 1 ? "" : "s"} will be marked no-show` : "No overdue arrivals"}</li>
            <li className={todo.length ? styles.hzOk : styles.hzWarn}>{todo.length ? <HzCheckmarkCircle20Regular /> : <HzWarning20Regular />}{todo.length ? `${todo.length} room charge${todo.length === 1 ? "" : "s"} ready to post (${money(expected)})` : "No room charges left to post"}</li>
          </ul>
        </HzPanel>
        <HzPanel title="Audit history">
          <table className={styles.hzTbl}>
            <thead><tr><th>Date</th><th className={styles.hzRight}>Rooms</th><th className={styles.hzRight}>Revenue</th><th className={styles.hzRight}>No-shows</th><th className={styles.hzRight}>Occ.</th></tr></thead>
            <tbody>
              {rows(d, "audits").map((a) => <tr key={a.id}><td>{fdate(String(a.date))}</td><td className={styles.hzRight}>{num(a.rooms)}</td><td className={styles.hzRight}>{money(num(a.revenue))}</td><td className={styles.hzRight}>{num(a.noshows)}</td><td className={styles.hzRight}>{num(a.occ)}%</td></tr>)}
              {rows(d, "audits").length === 0 && <tr><td colSpan={5} className={styles.hzEmpty}>No audits yet.</td></tr>}
            </tbody>
          </table>
        </HzPanel>
      </div>
    </>
  );
};

/* Availability grid with stop-sell */
const AvailabilityPage: React.FC<PageProps> = (p) => {
  const { data: d } = p;
  const [start, setStart] = useState(0);
  const N = 14;
  const days = Array.from({ length: N }, (_, i) => off(start + i));
  const toggle = (rt: string, date: string) => {
    const id = `${rt}|${date}`;
    const closed = stopSold(d, rt, date);
    p.setData((x) => audit({ ...x, restrictions: closed ? rows(x, "restrictions").filter((r) => r.id !== id) : [...rows(x, "restrictions"), R(id, { rt, date })] }, "Availability", id, closed ? "Reopened" : "Stop-sell", `${nameOf(x, "roomtypes", rt)} ${closed ? "reopened" : "closed"} for ${fdate(date)}`));
    p.say(`${nameOf(d, "roomtypes", rt)} ${closed ? "reopened" : "closed"} for ${fdate(date)}`);
  };
  return (
    <div className={styles.hzCard}>
      <div className={styles.hzPane}>
        <HzButton size="small" appearance="subtle" icon={<HzChevronLeft20Regular />} onClick={() => setStart(start - 7)} aria-label="Previous week" />
        <HzButton size="small" appearance="subtle" onClick={() => setStart(0)}>Today</HzButton>
        <HzButton size="small" appearance="subtle" icon={<HzChevronRight20Regular />} onClick={() => setStart(start + 7)} aria-label="Next week" />
        <span className={styles.hzGrow} />
        <span className={styles.hzHint}>Select a cell to close or reopen that room type for sale.</span>
      </div>
      <div className={styles.hzAvScroll}>
        <table className={styles.hzAv}>
          <thead>
            <tr>
              <th className={styles.hzAvName}>Room type</th>
              {days.map((x) => <th key={x} className={x === off(0) ? styles.hzToday : undefined}><small>{dow(x)}</small>{parseD(x).getDate()}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows(d, "roomtypes").filter((t) => t.status === "Active").map((t) => (
              <React.Fragment key={t.id}>
                <tr>
                  <th className={styles.hzAvName}><strong>{String(t.name)}</strong><small>{roomsOf(d, t.id).length} rooms</small></th>
                  {days.map((x) => {
                    const free = availOn(d, t.id, x);
                    const closed = stopSold(d, t.id, x);
                    return (
                      <td key={x}>
                        <button type="button" className={`${styles.hzAvCell} ${closed ? styles.hzAvClosed : free <= 0 ? styles.hzAvFull : free <= 2 ? styles.hzAvLow : styles.hzAvOpen}`} onClick={() => toggle(t.id, x)} aria-label={`${String(t.name)} ${fdate(x)} ${closed ? "closed" : free + " available"}`}>
                          {closed ? "Closed" : Math.max(free, 0)}
                        </button>
                      </td>
                    );
                  })}
                </tr>
                <tr className={styles.hzAvRate}>
                  <th className={styles.hzAvName}>Rate</th>
                  {days.map((x) => { const a = rateAdj(d, x); return <td key={x}>{compact(num(t.base) * (1 + a / 100))}{a ? <small className={a > 0 ? styles.hzUp : styles.hzDown}>{a > 0 ? "+" : ""}{a}%</small> : null}</td>; })}
                </tr>
              </React.Fragment>
            ))}
            <tr className={styles.hzAvTotal}>
              <th className={styles.hzAvName}>Occupancy</th>
              {days.map((x) => <td key={x}>{occOn(d, x)}%</td>)}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

/* Revenue AI */
const RevenueAiPage: React.FC<PageProps> = (p) => {
  const { data: d } = p;
  const adv = priceAdvice(d);
  const avgBase = rows(d, "roomtypes").length ? sum(rows(d, "roomtypes"), (t) => num(t.base)) / rows(d, "roomtypes").length : 0;
  const open = adv.filter((s) => s.adj !== rateAdj(d, s.date));
  const uplift = sum(open.map((s) => R(s.date, { v: (booked(d, s.date) * avgBase * (s.adj - rateAdj(d, s.date))) / 100 })), (x) => num(x.v));
  const write = (list: Suggest[], reset: boolean) => {
    p.setData((x) => {
      const keep = rows(x, "pricing").filter((r) => !list.some((s) => s.date === r.id));
      const add = reset ? [] : list.filter((s) => s.adj !== 0).map((s) => R(s.date, { adj: s.adj }));
      return audit({ ...x, pricing: [...keep, ...add] }, "Revenue AI", "—", reset ? "Rates reset" : "Rates applied", `${list.length} day${list.length === 1 ? "" : "s"} ${reset ? "reset to base" : "updated"}`);
    });
    p.say(reset ? "Rates reset to base" : `${list.length} day${list.length === 1 ? "" : "s"} updated`);
  };
  return (
    <>
      <Tiles tiles={[
        { label: "Days to review", value: String(open.length) }, { label: "Peak days", value: String(adv.filter((s) => s.adj >= 12).length) },
        { label: "Soft days", value: String(adv.filter((s) => s.adj < 0).length) }, { label: "Estimated effect", value: `${uplift >= 0 ? "+" : "−"}${compact(Math.abs(uplift))}`, note: "on rooms already booked" },
      ]} />
      <div className={styles.hzCard}>
        <div className={styles.hzPane}>
          <span className={styles.hzAiHead}><HzSparkle20Regular /> Suggested rate changes for the next 14 days</span>
          <span className={styles.hzGrow} />
          <HzButton size="small" appearance="subtle" icon={<HzArrowUndo20Regular />} onClick={() => write(adv, true)}>Reset to base</HzButton>
          <HzButton size="small" appearance="primary" className={styles.hzPrimary} icon={<HzCheckmark20Regular />} disabled={open.length === 0} onClick={() => write(open, false)}>Apply all ({open.length})</HzButton>
        </div>
        <div className={styles.hzGridWrap}>
          <table className={styles.hzGrid}>
            <thead><tr><th>Date</th><th>Occupancy</th><th className={styles.hzRight}>Current</th><th className={styles.hzRight}>Suggested</th><th>Why</th><th /></tr></thead>
            <tbody>
              {adv.map((s) => {
                const cur = rateAdj(d, s.date);
                return (
                  <tr key={s.date}>
                    <td>{dow(s.date)} {fshort(s.date)}</td>
                    <td><UseBar pct={s.occ} /></td>
                    <td className={styles.hzRight}>{cur > 0 ? "+" : ""}{cur}%</td>
                    <td className={`${styles.hzRight} ${s.adj > 0 ? styles.hzUp : s.adj < 0 ? styles.hzDown : ""}`}><strong>{s.adj > 0 ? "+" : ""}{s.adj}%</strong></td>
                    <td>{s.why}</td>
                    <td className={styles.hzRight}>{s.adj === cur ? <Pill text="Active" /> : <HzButton size="small" onClick={() => write([s], false)}>Apply</HzButton>}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className={styles.hzFoot}><span>Suggestions are rules based on how full each night is. Rates you apply show on the Availability page.</span></div>
      </div>
    </>
  );
};

/* Reports */
const Bars: React.FC<{ items: { label: string; value: number; text?: string }[] }> = ({ items }) => {
  const mx = Math.max(...items.map((i) => i.value), 1);
  return (
    <ul className={styles.hzBars}>
      {items.map((i) => (
        <li key={i.label}><span className={styles.hzBarLabel}>{i.label}</span><span className={styles.hzBarTrack}><span className={styles.hzBarFill} style={{ width: `${Math.max((i.value / mx) * 100, i.value > 0 ? 3 : 0)}%` }} /></span><span className={styles.hzBarVal}>{i.text ?? String(i.value)}</span></li>
      ))}
      {items.length === 0 && <li className={styles.hzEmptyLi}>Nothing to show yet.</li>}
    </ul>
  );
};
const PerformancePage: React.FC<PageProps> = ({ data: d }) => {
  const k = kpis(d, 7);
  const today = off(0);
  const days = Array.from({ length: 14 }, (_, i) => off(i));
  const dept: Record<string, number> = {};
  rows(d, "charges").filter((c) => c.kind === "Charge" && String(c.date) >= off(-29)).forEach((c) => { dept[String(c.dept)] = (dept[String(c.dept)] ?? 0) + num(c.amount); });
  const guestSpend: Record<string, number> = {};
  rows(d, "charges").filter((c) => c.kind === "Charge").forEach((c) => { const r = rows(d, "reservations").find((x) => x.id === c.res); if (r) guestSpend[String(r.guest)] = (guestSpend[String(r.guest)] ?? 0) + num(c.amount); });
  const top = Object.entries(guestSpend).sort((a, b) => b[1] - a[1]).slice(0, 5);
  return (
    <>
      <Tiles tiles={[
        { label: "Occupancy tonight", value: `${occOn(d, today)}%`, note: `${booked(d, today)} of ${inService(d)} rooms` }, { label: "ADR (7 days)", value: compact(k.adr) },
        { label: "RevPAR (7 days)", value: compact(k.revpar) }, { label: "Revenue (7 days)", value: compact(k.total), note: `rooms ${compact(k.rev)}` },
        { label: "Rating", value: rows(d, "feedback").length ? (sum(rows(d, "feedback"), (f) => num(f.rating)) / rows(d, "feedback").length).toFixed(1) : "—", note: "guest reviews" },
      ]} />
      <HzPanel title="Occupancy, next 14 days" note="Share of rooms booked each night" wide>
        <div className={styles.hzColChart}>
          {days.map((x) => {
            const o = occOn(d, x);
            return (
              <div key={x} className={styles.hzColItem} title={`${dow(x)} ${fshort(x)}: ${o}%`}>
                <span className={styles.hzColVal}>{o}%</span>
                <span className={styles.hzColTrack}><span className={`${styles.hzColBar} ${o >= 80 ? styles.hzColHigh : ""}`} style={{ height: `${Math.max(o, 2)}%` }} /></span>
                <span className={styles.hzColDay}>{dow(x)}<br />{parseD(x).getDate()}</span>
              </div>
            );
          })}
        </div>
      </HzPanel>
      <div className={styles.hzCols3}>
        <HzPanel title="Revenue by department" note="Last 30 days">
          <Bars items={Object.entries(dept).sort((a, b) => b[1] - a[1]).map(([label, value]) => ({ label, value, text: compact(value) }))} />
        </HzPanel>
        <HzPanel title="Booking sources" note="Reservations by value">
          <Bars items={SOURCES.map((s) => ({ label: s.v, value: sum(rows(d, "reservations").filter((r) => r.source === s.v && r.status !== "Cancelled" && r.status !== "No-show"), resTotal) })).filter((x) => x.value > 0).sort((a, b) => b.value - a.value).slice(0, 6).map((x) => ({ ...x, text: compact(x.value) }))} />
        </HzPanel>
        <HzPanel title="Top guests by spend" note="All time">
          <Bars items={top.map(([g, v]) => ({ label: hzGuestName(d, g), value: v, text: compact(v) }))} />
        </HzPanel>
      </div>
    </>
  );
};
const RevenuePage: React.FC<PageProps> = ({ data: d }) => {
  const [days, setDays] = useState("30");
  const from = off(-(Number(days) - 1));
  const rc = roomCharges(d, from, off(0));
  const resOf = (c: Row) => rows(d, "reservations").find((r) => r.id === c.res);
  const byType = rows(d, "roomtypes").map((t) => {
    const l = rc.filter((c) => resOf(c)?.roomType === t.id);
    const rev = sum(l, (c) => num(c.amount));
    return { t, nights: l.length, rev, adr: l.length ? rev / l.length : 0, avail: roomsOf(d, t.id).length * Number(days) };
  });
  const total = byType.reduce((t, x) => t + x.rev, 0);
  const srcs = SOURCES.map((s) => { const l = rc.filter((c) => resOf(c)?.source === s.v); return { s: s.v, nights: l.length, rev: sum(l, (c) => num(c.amount)) }; }).filter((x) => x.nights > 0).sort((a, b) => b.rev - a.rev);
  return (
    <div className={styles.hzCols2}>
      <HzPanel title="By room type" action={<HzSelect size="small" className={styles.hzSelSm} value={days} onChange={(_, dd) => setDays(dd.value)} aria-label="Period"><option value="7">Last 7 days</option><option value="30">Last 30 days</option><option value="90">Last 90 days</option></HzSelect>}>
        <table className={styles.hzTbl}>
          <thead><tr><th>Type</th><th className={styles.hzRight}>Nights</th><th className={styles.hzRight}>Revenue</th><th className={styles.hzRight}>ADR</th><th className={styles.hzRight}>Occ.</th></tr></thead>
          <tbody>
            {byType.map((x) => <tr key={x.t.id}><td>{String(x.t.name)}</td><td className={styles.hzRight}>{x.nights}</td><td className={styles.hzRight}>{money(x.rev)}</td><td className={styles.hzRight}>{money(x.adr)}</td><td className={styles.hzRight}>{pct(x.nights, x.avail)}%</td></tr>)}
            <tr className={styles.hzTotalRow}><td>Total</td><td className={styles.hzRight}>{byType.reduce((t, x) => t + x.nights, 0)}</td><td className={styles.hzRight}>{money(total)}</td><td colSpan={2} /></tr>
          </tbody>
        </table>
      </HzPanel>
      <HzPanel title="By source" note="Room revenue in the same period">
        <table className={styles.hzTbl}>
          <thead><tr><th>Source</th><th className={styles.hzRight}>Nights</th><th className={styles.hzRight}>Revenue</th><th className={styles.hzRight}>Share</th></tr></thead>
          <tbody>
            {srcs.map((x) => <tr key={x.s}><td>{x.s}</td><td className={styles.hzRight}>{x.nights}</td><td className={styles.hzRight}>{money(x.rev)}</td><td className={styles.hzRight}>{pct(x.rev, total)}%</td></tr>)}
            {srcs.length === 0 && <tr><td colSpan={4} className={styles.hzEmpty}>No room revenue in this period.</td></tr>}
          </tbody>
        </table>
      </HzPanel>
    </div>
  );
};

/* Reorder AI */
const ReorderPage: React.FC<PageProps> = (p) => {
  const { data: d } = p;
  const list = reorderList(d);
  const create = () => {
    p.setData((x) => {
      let next = x;
      list.forEach((l) => { next = { ...next, orders: [...rows(next, "orders"), R(nextId("PO-", rows(next, "orders")), { supplier: String(l.item.supplier), item: l.item.id, qty: l.qty, cost: num(l.item.cost), date: off(0), expected: off(5), status: "Draft" })] }; });
      return audit(next, "Reorder AI", "—", "Draft orders", `${list.length} draft order${list.length === 1 ? "" : "s"} created`);
    });
    p.say(`${list.length} draft order${list.length === 1 ? "" : "s"} created in Purchase orders`);
  };
  return (
    <div className={styles.hzCard}>
      <div className={styles.hzPane}>
        <span className={styles.hzAiHead}><HzSparkle20Regular /> Items at or below their reorder level</span>
        <span className={styles.hzGrow} />
        <HzButton size="small" appearance="primary" className={styles.hzPrimary} icon={<HzCart20Regular />} disabled={list.length === 0} onClick={create}>Create draft orders ({list.length})</HzButton>
      </div>
      <div className={styles.hzGridWrap}>
        <table className={styles.hzGrid}>
          <thead><tr><th>Item</th><th className={styles.hzRight}>On hand</th><th className={styles.hzRight}>Reorder at</th><th className={styles.hzRight}>Par</th><th className={styles.hzRight}>Suggested qty</th><th>Supplier</th><th className={styles.hzRight}>Estimate</th></tr></thead>
          <tbody>
            {list.map((l) => (
              <tr key={l.item.id}><td>{String(l.item.name)}</td><td className={styles.hzRight}>{num(l.item.qty)} {String(l.item.unit)}</td><td className={styles.hzRight}>{num(l.item.reorder)}</td><td className={styles.hzRight}>{num(l.item.par)}</td><td className={styles.hzRight}><strong>{l.qty}</strong></td><td>{nameOf(d, "suppliers", l.item.supplier)}</td><td className={styles.hzRight}>{money(l.cost)}</td></tr>
            ))}
            {list.length === 0 && <tr><td colSpan={7} className={styles.hzEmpty}>Everything is above its reorder level, or already on order.</td></tr>}
          </tbody>
        </table>
      </div>
      <div className={styles.hzFoot}><span>Quantity brings each item back up to its par level. Items with an open order are skipped. Total estimate {money(sum(list.map((l) => R(l.item.id, { c: l.cost })), (x) => num(x.c)))}.</span></div>
    </div>
  );
};

/* AI assistant */
const SUGGESTED = ["What should I focus on today?", "Who is arriving today?", "Show departures", "How is occupancy?", "Which rooms are dirty?", "Revenue this week", "Suggest rate changes", "What stock is low?", "Summarise Adaeze Okafor", "How is guest feedback?"];
const AssistantPage: React.FC<PageProps> = ({ data, setData }) => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const endRef = useRef<HTMLDivElement>(null);
  const msgs = rows(data, "chat");
  useEffect(() => { endRef.current?.scrollIntoView?.({ block: "end" }); }, [msgs.length, busy]);
  const send = (q: string) => {
    const t = q.trim();
    if (!t || busy) return;
    setText("");
    setBusy(true);
    setData((d) => ({ ...d, chat: [...rows(d, "chat"), R(`M-${rows(d, "chat").length + 1}`, { role: "user", text: t })] }));
    window.setTimeout(() => {
      setData((d) => ({ ...d, chat: [...rows(d, "chat"), R(`M-${rows(d, "chat").length + 1}`, { role: "ai", text: hzAsk(t, d) })] }));
      setBusy(false);
    }, 500);
  };
  return (
    <div className={styles.hzAiPage}>
      <div className={`${styles.hzCard} ${styles.hzChat}`}>
        <div className={styles.hzMsgs} role="log" aria-live="polite" aria-label="Conversation">
          {msgs.map((m) => (
            <div key={m.id} className={`${styles.hzMsg} ${m.role === "user" ? styles.hzMsgUser : styles.hzMsgAi}`}>
              {m.role === "ai" && <span className={styles.hzAvatar}><HzSparkle20Regular /></span>}
              <div className={styles.hzBubble}>{String(m.text)}</div>
            </div>
          ))}
          {busy && <div className={`${styles.hzMsg} ${styles.hzMsgAi}`}><span className={styles.hzAvatar}><HzSparkle20Regular /></span><div className={styles.hzBubble}>Thinking…</div></div>}
          <div ref={endRef} />
        </div>
        <form className={styles.hzAsk} onSubmit={(e) => { e.preventDefault(); send(text); }}>
          <HzInput className={styles.hzAskInput} placeholder="Ask about arrivals, rooms, revenue, stock or a guest" value={text} onChange={(_, dd) => setText(dd.value)} aria-label="Ask the assistant" />
          <HzButton size="small" type="submit" className={styles.hzPrimary} appearance="primary" icon={<HzSend20Regular />} disabled={!text.trim() || busy}>Send</HzButton>
        </form>
      </div>
      <div className={styles.hzSide}>
        <HzPanel title="Try asking">
          <div className={styles.hzChips}>{SUGGESTED.map((s) => <button key={s} type="button" className={styles.hzChip} onClick={() => send(s)}>{s}</button>)}</div>
        </HzPanel>
        <HzPanel title="Needs attention">
          <ul className={styles.hzInsights}>{hzInsights(data).slice(0, 5).map((s) => <li key={s}><HzSparkle20Regular />{s}</li>)}</ul>
        </HzPanel>
      </div>
    </div>
  );
};

/* ---------- navigation ---------- */
interface SubPage { id: string; title: string; subtitle: string }
const entHead = (id: string): SubPage => { const e = ENTS.find((x) => x.id === id); return { id, title: e?.title ?? id, subtitle: e?.subtitle ?? "" }; };
const CUSTOM: Record<string, { title: string; subtitle: string; tab: string; render: React.FC<PageProps> }> = {
  Tape: { title: "Tape chart", subtitle: "Every room across the next two weeks.", tab: "Tape chart", render: TapePage },
  FrontDesk: { title: "Front desk", subtitle: "Today's arrivals, departures and guests in house.", tab: "Front desk", render: FrontDeskPage },
  NightAudit: { title: "Night audit", subtitle: "Close the business day and post room charges.", tab: "Night audit", render: NightAuditPage },
  Availability: { title: "Availability", subtitle: "Rooms left by type, with rates and stop-sell.", tab: "Availability", render: AvailabilityPage },
  RevenueAI: { title: "Revenue AI", subtitle: "Rate suggestions based on how full each night is.", tab: "Revenue AI", render: RevenueAiPage },
  Performance: { title: "Performance", subtitle: "Occupancy, ADR, RevPAR and where revenue comes from.", tab: "Performance", render: PerformancePage },
  Revenue: { title: "Revenue", subtitle: "Room revenue by type and booking source.", tab: "Revenue", render: RevenuePage },
  Reorder: { title: "Reorder AI", subtitle: "Items to restock and ready-made draft orders.", tab: "Reorder AI", render: ReorderPage },
  Assistant: { title: "AI assistant", subtitle: "Ask about the property in plain language.", tab: "Assistant", render: AssistantPage },
};
const HZ_NAV: Record<string, { id: string; label: string }[]> = {
  Reservations: [{ id: "Reservations", label: "Reservations" }, { id: "Tape", label: "Tape chart" }, { id: "Group blocks", label: "Group blocks" }, { id: "Waitlist", label: "Waitlist" }],
  Operations: [{ id: "FrontDesk", label: "Front desk" }, { id: "Housekeeping", label: "Housekeeping" }, { id: "Maintenance", label: "Maintenance" }, { id: "NightAudit", label: "Night audit" }, { id: "Staff & shifts", label: "Staff & shifts" }, { id: "Lost & found", label: "Lost & found" }],
  Guest: [{ id: "Guests", label: "Guests" }, { id: "Folios & billing", label: "Folios & billing" }, { id: "Loyalty", label: "Loyalty" }, { id: "Feedback", label: "Feedback" }, { id: "Messages", label: "Messages" }],
  "Clients Relations": [{ id: "Corporate accounts", label: "Corporate accounts" }, { id: "Travel agents", label: "Travel agents" }, { id: "Promotions", label: "Promotions" }, { id: "Complaints", label: "Complaints" }],
  Booking: [{ id: "Availability", label: "Availability" }, { id: "Rate plans", label: "Rate plans" }, { id: "Room types", label: "Room types" }, { id: "Channels", label: "Channels" }, { id: "Web bookings", label: "Web bookings" }, { id: "RevenueAI", label: "Revenue AI" }],
  Reports: [{ id: "Performance", label: "Performance" }, { id: "Revenue", label: "Revenue" }, { id: "Audit log", label: "Audit log" }],
  Inventory: [{ id: "Stock items", label: "Stock items" }, { id: "Reorder", label: "Reorder AI" }, { id: "Purchase orders", label: "Purchase orders" }, { id: "Suppliers", label: "Suppliers" }, { id: "Stock movements", label: "Movements" }],
  "AI assistant": [{ id: "Assistant", label: "Assistant" }],
};

const HospitalityPages: React.FC<{ tab: string }> = ({ tab }) => {
  const { user } = useAuth();
  const [data, setData] = useHzData();
  const [subs, setSubs] = useState<Record<string, string>>({});
  const [toast, setToast] = useState<{ msg: string; err: boolean } | null>(null);
  useEffect(() => {
    if (!toast) return;
    const t = window.setTimeout(() => setToast(null), 3500);
    return () => window.clearTimeout(t);
  }, [toast]);
  const say = (msg: string, err = false) => setToast({ msg, err });
  // loads every screen from the database, keeps it fresh, and reports save errors
  const hz = useHzBoot({ token: user?.token ?? localStorage.getItem("authToken") ?? undefined, say });
  const items = HZ_NAV[tab] ?? [];
  const cur = subs[tab] ?? items[0]?.id ?? "";
  const custom = CUSTOM[cur];
  const entDef = ENTS.find((e) => e.id === cur);
  const head = custom ? { title: custom.title, subtitle: custom.subtitle } : entHead(cur);
  const p: PageProps = { data, setData, say };
  const Custom = custom?.render;
  return (
    <div className={styles.hzShell}>
      <div className={styles.hzHost}>
        {hz.loading && !hz.loadedAt && (
          <div role="status" aria-busy="true" aria-label="Loading hotel data" style={{ display: "grid", gap: 16, padding: "8px 0" }}>
            <Skeleton aria-hidden>
              <SkeletonItem shape="rectangle" size={28} style={{ width: "30%", maxWidth: 260 }} />
            </Skeleton>
            <Skeleton aria-hidden style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 12 }}>
              {[0, 1, 2, 3].map((i) => <SkeletonItem key={i} shape="rectangle" size={72} />)}
            </Skeleton>
            <Skeleton aria-hidden style={{ display: "grid", gap: 10 }}>
              {[0, 1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} style={{ display: "grid", gridTemplateColumns: "40px 2fr 1fr 1fr 1fr", gap: 12, alignItems: "center" }}>
                  <SkeletonItem shape="circle" size={32} />
                  <SkeletonItem size={16} />
                  <SkeletonItem size={16} />
                  <SkeletonItem size={16} />
                  <SkeletonItem size={16} />
                </div>
              ))}
            </Skeleton>
          </div>
        )}
        {!hz.loading && !hz.loadedAt && hz.error && (
          <p role="alert" className={styles.hzHint}>
            {hz.error} <button type="button" onClick={() => void hzReload()}>Try again</button>
          </p>
        )}
        {hz.saving > 0 && <p role="status" className={styles.hzHint}>Saving…</p>}
        {items.length > 1 && (
          <HzTabList className={styles.hzSubnav} size="small" selectedValue={cur} onTabSelect={(_, dd) => setSubs({ ...subs, [tab]: String(dd.value) })}>
            {items.map((i) => <HzTab key={i.id} value={i.id}>{i.label}</HzTab>)}
          </HzTabList>
        )}
        <div className={styles.hzPg}>
          <header className={styles.hzHead}>
            <h2 className={styles.hzTitle}>{head.title}</h2>
            <p className={styles.hzSub}>{head.subtitle}</p>
          </header>
          {entDef && <EntityPage key={entDef.id} ent={entDef} {...p} />}
          {Custom && <Custom key={cur} {...p} />}
        </div>
      </div>
      {toast && <div className={`${styles.hzToast} ${toast.err ? styles.hzToastErr : ""}`} role="status" aria-live="polite">{toast.msg}</div>}
    </div>
  );
};


/* ---------- HMS quick actions (Check-In, Check-Out, Discount, Room state, Service charge, New guest) ---------- */
const ID_TYPES = opts("National ID", "International passport", "Driver's licence", "Voter's card");
const resLabel = (d: HzData, r: Row) => `${r.id} · ${hzGuestName(d, r.guest)} · ${nameOf(d, "roomtypes", r.roomType)}${r.room ? ` · Rm ${String(r.room)}` : ""}`;
const resOpts = (pred: (r: Row) => boolean) => (d: HzData): Opt[] => rows(d, "reservations").filter(pred).map((r) => ({ v: r.id, l: resLabel(d, r) }));
const Peek: React.FC<{ lines: [string, string][]; tone?: "ok" | "warn" }> = ({ lines, tone }) => (
  <div className={`${styles.hzPeek} ${tone === "warn" ? styles.hzWarn : ""}`}>
    {lines.map(([k, v]) => <div key={k} className={styles.hzPeekRow}><span>{k}</span><strong>{v}</strong></div>)}
  </div>
);
const usablePromo = (p: Row) => p.status === "Active" && String(p.from) <= off(0) && off(0) <= String(p.to) && num(p.used) < num(p.limit);

const HzQuick: React.FC<{ action: string | null; onClose: () => void }> = ({ action, onClose }) => {
  const [data, setData] = useHzData();
  const [toast, setToast] = useState<string | null>(null);
  useEffect(() => {
    if (!toast) return;
    const t = window.setTimeout(() => setToast(null), 3500);
    return () => window.clearTimeout(t);
  }, [toast]);
  const d = data;
  const today = off(0);
  const commitRes = (src: string, row: Row, res: Res, title: string, label: string): string | null => {
    if (res.err) return res.err;
    setData((x) => audit(apply(x, src, row.id, res), title, row.id, label, res.msg));
    setToast(res.msg);
    onClose();
    return null;
  };
  const find = (id: Val | undefined) => rows(d, "reservations").find((r) => r.id === String(id));
  const first = (pred: (r: Row) => boolean) => rows(d, "reservations").find(pred)?.id ?? "";

  let dialog: React.ReactNode = null;
  if (action === "checkin") {
    dialog = (
      <RecordDialog key={action} title="Check-in guest" submit="Check in" data={d} onClose={onClose}
        initial={{ res: first((r) => r.status === "Confirmed" && String(r.arrive) <= today), room: "", idType: "National ID" }}
        fields={[
          { key: "res", label: "Arriving reservation", kind: "select", required: true, full: true, options: resOpts((r) => r.status === "Confirmed" && String(r.arrive) <= today && String(r.depart) > today) },
          { key: "room", label: "Room (blank keeps assigned or auto-picks)", kind: "select", full: true, options: (x) => rows(x, "rooms").filter((m) => m.state !== "Out of order").map((m) => ({ v: m.id, l: `${m.id} · ${nameOf(x, "roomtypes", m.type)} · ${String(m.state)}${isOccupied(x, m.id) ? " · occupied" : ""}` })) },
          { key: "idType", label: "ID type", kind: "select", required: true, options: ID_TYPES },
          { key: "idNumber", label: "ID number", kind: "text", required: true },
          { key: "deposit", label: "Deposit received (₦)", kind: "number" },
          { key: "notes", label: "Notes", kind: "text", full: true },
        ]}
        extra={(v) => {
          const r = find(v.res);
          if (!r) return <p className={styles.hzHint}>No arrivals are waiting to check in.</p>;
          const sug = r.room ? String(r.room) : autoRoom(d, r);
          return <Peek lines={[["Guest", hzGuestName(d, r.guest)], ["Stay", `${nightsOf(r)} night${nightsOf(r) === 1 ? "" : "s"}, until ${fdate(String(r.depart))}`], ["Rate", `${money(num(r.rate))} per night`], [r.room ? "Assigned room" : "Suggested room", sug ?? "None free"]]} />;
        }}
        onSave={(v) => {
          const r = find(v.res);
          if (!r) return "Choose a reservation.";
          const room = String(v.room || r.room || autoRoom(d, r) || "");
          if (!room) return `No ${nameOf(d, "roomtypes", r.roomType)} is ready. Pick a room.`;
          const rm = rows(d, "rooms").find((m) => m.id === room);
          if (rm && rm.type !== r.roomType) return `Room ${room} is a ${nameOf(d, "roomtypes", rm.type)}. This booking is for ${nameOf(d, "roomtypes", r.roomType)}.`;
          if (!roomFree(d, room, String(r.arrive), String(r.depart), r.id)) return `Room ${room} is booked for those dates.`;
          if (num(v.deposit) < 0) return "Deposit can't be negative.";
          const res = hzCheckIn({ ...r, room }, d);
          if (res.err) return res.err;
          const creates: NonNullable<Res["creates"]> = num(v.deposit) > 0 ? [{ ent: "charges", values: { res: r.id, desc: "Deposit (Cash)", dept: "Payment", kind: "Payment", amount: num(v.deposit), date: today } }] : [];
          return commitRes("reservations", r, { ...res, patch: { ...(res.patch ?? {}), room, idType: String(v.idType), idNumber: String(v.idNumber), notes: String(v.notes ?? "") }, creates }, "Reservations", "Check in");
        }} />
    );
  } else if (action === "checkout") {
    dialog = (
      <RecordDialog key={action} title="Check-out guest" submit="Check out" data={d} onClose={onClose}
        initial={{ res: first((r) => r.status === "Checked in" && String(r.depart) <= today) || first((r) => r.status === "Checked in"), method: "Card" }}
        fields={[
          { key: "res", label: "In-house guest", kind: "select", required: true, full: true, options: resOpts((r) => r.status === "Checked in") },
          { key: "method", label: "Pay balance by", kind: "select", required: true, options: opts("Cash", "Card", "Transfer", "Corporate bill") },
        ]}
        extra={(v) => {
          const r = find(v.res);
          if (!r) return <p className={styles.hzHint}>Nobody is checked in.</p>;
          const bal = balanceOf(d, r.id);
          return (
            <>
              <FolioLines d={d} res={r.id} />
              <Peek tone={bal > 0 ? "warn" : "ok"} lines={[["Balance to collect", money(Math.max(bal, 0))], ["Loyalty points earned", String(Math.floor(resTotal(r) / 1000))], ["Room after check-out", `${String(r.room)} goes to housekeeping`]]} />
            </>
          );
        }}
        onSave={(v) => {
          const r = find(v.res);
          if (!r) return "Choose a guest.";
          const bal = balanceOf(d, r.id);
          const pay: Row | null = bal > 0 ? R("tmp", { res: r.id, desc: `Payment (${String(v.method)})`, dept: "Payment", kind: "Payment", amount: bal, date: today }) : null;
          const res = hzCheckOut(r, pay ? { ...d, charges: [...rows(d, "charges"), pay] } : d);
          if (res.err) return res.err;
          return commitRes("reservations", r, { ...res, creates: pay ? [{ ent: "charges", values: { res: r.id, desc: String(pay.desc), dept: "Payment", kind: "Payment", amount: bal, date: today } }] : [] }, "Reservations", "Check out");
        }} />
    );
  } else if (action === "discount") {
    const calc = (r: Row, v: Record<string, Val>): { amt: number; label: string } | string => {
      const promo = rows(d, "promos").find((p) => p.id === v.promo);
      const base = resTotal(r);
      if (promo) {
        if (!usablePromo(promo)) return "That promotion isn't valid today.";
        return { amt: promo.kind === "Percent" ? Math.round((base * num(promo.value)) / 100) : num(promo.value), label: String(promo.code) };
      }
      const val = num(v.value);
      if (val <= 0) return "Enter a discount value or choose a promotion.";
      if (!String(v.reason ?? "").trim()) return "Give a reason for a manual discount.";
      if (v.kind === "Percent" && val > 100) return "A percentage can't exceed 100.";
      return { amt: v.kind === "Percent" ? Math.round((base * val) / 100) : val, label: String(v.reason) };
    };
    dialog = (
      <RecordDialog key={action} title="Discount / promo" submit="Apply discount" data={d} onClose={onClose}
        initial={{ res: first((r) => r.status === "Checked in") || first(resActive), kind: "Percent" }}
        fields={[
          { key: "res", label: "Reservation", kind: "select", required: true, full: true, options: resOpts(resActive) },
          { key: "promo", label: "Promotion code", kind: "select", full: true, options: (x) => rows(x, "promos").filter(usablePromo).map((p) => ({ v: p.id, l: `${String(p.code)} · ${String(p.name)} (${p.kind === "Percent" ? `${num(p.value)}%` : money(num(p.value))})` })) },
          { key: "kind", label: "Or manual type", kind: "select", options: opts("Percent", "Fixed") },
          { key: "value", label: "Manual value", kind: "number" },
          { key: "reason", label: "Reason (manual only)", kind: "text", full: true },
        ]}
        extra={(v) => {
          const r = find(v.res);
          if (!r) return null;
          const c = calc(r, v);
          return typeof c === "string" ? <p className={styles.hzHint}>{c}</p> : <Peek lines={[["Stay total", money(resTotal(r))], ["Discount", `−${money(c.amt)}`], ["New total", money(Math.max(resTotal(r) - c.amt, 0))]]} />;
        }}
        onSave={(v) => {
          const r = find(v.res);
          if (!r) return "Choose a reservation.";
          const c = calc(r, v);
          if (typeof c === "string") return c;
          if (c.amt <= 0 || c.amt >= resTotal(r)) return "The discount must be more than zero and less than the stay total.";
          const promo = rows(d, "promos").find((p) => p.id === v.promo);
          const other: NonNullable<Res["other"]> = promo ? [{ ent: "promos", id: promo.id, patch: { used: num(promo.used) + 1 } }] : [];
          if (r.status === "Checked in") return commitRes("reservations", r, { creates: [{ ent: "charges", values: { res: r.id, desc: `Discount · ${c.label}`, dept: "Discount", kind: "Charge", amount: -c.amt, date: today } }], other, msg: `${money(c.amt)} discount applied to ${r.id}` }, "Reservations", "Discount");
          return commitRes("reservations", r, { patch: { rate: Math.max(Math.round(num(r.rate) - c.amt / nightsOf(r)), 1) }, other, msg: `${money(c.amt)} discount applied, nightly rate lowered on ${r.id}` }, "Reservations", "Discount");
        }} />
    );
  } else if (action === "roomstate") {
    dialog = (
      <RecordDialog key={action} title="Manage room state" submit="Update room" data={d} onClose={onClose}
        initial={{ room: "", state: "Clean", priority: "Medium" }}
        fields={[
          { key: "room", label: "Room", kind: "select", required: true, full: true, options: (x) => rows(x, "rooms").map((m) => ({ v: m.id, l: `${m.id} · ${nameOf(x, "roomtypes", m.type)} · ${String(m.state)}${isOccupied(x, m.id) ? " · occupied" : ""}` })) },
          { key: "state", label: "New state", kind: "select", required: true, options: opts("Clean", "Dirty", "Inspected", "Out of order") },
          { key: "priority", label: "Repair priority", kind: "select", options: opts("Low", "Medium", "High") },
          { key: "issue", label: "Problem (needed for out of order)", kind: "text", full: true },
        ]}
        extra={(v) => {
          const m = rows(d, "rooms").find((x) => x.id === v.room);
          return m ? <Peek lines={[["Room", `${m.id} · ${nameOf(d, "roomtypes", m.type)}`], ["Now", `${String(m.state)}${isOccupied(d, m.id) ? ", occupied" : ", vacant"}`]]} /> : null;
        }}
        onSave={(v) => {
          const m = rows(d, "rooms").find((x) => x.id === v.room);
          if (!m) return "Choose a room.";
          const to = String(v.state);
          if (m.state === to) return `Room ${m.id} is already ${to.toLowerCase()}.`;
          if (to === "Out of order") {
            if (isOccupied(d, m.id)) return "A guest is in this room. Move them first.";
            if (rows(d, "reservations").some((x) => x.room === m.id && resActive(x) && String(x.depart) > today)) return `Room ${m.id} has upcoming reservations. Move them first.`;
            if (!String(v.issue ?? "").trim()) return "Describe the problem so maintenance can fix it.";
            return commitRes("rooms", m, { patch: { state: "Out of order" }, creates: [{ ent: "workorders", values: { room: m.id, issue: String(v.issue), priority: String(v.priority || "Medium"), assigned: "", status: "Open", reported: today } }], msg: `Room ${m.id} out of order, work order raised` }, "Housekeeping", "Out of order");
          }
          if (to === "Inspected" && m.state === "Dirty") return "Clean the room before inspecting it.";
          const other: NonNullable<Res["other"]> = m.state === "Out of order" ? rows(d, "workorders").filter((w) => w.room === m.id && w.status !== "Completed").map((w) => ({ ent: "workorders", id: w.id, patch: { status: "Completed" } })) : [];
          return commitRes("rooms", m, { patch: { state: to }, other, msg: `Room ${m.id} set to ${to.toLowerCase()}` }, "Housekeeping", "Room state");
        }} />
    );
  } else if (action === "service") {
    const total = (v: Record<string, Val>) => {
      const sub = num(v.qty) * num(v.price);
      const vat = v.vat === "No" ? 0 : Math.round(sub * 0.075);
      return { sub, vat, all: sub + vat };
    };
    dialog = (
      <RecordDialog key={action} title="Add service charge" submit="Post charge" data={d} onClose={onClose}
        initial={{ res: first((r) => r.status === "Checked in"), dept: "F&B", qty: 1, vat: "Yes" }}
        fields={[
          { key: "res", label: "In-house guest", kind: "select", required: true, full: true, options: resOpts((r) => r.status === "Checked in") },
          { key: "dept", label: "Department", kind: "select", required: true, options: opts("F&B", "Laundry", "Spa", "Minibar", "Transport", "Other") },
          { key: "vat", label: "Add 7.5% VAT", kind: "select", options: opts("Yes", "No") },
          { key: "desc", label: "Service", kind: "text", required: true, full: true },
          { key: "qty", label: "Quantity", kind: "number", required: true },
          { key: "price", label: "Unit price (₦)", kind: "number", required: true },
        ]}
        extra={(v) => { const t = total(v); return <Peek lines={[["Subtotal", money(t.sub)], ["VAT", money(t.vat)], ["Posted to folio", money(t.all)]]} />; }}
        onSave={(v) => {
          const r = find(v.res);
          if (!r) return "Choose a guest.";
          if (num(v.qty) <= 0 || !Number.isInteger(num(v.qty))) return "Quantity must be a whole number above zero.";
          if (num(v.price) <= 0) return "Unit price must be greater than zero.";
          const t = total(v);
          const creates: NonNullable<Res["creates"]> = [{ ent: "charges", values: { res: r.id, desc: `${String(v.desc)} × ${num(v.qty)}`, dept: String(v.dept), kind: "Charge", amount: t.sub, date: today } }];
          if (t.vat > 0) creates.push({ ent: "charges", values: { res: r.id, desc: `VAT 7.5% · ${String(v.desc)}`, dept: String(v.dept), kind: "Charge", amount: t.vat, date: today } });
          return commitRes("charges", r, { creates, msg: `${money(t.all)} posted to ${hzGuestName(d, r.guest)}'s folio` }, "Folios & billing", "Service charge");
        }} />
    );
  } else if (action === "newguest") {
    dialog = (
      <RecordDialog key={action} title="Add new guest" submit="Create guest" data={d} onClose={onClose}
        initial={{ nationality: "Nigeria", vip: "No" }}
        fields={[
          { key: "name", label: "Full name", kind: "text", required: true, full: true },
          { key: "phone", label: "Phone", kind: "text", required: true }, { key: "email", label: "Email", kind: "text" },
          { key: "nationality", label: "Nationality", kind: "text", required: true }, { key: "vip", label: "VIP", kind: "select", options: opts("No", "Yes") },
          { key: "prefs", label: "Preferences", kind: "text", full: true },
        ]}
        onSave={(v) => {
          const email = String(v.email ?? "");
          if (email && !/^\S+@\S+\.\S+$/.test(email)) return "Enter a valid email address.";
          if (rows(d, "guests").some((g) => String(g.name).toLowerCase() === String(v.name).toLowerCase() && g.phone === v.phone)) return "A guest with this name and phone already exists.";
          const id = nextId("GS-", rows(d, "guests"));
          setData((x) => audit({ ...x, guests: [...rows(x, "guests"), R(id, { name: String(v.name), phone: String(v.phone), email, nationality: String(v.nationality), vip: String(v.vip), tier: "None", points: 0, prefs: String(v.prefs ?? ""), status: "Active" })] }, "Guests", id, "Created", `${id} created`));
          setToast(`${String(v.name)} added as ${id}`);
          onClose();
          return null;
        }} />
    );
  }
  return (
    <>
      {dialog}
      {toast && <div className={`${styles.hzToast} ${styles.hzToastFix}`} role="status" aria-live="polite">{toast}</div>}
    </>
  );
};


/* ---------- Sidebar category filter: local fallback when the Workflow API is unreachable ---------- */
const hzWorkflowTabs = (d: HzData, category: string): WorkflowTab[] => {
  const today = off(0);
  const res = rows(d, "reservations");
  const gn = (r: Row) => hzGuestName(d, r.guest);
  const typeOf = (id: Val | undefined) => nameOf(d, "roomtypes", id);
  const guestTab = (r: Row, date: string, time: string, company: string): WorkflowTab => ({ id: r.id, name: gn(r), role: typeOf(r.roomType), company, datetime: `${date}T${time}`, avatar: "" });
  const inHouse = res.filter((r) => r.status === "Checked in");
  if (category === WorkflowCategories.CheckedInGuests) return inHouse.map((r) => guestTab(r, String(r.arrive), "14:00:00", r.room ? `Room ${String(r.room)}` : "No room yet"));
  if (category === WorkflowCategories.CheckingOutToday) return inHouse.filter((r) => String(r.depart) === today).map((r) => guestTab(r, today, "11:00:00", r.room ? `Room ${String(r.room)}` : "No room yet"));
  if (category === WorkflowCategories.OccupiedRooms || category === WorkflowCategories.AvailableRooms) {
    const now = new Date().toISOString();
    const taken = new Map(inHouse.filter((r) => r.room).map((r) => [String(r.room), r] as [string, Row]));
    const rooms = rows(d, "rooms").filter((m) => m.state !== "Out of order");
    if (category === WorkflowCategories.OccupiedRooms) return rooms.filter((m) => taken.has(m.id)).map((m) => ({ id: m.id, name: `Room ${m.id}`, role: typeOf(m.type), company: gn(taken.get(m.id) as Row), datetime: now, avatar: "" }));
    return rooms.filter((m) => !taken.has(m.id)).map((m) => ({ id: m.id, name: `Room ${m.id}`, role: typeOf(m.type), company: String(m.state), datetime: now, avatar: "" }));
  }
  return res
    .filter((r) => (r.status === "Confirmed" || r.status === "Pending") && String(r.arrive) >= today)
    .sort((x, y) => String(x.arrive).localeCompare(String(y.arrive)))
    .map((r) => guestTab(r, String(r.arrive), "14:00:00", `Arrives ${fdate(String(r.arrive))}`));
};

/* ---------- Booking panel: Edit + Rate & Availability popups ---------- */
interface Bk {
  arrive: string;
  depart: string;
  roomType: string;
  room: string;
  adults: number;
  children: number;
  infants: number;
  plan: string;
  meal: string;
  addons: string[];
  discount: number;
  guest: string;
  phone: string;
  email: string;
  nationality: string;
  requests: string;
}
type BkMode = "stay" | "guests" | "rate" | "avail" | "guest";

const BK_MEALS: [string, number][] = [["Room only", 0], ["Bed & breakfast", 8000], ["Half board", 18000], ["Full board", 28000]];
const BK_ADDONS: { id: string; label: string; price: number }[] = [
  { id: "pickup", label: "Airport pickup", price: 25000 },
  { id: "late", label: "Late checkout", price: 15000 },
  { id: "bed", label: "Extra bed", price: 20000 },
  { id: "spa", label: "Spa credit", price: 30000 },
];
const BK_TAX = 7.5;
const mealCost = (m: string) => BK_MEALS.find(([k]) => k === m)?.[1] ?? 0;
const bkTypes = (d: HzData) => rows(d, "roomtypes").filter((t) => t.status === "Active");
const bkPlans = (d: HzData, type: string) => rows(d, "rateplans").filter((p) => p.roomType === type && p.status === "Active");
const bkPlan = (d: HzData, b: Bk): Row | undefined => bkPlans(d, b.roomType).find((p) => p.id === b.plan) ?? bkPlans(d, b.roomType)[0];
const bkNights = (b: Bk) => Math.max(daysBetween(b.arrive, b.depart), 0);
const bkDates = (b: Bk) => Array.from({ length: bkNights(b) }, (_, i) => hzAddDays(b.arrive, i));
const nightRate = (d: HzData, type: string, plan: Row | undefined, date: string) =>
  (plan ? num(plan.rate) : num(rows(d, "roomtypes").find((t) => t.id === type)?.base)) * (1 + rateAdj(d, date) / 100);
const bkPrice = (d: HzData, b: Bk) => {
  const plan = bkPlan(d, b);
  const dates = bkDates(b);
  const room = dates.reduce((t, x) => t + nightRate(d, b.roomType, plan, x), 0);
  const meal = (mealCost(b.meal) - mealCost(String(plan?.basis ?? "Room only"))) * b.adults * dates.length;
  const addons = b.addons.reduce((t, id) => t + (BK_ADDONS.find((a) => a.id === id)?.price ?? 0), 0);
  const disc = ((room + meal) * b.discount) / 100;
  const tax = ((room + meal + addons - disc) * BK_TAX) / 100;
  return { plan, nights: dates.length, room, meal, addons, disc, tax, total: room + meal + addons - disc + tax };
};
const bkFreeRoom = (d: HzData, type: string, a: string, z: string) =>
  roomsOf(d, type).find((m) => m.state !== "Dirty" && roomFree(d, m.id, a, z))?.id ?? roomsOf(d, type).find((m) => roomFree(d, m.id, a, z))?.id ?? "";
const bkInit = (d: HzData): Bk => {
  const t = bkTypes(d).find((x) => /deluxe/i.test(String(x.name))) ?? bkTypes(d)[0];
  const type = String(t?.id ?? "");
  const arrive = off(1);
  const depart = off(3);
  const plan = bkPlans(d, type)[0];
  return { arrive, depart, roomType: type, room: bkFreeRoom(d, type, arrive, depart), adults: 1, children: 0, infants: 0, plan: String(plan?.id ?? ""), meal: String(plan?.basis ?? "Room only"), addons: [], discount: 0, guest: "", phone: "", email: "", nationality: "", requests: "" };
};
/* Day cards: rooms in house / arrivals for a date, and the booking that day opens in the panel */
const bkDayCounts = (d: HzData, iso: string) => {
  const live = rows(d, "reservations").filter((r) => r.status !== "Cancelled" && r.status !== "No-show");
  return { inHouse: live.filter((r) => String(r.arrive) <= iso && String(r.depart) > iso).length, arrivals: live.filter((r) => String(r.arrive) === iso).length };
};
/* Is there a real reservation on this day? (when not, the panel shows dashes, not a made-up stay) */
const bkHasRes = (d: HzData, iso: string): boolean =>
  rows(d, "reservations").some((r) => r.status !== "Cancelled" && r.status !== "No-show" && ((String(r.arrive) === iso) || (String(r.arrive) <= iso && String(r.depart) > iso)));
const bkForDay = (d: HzData, iso: string, base: Bk): Bk => {
  const live = rows(d, "reservations").filter((r) => r.status !== "Cancelled" && r.status !== "No-show");
  const r = live.find((x) => String(x.arrive) === iso) ?? live.find((x) => String(x.arrive) <= iso && String(x.depart) > iso);
  if (!r) return base;
  const g = rows(d, "guests").find((x) => x.id === String(r.guest));
  const plan = bkPlans(d, String(r.roomType))[0];
  return { ...base, arrive: String(r.arrive), depart: String(r.depart), roomType: String(r.roomType), room: r.room ? String(r.room) : "", adults: num(r.adults) || 1, children: num(r.children), infants: num(r.infants), plan: String(plan?.id ?? base.plan), meal: String(r.meal ?? plan?.basis ?? base.meal), guest: nameOf(d, "guests", r.guest), phone: String(g?.phone ?? ""), email: String(g?.email ?? "") };
};
/* Strings the booking panel shows (arrival/departure blocks, room, rate code ...) */
const bkView = (d: HzData, b: Bk, empty = false) => {
  const p = bkPrice(d, b);
  if (empty) {
    return {
      arrDay: "–", arrMon: "–", arrWd: "–", depDay: "–", depMon: "–", depWd: "–", nights: "–", type: "–", room: "–",
      adults: "–", children: "–", infants: "–", code: "—", meal: "–", addons: "-", discount: "–", tax: "–",
      guest: "No reservation on this day", guestSub: "Pick a guest from the list, or press New Reservation / Booking",
    };
  }
  const mon = (s: string) => parseD(s).toLocaleDateString("en-GB", { month: "short", year: "numeric" }).replace(" ", "-");
  const wd = (s: string) => `${parseD(s).toLocaleDateString("en-GB", { weekday: "long" })}, 11:00 AM`;
  return {
    arrDay: String(parseD(b.arrive).getDate()), arrMon: mon(b.arrive), arrWd: wd(b.arrive),
    depDay: String(parseD(b.depart).getDate()), depMon: mon(b.depart), depWd: wd(b.depart),
    nights: String(p.nights), type: nameOf(d, "roomtypes", b.roomType), room: b.room || "Auto",
    adults: String(b.adults), children: String(b.children), infants: String(b.infants),
    code: String(p.plan?.code ?? "—"), meal: b.meal, addons: b.addons.length ? b.addons.map((id) => BK_ADDONS.find((a) => a.id === id)?.label ?? id).join(", ") : "-",
    discount: `${b.discount}%`, tax: money(p.tax),
    guest: b.guest || "No guest selected", guestSub: b.guest || b.email || b.phone ? `📩 ${b.email || "no email"} ● 📞 ${b.phone || "no phone"}` : "Pick a guest from the list, or add one in Guest Details",
  };
};

const BookingDialog: React.FC<{ mode: BkMode | null; bk: Bk; selfId?: string; onClose: () => void; onApply: (next: Bk, msg: string) => void }> = ({ mode, bk, selfId, onClose, onApply }) => {
  const [d0] = useHzData();
  // when editing an existing reservation it must not count against its own availability
  const d = selfId ? { ...d0, reservations: rows(d0, "reservations").filter((r) => r.id !== selfId) } : d0;
  const [v, setV] = useState<Bk>(bk);
  const [err, setErr] = useState<string | null>(null);
  const [more, setMore] = useState(false);
  const [from, setFrom] = useState(0);
  if (!mode) return null;
  const set = (patch: Partial<Bk>) => { setV((x) => ({ ...x, ...patch })); setErr(null); };
  const typ = rows(d, "roomtypes").find((t) => t.id === v.roomType);
  const price = bkPrice(d, v);
  const pickType = (id: string) => {
    if (id === v.roomType) return;
    const plan = bkPlans(d, id)[0];
    const max = num(rows(d, "roomtypes").find((t) => t.id === id)?.maxOcc) || 2;
    set({ roomType: id, plan: String(plan?.id ?? ""), meal: String(plan?.basis ?? "Room only"), room: bkFreeRoom(d, id, v.arrive, v.depart), adults: Math.min(v.adults, max), children: Math.min(v.children, Math.max(max - Math.min(v.adults, max), 0)) });
  };
  const leftFor = (type: string, a: string, z: string) => {
    const ds = Array.from({ length: Math.max(daysBetween(a, z), 0) }, (_, i) => hzAddDays(a, i));
    if (!ds.length) return 0;
    return Math.min(...ds.map((x) => (stopSold(d, type, x) ? 0 : availOn(d, type, x))));
  };
  const check = (): string | null => {
    if (!v.arrive || !v.depart) return "Choose arrival and departure dates.";
    if (v.arrive < off(0) && v.arrive !== bk.arrive) return "Arrival can't be in the past.";
    if (v.depart <= v.arrive) return "Departure must be after arrival.";
    if (bkNights(v) > 30) return "A stay can be up to 30 nights.";
    for (const x of bkDates(v)) {
      if (stopSold(d, v.roomType, x)) return `${String(typ?.name)} is closed for sale on ${fdate(x)}.`;
      if (availOn(d, v.roomType, x) <= 0) return `No ${String(typ?.name)} left on ${fdate(x)}. Pick other dates or another room type.`;
    }
    if (v.adults < 1) return "At least one adult is needed.";
    const max = num(typ?.maxOcc) || 2;
    if (v.adults + v.children > max && (v.roomType !== bk.roomType || v.adults + v.children > bk.adults + bk.children)) return `${String(typ?.name)} sleeps ${max} (adults and children).`;
    if (v.room && !roomFree(d, v.room, v.arrive, v.depart)) return `Room ${v.room} is booked for those dates.`;
    if (v.discount < 0 || v.discount > 100) return "Discount must be between 0 and 100%.";
    return null;
  };
  const save = (msg: string) => {
    const bad = check();
    if (bad) return setErr(bad);
    onApply(v, msg);
  };
  const title = mode === "guest" ? "Guest details" : mode === "stay" ? "Edit stay" : mode === "guests" ? "Edit room and guests" : mode === "rate" ? "Edit rate and charges" : "Rate & availability";
  const sub = mode === "guest" ? `${v.guest || "Guest"} · ${fdate(v.arrive)} → ${fdate(v.depart)}` : `${String(typ?.name ?? "")} · ${fdate(v.arrive)} → ${fdate(v.depart)} · ${price.nights} night${price.nights === 1 ? "" : "s"}`;
  const tone = (n: number, closed: boolean) => (closed ? styles.hzAvClosed : n <= 0 ? styles.hzAvFull : n <= 2 ? styles.hzAvLow : styles.hzAvOpen);
  const step = (label: string, hint: string, val: number, min: number, max: number, k: "adults" | "children" | "infants") => (
    <div className={styles.hzBkStep}>
      <div><strong>{label}</strong><small>{hint}</small></div>
      <div className={styles.hzBkStepper}>
        <HzButton size="small" appearance="subtle" aria-label={`Fewer ${label.toLowerCase()}`} disabled={val <= min} onClick={() => set({ [k]: val - 1 } as Partial<Bk>)}>−</HzButton>
        <span aria-live="polite">{val}</span>
        <HzButton size="small" appearance="subtle" aria-label={`More ${label.toLowerCase()}`} disabled={val >= max} onClick={() => set({ [k]: val + 1 } as Partial<Bk>)}>+</HzButton>
      </div>
    </div>
  );
  const maxOcc = num(typ?.maxOcc) || 2;
  const win = Array.from({ length: 7 }, (_, i) => hzAddDays(v.arrive, from + i - 1));
  return (
    <HzDialog open onOpenChange={(_, dd) => !dd.open && onClose()}>
      <HzDialogSurface className={mode === "avail" ? styles.hzBkWide : mode === "guest" ? styles.hzBkCard : styles.hzDialog}>
        <HzDialogBody>
          <HzDialogTitle className={mode === "guest" ? styles.hzBkSrOnly : undefined} action={<HzDialogTrigger action="close"><HzButton size="small" appearance="subtle" aria-label="Close" icon={<HzDismiss24Regular />} /></HzDialogTrigger>}>{title}</HzDialogTitle>
          <HzDialogContent>
            {mode !== "guest" && <p className={styles.hzBkSub}>{sub}</p>}

            {mode === "guest" && (() => {
              const g = rows(d, "guests").find((x) => String(x.name).toLowerCase() === v.guest.trim().toLowerCase() || (!!v.email && String(x.email ?? "").toLowerCase() === v.email.toLowerCase()));
              const past = g ? rows(d, "reservations").filter((r) => r.guest === g.id).sort((x, y) => String(y.arrive).localeCompare(String(x.arrive))).slice(0, 5) : [];
              const initials = v.guest.split(/\s+/).filter(Boolean).map((w) => w.charAt(0)).slice(0, 2).join("").toUpperCase();
              const vip = g?.vip === "Yes";
              const tier = g && String(g.tier).toLowerCase() !== "none" ? String(g.tier) : "";
              const today = off(0);
              const state = today < v.arrive ? `Arriving ${fdate(v.arrive)}` : today < v.depart ? "In house" : "Departed";
              const guestsTxt = `${v.adults} adult${v.adults === 1 ? "" : "s"}${v.children ? `, ${v.children} child${v.children === 1 ? "" : "ren"}` : ""}${v.infants ? `, ${v.infants} infant${v.infants === 1 ? "" : "s"}` : ""}`;
              const tone = (st: string) => (st === "Checked in" ? styles.hzTone_green : st === "Confirmed" ? styles.hzTone_blue : st === "Pending" ? styles.hzTone_amber : styles.hzTone_grey);
              const item = (icon: React.ReactNode, label: string, val: string, href?: string) => (
                <div className={styles.hzBkInfo}>
                  <span className={styles.hzBkInfoIcon}>{icon}</span>
                  <div>
                    <small>{label}</small>
                    {href && val ? <a href={href}>{val}</a> : <span>{val || "—"}</span>}
                  </div>
                </div>
              );
              return (
                <>
                  <div className={styles.hzBkHero}>
                    <span className={styles.hzBkAvatarLg} aria-hidden="true">
                      {initials}
                      <span className={styles.hzBkBadge}><HzCalendarClock20Regular /></span>
                    </span>
                    <div className={styles.hzBkHeroText}>
                      <h3>{v.guest}</h3>
                      <p>{[vip ? "VIP" : "", tier ? `${tier} member` : "", String(typ?.name ?? "")].filter(Boolean).join(" • ")}</p>
                      <div className={styles.hzBkActions}>
                        {v.email && <a href={`mailto:${v.email}`} aria-label={`Email ${v.guest}`} title="Email"><HzMail20Regular /></a>}
                        {v.phone && <a href={`tel:${v.phone.replace(/\s+/g, "")}`} aria-label={`Call ${v.guest}`} title="Call"><HzCall20Regular /></a>}
                      </div>
                    </div>
                  </div>

                  <div className={styles.hzBkStatus}>
                    <div className={styles.hzBkStatusTop}>
                      <span className={styles.hzBkDot}><HzCalendarClock20Regular /></span>
                      <div>
                        <strong>{state} • {price.nights} night{price.nights === 1 ? "" : "s"}</strong>
                        <small>Check-in from 11:00 AM • Check-out by 11:00 AM</small>
                      </div>
                    </div>
                    <div className={styles.hzBkStatusRow}>
                      <HzBed20Regular />
                      <span>{fdate(v.arrive)} → {fdate(v.depart)} • {String(typ?.name ?? "")}{v.room ? `, Room ${v.room}` : ""}</span>
                    </div>
                  </div>

                  <h4 className={styles.hzBkH4}>Contact information</h4>
                  <div className={styles.hzBkInfoGrid}>
                    {item(<HzMail20Regular />, "Email", v.email, v.email ? `mailto:${v.email}` : undefined)}
                    {item(<HzCall20Regular />, "Phone", v.phone, v.phone ? `tel:${v.phone.replace(/\s+/g, "")}` : undefined)}
                    {item(<HzGlobe20Regular />, "Nationality", v.nationality)}
                    {item(<HzBed20Regular />, "Room type", String(typ?.name ?? ""))}
                    {item(<HzKey20Regular />, "Room", v.room ? `Room ${v.room}` : "Not assigned")}
                    {item(<HzPeople20Regular />, "Guests", guestsTxt)}
                  </div>

                  {more && (
                    <div className={styles.hzBkInfoGrid}>
                      {item(<HzStar20Regular />, "Loyalty", g ? `${num(g.points)} points` : "Not a member")}
                      {item(<HzTag20Regular />, "Rate code", String(price.plan?.code ?? "—"))}
                      {item(<HzReceipt20Regular />, "Stay total", money(price.total))}
                      <div className={styles.hzBkInfoWide}>
                        {item(<HzPerson20Regular />, "Preferences and requests", [g?.prefs ? String(g.prefs) : "", v.requests].filter(Boolean).join(" • ") || "None noted")}
                      </div>
                    </div>
                  )}
                  {more && (
                    <>
                      <h4 className={styles.hzBkH4}>Previous stays</h4>
                      {past.length === 0 ? <div className={styles.hzBkNote}>No previous stays on record.</div> : (
                        <div className={styles.hzBkStays}>
                          {past.map((r) => (
                            <div key={r.id} className={styles.hzBkStay}>
                              <span><strong>{nameOf(d, "roomtypes", r.roomType)}</strong><small>{fdate(String(r.arrive))} → {fdate(String(r.depart))}</small></span>
                              <span className={`${styles.hzPill} ${tone(String(r.status))}`}>{String(r.status)}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                  <button type="button" className={styles.hzBkMore} onClick={() => setMore(!more)} aria-expanded={more}>{more ? "Show less" : "Show more information"}</button>
                </>
              );
            })()}

            {mode === "stay" && (
              <>
                <div className={styles.hzForm}>
                  <HzField label="Arrival" required><HzInput type="date" min={off(0)} value={v.arrive} onChange={(_, dd) => set({ arrive: dd.value, depart: dd.value && v.depart <= dd.value ? hzAddDays(dd.value, 1) : v.depart })} /></HzField>
                  <HzField label="Departure" required><HzInput type="date" min={v.arrive || off(0)} value={v.depart} onChange={(_, dd) => set({ depart: dd.value })} /></HzField>
                </div>
                <div className={styles.hzBkLabel}>Room type</div>
                <div className={styles.hzBkTypes} role="radiogroup" aria-label="Room type">
                  {bkTypes(d).map((t) => {
                    const left = leftFor(t.id, v.arrive, v.depart);
                    const pl = bkPlans(d, t.id)[0];
                    return (
                      <button key={t.id} type="button" role="radio" aria-checked={v.roomType === t.id} disabled={left <= 0} className={`${styles.hzBkType} ${v.roomType === t.id ? styles.hzBkTypeOn : ""}`} onClick={() => pickType(t.id)}>
                        <span className={styles.hzBkTypeName}>{String(t.name)}</span>
                        <span className={styles.hzBkTypeMeta}>{String(t.beds)} · sleeps {num(t.maxOcc)}</span>
                        <span className={styles.hzBkTypeFoot}>
                          <strong>{money(nightRate(d, t.id, pl, v.arrive))}</strong><small> / night</small>
                          <span className={`${styles.hzPill} ${left <= 0 ? styles.hzTone_red : left <= 2 ? styles.hzTone_amber : styles.hzTone_green}`}>{left <= 0 ? "Sold out" : `${left} left`}</span>
                        </span>
                      </button>
                    );
                  })}
                </div>
                <div className={styles.hzPeek}>
                  <div className={styles.hzPeekRow}><span>Stay</span><strong>{price.nights} night{price.nights === 1 ? "" : "s"}</strong></div>
                  <div className={styles.hzPeekRow}><span>Room total</span><strong>{money(price.room)}</strong></div>
                </div>
              </>
            )}

            {mode === "guests" && (
              <>
                {step("Adults", "Age 13 and over", v.adults, 1, Math.max(maxOcc - v.children, 1), "adults")}
                {step("Children", "Age 2 to 12", v.children, 0, Math.max(maxOcc - v.adults, 0), "children")}
                {step("Infants", "Under 2, stay free", v.infants, 0, 2, "infants")}
                <div className={styles.hzBkLabel}>Room</div>
                <HzSelect value={v.room} onChange={(_, dd) => set({ room: dd.value })} aria-label="Room">
                  <option value="">Assign automatically</option>
                  {roomsOf(d, v.roomType).map((m) => <option key={m.id} value={m.id} disabled={!roomFree(d, m.id, v.arrive, v.depart)}>{`Room ${m.id} · ${String(m.state)}${roomFree(d, m.id, v.arrive, v.depart) ? "" : " · booked"}`}</option>)}
                </HzSelect>
                <div className={styles.hzPeek}>
                  <div className={styles.hzPeekRow}><span>Occupancy</span><strong>{v.adults + v.children} of {maxOcc}</strong></div>
                </div>
              </>
            )}

            {mode === "rate" && (
              <>
                <div className={styles.hzForm}>
                  <HzField label="Rate code" required>
                    <HzSelect value={price.plan ? String(price.plan.id) : ""} onChange={(_, dd) => { const p = rows(d, "rateplans").find((x) => x.id === dd.value); set({ plan: dd.value, meal: String(p?.basis ?? v.meal) }); }}>
                      {bkPlans(d, v.roomType).map((p) => <option key={p.id} value={p.id}>{`${String(p.code)} · ${String(p.name)} · ${money(num(p.rate))}`}</option>)}
                    </HzSelect>
                  </HzField>
                  <HzField label="Meal plan">
                    <HzSelect value={v.meal} onChange={(_, dd) => set({ meal: dd.value })}>
                      {BK_MEALS.map(([m]) => <option key={m} value={m}>{m}</option>)}
                    </HzSelect>
                  </HzField>
                  <HzField label="Discount (%)"><HzInput type="number" min={0} max={100} value={String(v.discount)} onChange={(_, dd) => set({ discount: Math.max(Number(dd.value) || 0, 0) })} /></HzField>
                  <div>
                    <div className={styles.hzBkLabelTop}>Cancellation</div>
                    <div className={styles.hzBkPlain}>{String(price.plan?.cancel ?? "—")}</div>
                  </div>
                </div>
                <div className={styles.hzBkLabel}>Add-ons</div>
                <div className={styles.hzBkChips}>
                  {BK_ADDONS.map((a) => {
                    const on = v.addons.includes(a.id);
                    return <button key={a.id} type="button" aria-pressed={on} className={`${styles.hzBkChip} ${on ? styles.hzBkChipOn : ""}`} onClick={() => set({ addons: on ? v.addons.filter((x) => x !== a.id) : [...v.addons, a.id] })}>{a.label}<small>{money(a.price)}</small></button>;
                  })}
                </div>
                <div className={styles.hzBkTotals}>
                  <div><span>Room · {price.nights} night{price.nights === 1 ? "" : "s"}</span><strong>{money(price.room)}</strong></div>
                  {price.meal !== 0 && <div><span>Meal plan change</span><strong>{money(price.meal)}</strong></div>}
                  {price.addons > 0 && <div><span>Add-ons</span><strong>{money(price.addons)}</strong></div>}
                  {price.disc > 0 && <div><span>Discount ({v.discount}%)</span><strong className={styles.hzCredit}>−{money(price.disc)}</strong></div>}
                  <div><span>Tax ({BK_TAX}%)</span><strong>{money(price.tax)}</strong></div>
                  <div className={styles.hzBkGrand}><span>Total</span><strong>{money(price.total)}</strong></div>
                </div>
              </>
            )}

            {mode === "avail" && (
              <>
                <div className={styles.hzPane}>
                  <HzButton size="small" appearance="subtle" icon={<HzChevronLeft20Regular />} aria-label="Earlier" onClick={() => setFrom(from - 7)} />
                  <HzButton size="small" appearance="subtle" onClick={() => setFrom(0)}>Stay dates</HzButton>
                  <HzButton size="small" appearance="subtle" icon={<HzChevronRight20Regular />} aria-label="Later" onClick={() => setFrom(from + 7)} />
                  <span className={styles.hzGrow} />
                  <span className={styles.hzHint}>Outlined nights are in this stay. Choose a row to switch room type.</span>
                </div>
                <div className={styles.hzAvScroll}>
                  <table className={styles.hzAv}>
                    <thead>
                      <tr>
                        <th className={styles.hzAvName}>Room type</th>
                        {win.map((x) => <th key={x}><small>{dow(x)}</small>{parseD(x).getDate()}</th>)}
                        <th>Stay</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bkTypes(d).map((t) => {
                        const pl = t.id === v.roomType ? price.plan : bkPlans(d, t.id)[0];
                        const tot = bkDates(v).reduce((s, x) => s + nightRate(d, t.id, pl, x), 0);
                        const left = leftFor(t.id, v.arrive, v.depart);
                        return (
                          <React.Fragment key={t.id}>
                            <tr className={t.id === v.roomType ? styles.hzBkRowOn : undefined}>
                              <th className={styles.hzAvName}><strong>{String(t.name)}</strong><small>{String(pl?.code ?? "Base rate")}</small></th>
                              {win.map((x) => {
                                const n = availOn(d, t.id, x);
                                const closed = stopSold(d, t.id, x);
                                const inStay = x >= v.arrive && x < v.depart;
                                return <td key={x}><span className={`${styles.hzAvCell} ${styles.hzBkCell} ${tone(n, closed)} ${inStay ? styles.hzBkIn : ""}`}>{closed ? "Closed" : Math.max(n, 0)}</span></td>;
                              })}
                              <td><HzButton size="small" appearance={t.id === v.roomType ? "primary" : "secondary"} className={t.id === v.roomType ? styles.hzPrimary : undefined} disabled={left <= 0 && t.id !== v.roomType} onClick={() => pickType(t.id)}>{t.id === v.roomType ? "Selected" : "Choose"}</HzButton></td>
                            </tr>
                            <tr className={styles.hzAvRate}>
                              <th className={styles.hzAvName}>Rate</th>
                              {win.map((x) => { const a = rateAdj(d, x); return <td key={x}>{compact(nightRate(d, t.id, pl, x))}{a ? <small className={a > 0 ? styles.hzUp : styles.hzDown}>{a > 0 ? "+" : ""}{a}%</small> : null}</td>; })}
                              <td><strong>{compact(tot)}</strong></td>
                            </tr>
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </>
            )}

            {err && <div className={styles.hzErr} role="alert">{err}</div>}
          </HzDialogContent>
          <HzDialogActions>
            {mode === "guest" ? (
              <HzDialogTrigger action="close"><HzButton size="small" appearance="primary" className={styles.hzPrimary}>Close</HzButton></HzDialogTrigger>
            ) : (
              <>
                <HzDialogTrigger action="close"><HzButton size="small" appearance="secondary">Cancel</HzButton></HzDialogTrigger>
                <HzButton size="small" appearance="primary" className={styles.hzPrimary} onClick={() => save(mode === "stay" ? "Stay updated" : mode === "guests" ? "Room and guests updated" : mode === "rate" ? "Rate and charges updated" : `${String(typ?.name)} selected`)}>{mode === "avail" ? "Apply" : "Save"}</HzButton>
              </>
            )}
          </HzDialogActions>
        </HzDialogBody>
      </HzDialogSurface>
    </HzDialog>
  );
};

/* ---------- Guest view: Summary / Analytics / Details / Related for the sidebar selection ---------- */
const bkFromRes = (d: HzData, r: Row, base: Bk): Bk => {
  const g = rows(d, "guests").find((x) => x.id === String(r.guest));
  const plan = rows(d, "rateplans").find((p) => p.id === String(r.plan)) ?? bkPlans(d, String(r.roomType))[0];
  return { ...base, arrive: String(r.arrive), depart: String(r.depart), roomType: String(r.roomType), room: r.room ? String(r.room) : "", adults: num(r.adults) || 1, children: num(r.children), infants: num(r.infants), plan: String(plan?.id ?? base.plan), meal: String(r.meal ?? plan?.basis ?? base.meal), addons: String(r.addons ?? "").split(",").filter(Boolean), discount: num(r.discount), guest: nameOf(d, "guests", r.guest), phone: String(g?.phone ?? ""), email: String(g?.email ?? ""), nationality: String(g?.nationality ?? ""), requests: String(g?.prefs ?? "") };
};

type GvTab = "Summary" | "Analytics" | "Details" | "Related";
const GV_TABS: GvTab[] = ["Summary", "Analytics", "Details", "Related"];

const GuestPanel: React.FC<{ id: string; onOpen: (id: string) => void }> = ({ id, onOpen }) => {
  const [d, setD] = useHzData();
  const [tab, setTab] = useState<GvTab>("Summary");
  const [dlg, setDlg] = useState<BkMode | null>(null);
  const [toast, setToast] = useState<string | null>(null);
  const [askCancel, setAskCancel] = useState(false);
  useEffect(() => { if (!toast) return; const t = setTimeout(() => setToast(null), 3200); return () => clearTimeout(t); }, [toast]);
  useEffect(() => { setTab("Summary"); setAskCancel(false); setDlg(null); }, [id]);

  const room = rows(d, "rooms").find((m) => m.id === id);
  const all = rows(d, "reservations");
  const res = all.find((r) => r.id === id) ?? (room ? all.find((r) => r.status === "Checked in" && String(r.room) === room.id) : undefined);
  const g = res ? rows(d, "guests").find((x) => x.id === String(res.guest)) : undefined;

  if (!res || !g) {
    return (
      <div className={styles.YvsEV}>
        <div className={styles.Sdkwb7}>
          <Persona name={room ? `Room ${room.id}` : "Nothing selected"} secondaryText={room ? `${nameOf(d, "roomtypes", room.type)} • ${String(room.state)}` : "Pick a guest or room from the list"} avatar={{ color: "colorful" }} />
        </div>
        <div className={styles.SMdte}><div className={`${styles.WesTY} ${styles.customScrollBar}`}><p className={styles.hzHint} style={{ padding: 16 }}>{room ? "No guest is checked in to this room." : "Nothing to show."}</p></div></div>
      </div>
    );
  }

  const status = String(res.status);
  const editable = status === "Pending" || status === "Confirmed" || status === "Checked in";
  const nights = nightsOf(res);
  const rate = num(res.rate);
  const folio = rows(d, "charges").filter((c) => c.res === res.id);
  const roomCh = folio.filter((c) => c.dept === "Room");
  const roomTotal = roomCh.length ? sum(roomCh, (c) => num(c.amount)) : rate * nights;
  const extras = sum(folio.filter((c) => c.kind === "Charge" && c.dept !== "Room"), (c) => num(c.amount));
  const vat = (roomTotal + extras) * (BK_TAX / 100);
  const total = roomTotal + extras + vat;
  const paid = sum(folio.filter((c) => c.kind === "Payment"), (c) => num(c.amount));
  const typeName = nameOf(d, "roomtypes", res.roomType);
  const planRow = rows(d, "rateplans").find((p) => p.id === String(res.plan));
  const mine = all.filter((r) => r.guest === res.guest);
  const mineIds = new Set(mine.map((r) => r.id));
  const myCharges = rows(d, "charges").filter((c) => mineIds.has(String(c.res)) && c.kind === "Charge");
  const spend = sum(myCharges, (c) => num(c.amount));
  const doneNights = sum(mine.filter((r) => r.status === "Checked in" || r.status === "Checked out"), nightsOf);
  const byDept = Object.entries(myCharges.reduce<Record<string, number>>((m, c) => ({ ...m, [String(c.dept)]: (m[String(c.dept)] ?? 0) + num(c.amount) }), {})).sort((a, b) => b[1] - a[1]);
  const topDept = byDept[0]?.[1] || 1;
  const corp = rows(d, "corporates").find((c) => c.id === String(res.corp));
  const agent = rows(d, "agents").find((a) => a.id === String(res.agent));
  const amenities = [String(res.meal ?? planRow?.basis ?? "Room only") !== "Room only" ? `${String(res.meal ?? planRow?.basis)} included` : "", "Free Wi-Fi", g.vip === "Yes" ? "VIP welcome amenity" : "", String(g.tier) !== "None" ? (String(g.tier) === "Member" ? "Member benefits" : `${String(g.tier)} member benefits`) : ""].filter(Boolean);
  const tierLbl = String(g.tier) === "None" ? "Not a member" : String(g.tier) === "Member" ? "Member" : `${String(g.tier)} Member`;
  const stayVals = [...mine].sort((x, y) => String(x.arrive).localeCompare(String(y.arrive))).slice(-8).map((r) => {
    const c = sum(rows(d, "charges").filter((x) => x.res === r.id && x.kind === "Charge"), (x) => num(x.amount));
    return { r, v: c || num(r.rate) * nightsOf(r) };
  });
  const maxStay = Math.max(...stayVals.map((s) => s.v), 1);
  const stamp = (s: string, t: string) => `${fdate(s)} – ${t}`;

  const Row2: React.FC<{ a: [string, React.ReactNode]; b?: [string, React.ReactNode] }> = ({ a, b }) => (
    <div className={styles.rowj}>
      <div className={styles.Hirow}><span className={styles.label}>{a[0]}</span><span className={styles.value}>{a[1]}</span></div>
      {b && <div className={styles.Hirow}><span className={styles.label}>{b[0]}</span><span className={styles.value}>{b[1]}</span></div>}
    </div>
  );
  const Sec: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (<div className={styles.section}><h3 className={styles.sectionTitle}>{title}</h3>{children}</div>);
  const side = (...parts: React.ReactNode[]) => (
    <div className={styles.WRnty}><div className={`${styles.dtYUmd} ${styles.RT3s} ${styles.solen22}`}>{parts.map((p, i) => (<React.Fragment key={i}>{i > 0 && <Divider className={styles.HUEyb} />}{p}</React.Fragment>))}</div></div>
  );

  const apply = (n: Bk, msg: string) => {
    const plan = rows(d, "rateplans").find((p) => p.id === n.plan);
    setD((x) => ({ ...x, reservations: rows(x, "reservations").map((r): Row => (r.id === res.id ? { ...r, arrive: n.arrive, depart: n.depart, roomType: n.roomType, room: n.room, adults: n.adults, children: n.children, infants: n.infants, plan: n.plan, rate: plan && n.plan !== String(r.plan) ? num(plan.rate) : num(r.rate), meal: n.meal, discount: n.discount, addons: n.addons.join(",") } : r)) }));
    setDlg(null); setToast(msg);
  };
  const cancel = () => {
    setD((x) => ({ ...x, reservations: rows(x, "reservations").map((r) => (r.id === res.id ? { ...r, status: "Cancelled" } : r)) }));
    setAskCancel(false); setToast(`${res.id} cancelled`);
  };

  return (
    <div className={styles.YvsEV}>
      <div className={styles.Sdkwb7}>
        <Persona name={String(g.name)} secondaryText={<span style={{ fontWeight: 500 }}>{String(g.nationality)} <span style={{ fontSize: "1.2em", fontWeight: "bold" }}>•</span> {String(g.tier)} {g.vip === "Yes" ? "• VIP" : ""}</span>} avatar={{ color: "colorful" }} />
      </div>
      <div className={styles.TRqm}>
        <Button shape="circular" size="small" className={`${styles.hmectKL} ${styles.LoiR}`}>
          {GV_TABS.map((t) => (<Button key={t} shape="circular" size="small" className={`${styles.hmecTm} ${tab === t ? styles.cgTactive : ""}`} onClick={() => setTab(t)}>{t === "Summary" ? "Summary" : t}</Button>))}
        </Button>
      </div>
      <div className={`${styles.SMdte}`}>
        <div className={`${styles.WesTY} ${styles.customScrollBar}`}>
          {tab === "Summary" && (
            <>
              {side(
                <div className={`${styles.UL0v}`}>
                  <div className={`${styles.Sneh} ${styles.Wrui}`}><Button icon={<Call16Regular />} className={styles.FPhone} as="a" href={`tel:${String(g.phone)}`}></Button><span className={styles.Tevet}>{String(g.phone)}</span></div>
                  <div className={`${styles.Sneh} ${styles.Wrui}`}><Button icon={<MailInbox16Regular />} className={styles.FPhone} as="a" href={`mailto:${String(g.email)}`}></Button><span className={styles.Tevet}>{String(g.email)}</span></div>
                </div>,
                <Sec title="Personal Information">
                  <Row2 a={["Nationality", String(g.nationality)]} b={["VIP", String(g.vip)]} />
                  <Row2 a={["Guest status", String(g.status)]} b={["Stays", String(mine.length)]} />
                </Sec>,
                <Sec title="Loyalty Program">
                  <div className={styles.rowj}><div className={styles.Hirow}><span className={styles.label}>Membership Status</span><span className={styles.statusTag}>{tierLbl}</span></div></div>
                  <Row2 a={["Points Balance", `${num(g.points).toLocaleString()} points`]} b={["Tier Level", String(g.tier)]} />
                </Sec>
              )}
              <div className={`${styles.dRAP} ${styles.HDRTp}`}>
                <div className={styles.leftPanel}>
                  <Label className={styles.LbelText}><Text>Booking info</Text></Label>
                  <div className={styles.sectionHeader}><Button icon={<Checkmark16Regular />} size="small" shape="square" className={`${styles.cgTactive}`}>{status === "Confirmed" ? "Booking Confirmed" : `Booking ${status}`}</Button></div>
                  <Text weight="bold">Booking ID: {String(res.id)}</Text>
                  <p className={styles.timestamp}>Booked via {String(res.source)}</p>
                  <div className={styles.infoGrid}>
                    <div><label>Room Type</label><p>{typeName}</p></div>
                    <div><label>Room Number</label><Subtitle2Stronger>{res.room ? String(res.room) : "Not assigned"}</Subtitle2Stronger></div>
                    <div><label>Price</label><p>{money(rate)}/night</p></div>
                    <div><label>Guests</label><p>{num(res.adults) || 1} Adult{(num(res.adults) || 1) > 1 ? "s" : ""}{num(res.children) ? `, ${num(res.children)} Child` : ""}</p></div>
                    <div><label>Requests</label><p>{g.prefs ? String(g.prefs) : "None"}</p></div>
                    <div><label>Check In</label><Text>{stamp(String(res.arrive), "2:00 PM")}</Text></div>
                    <div><label>Check Out</label><p>{stamp(String(res.depart), "11:00 AM")}</p></div>
                    <div><label>Duration</label><p>{nights} night{nights > 1 ? "s" : ""}</p></div>
                  </div>
                  <div className={styles.notesBox}>
                    <Button size="small" className={styles.cgTactive}><span className={styles.noteContent}>{g.prefs ? `Guest preference: ${String(g.prefs)}.` : "No special notes on this guest."}{" "}<Link onClick={() => setTab("Details")}>details</Link></span></Button>
                  </div>
                  <div className={styles.amenitiesWrapper}>
                    <div className={styles.dflr}>
                      <div><label>Loyalty Program</label><p>{tierLbl}</p></div>
                      <div><label>Source</label><p>{corp ? String(corp.name) : agent ? String(agent.name) : String(res.source)}</p></div>
                    </div>
                    <div><label>Special Amenities</label><div className={styles.amenityList}>{amenities.map((a) => (<Button key={a} icon={<Checkmark16Regular />}>{a}</Button>))}</div></div>
                  </div>
                  <div className={styles.buttonRow}>
                    <Menu>
                      <MenuTrigger disableButtonEnhancement><Button size="small" className={styles.editBtn} disabled={!editable}>Edit</Button></MenuTrigger>
                      <MenuPopover><MenuList>
                        <MenuItem onClick={() => setDlg("stay")}>Edit stay</MenuItem>
                        <MenuItem onClick={() => setDlg("guests")}>Edit room and guests</MenuItem>
                        <MenuItem onClick={() => setDlg("rate")}>Edit rate and charges</MenuItem>
                      </MenuList></MenuPopover>
                    </Menu>
                    {!askCancel && <Button size="small" className={styles.cancelBtn} disabled={status !== "Pending" && status !== "Confirmed"} onClick={() => setAskCancel(true)}>Cancel Booking</Button>}
                    {askCancel && (<><Button size="small" className={styles.cancelBtn} onClick={cancel}>Yes, cancel it</Button><Button size="small" onClick={() => setAskCancel(false)}>Keep</Button></>)}
                  </div>
                </div>
                <div className={styles.rightPanel}>
                  <div className={styles.roomImageWrapper}><img src={luxuryMorden} alt="Room preview" className={styles.roomImage} /></div>
                  <div className={styles.roomMeta}><span>{typeName}</span>•<span>{res.room ? `Room ${String(res.room)}` : "Room not assigned"}</span>•<span>{num(res.adults) || 1} guest{(num(res.adults) || 1) > 1 ? "s" : ""}</span></div>
                  <div className={styles.priceBox}>
                    <h3>Price Summary</h3>
                    <div className={styles.row}><span>Room and offer</span><span>{money(roomTotal)}</span></div>
                    <div className={styles.row}><span>Extras</span><span>{money(extras)}</span></div>
                    <div className={styles.row}><span>{BK_TAX}% VAT</span><span>{money(vat)}</span></div>
                    <div className={`${styles.row} ${styles.totalRow}`}><strong>Total Price</strong><strong>{money(total)}</strong></div>
                    <div className={styles.row}><span>Paid</span><span>{money(paid)}</span></div>
                    <div className={styles.row}><span>Balance</span><span>{money(Math.max(total - paid, 0))}</span></div>
                    <p className={styles.invoiceNote}>{corp ? `Invoice goes to ${String(corp.name)}.` : paid >= total && paid > 0 ? "Paid in full." : "Payment due at check-out."}</p>
                  </div>
                </div>
              </div>
            </>
          )}
          {tab !== "Summary" && (
            <div className={styles.hzGvWrap}>
              {tab === "Analytics" && (
                <>
                  <div className={styles.hzGvKpis}>
                    {([["Lifetime spend", money(spend), `${mine.length} stay${mine.length === 1 ? "" : "s"}`], ["Nights stayed", String(doneNights), "checked in or out"], ["Average per stay", money(mine.length ? spend / mine.length : 0), "all charges"], ["Balance due", money(Math.max(total - paid, 0)), `on ${String(res.id)}`]] as [string, string, string][]).map(([k, v, s]) => (
                      <div key={k} className={styles.hzGvKpi}><span>{k}</span><strong>{v}</strong><small>{s}</small></div>
                    ))}
                  </div>
                  <div className={styles.hzGvGrid}>
                    <div className={styles.hzGvCard}>
                      <h4>Spend by department</h4>
                      {byDept.length === 0 && <p className={styles.hzHint}>No charges posted yet.</p>}
                      {byDept.map(([dept, amt]) => (
                        <div key={dept} className={styles.hzGvBar}>
                          <div><span>{dept}</span><span>{money(amt)} · {Math.round((amt / (spend || 1)) * 100)}%</span></div>
                          <i><b style={{ width: `${Math.max((amt / topDept) * 100, 3)}%` }} /></i>
                        </div>
                      ))}
                    </div>
                    <div className={styles.hzGvCard}>
                      <h4>Value of each stay</h4>
                      <div className={styles.hzGvCols}>
                        {stayVals.map((s) => (
                          <div key={String(s.r.id)} className={s.r.id === res.id ? styles.hzGvColOn : ""} title={`${fdate(String(s.r.arrive))} · ${money(s.v)}`}>
                            <b style={{ height: `${Math.max((s.v / maxStay) * 100, 4)}%` }} />
                            <span>{fshort(String(s.r.arrive))}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className={styles.hzGvCard}>
                      <h4>This stay</h4>
                      <div className={styles.hzGvBar}><div><span>Paid</span><span>{money(paid)} of {money(total)}</span></div><i><b style={{ width: `${Math.min((paid / (total || 1)) * 100, 100)}%` }} /></i></div>
                      <dl className={styles.hzGvDl}><dt>Nights</dt><dd>{nights}</dd><dt>Rate</dt><dd>{money(rate)} / night</dd><dt>Extras</dt><dd>{money(extras)}</dd></dl>
                    </div>
                  </div>
                </>
              )}
              {tab === "Details" && (
                <div className={styles.hzGvGrid}>
                  <div className={styles.hzGvCard}>
                    <h4>Guest</h4>
                    <dl className={styles.hzGvDl}>
                      <dt>Full name</dt><dd>{String(g.name)}</dd><dt>Nationality</dt><dd>{String(g.nationality)}</dd><dt>Phone</dt><dd>{String(g.phone)}</dd><dt>Email</dt><dd>{String(g.email)}</dd>
                      <dt>VIP</dt><dd>{String(g.vip)}</dd><dt>Loyalty</dt><dd>{tierLbl} · {num(g.points).toLocaleString()} pts</dd><dt>Preferences</dt><dd>{g.prefs ? String(g.prefs) : "None"}</dd>
                    </dl>
                  </div>
                  <div className={styles.hzGvCard}>
                    <h4>Reservation</h4>
                    <dl className={styles.hzGvDl}>
                      <dt>Booking ID</dt><dd>{String(res.id)}</dd><dt>Status</dt><dd><Pill text={status} /></dd><dt>Stay</dt><dd>{fdate(String(res.arrive))} → {fdate(String(res.depart))}</dd>
                      <dt>Room</dt><dd>{typeName}{res.room ? ` · ${String(res.room)}` : ""}</dd><dt>Rate plan</dt><dd>{planRow ? `${String(planRow.name)} (${String(planRow.code)})` : "—"}</dd>
                      <dt>Cancellation</dt><dd>{planRow ? String(planRow.cancel) : "—"}</dd><dt>Source</dt><dd>{String(res.source)}</dd>
                    </dl>
                  </div>
                  <div className={`${styles.hzGvCard} ${styles.hzGvWide}`}>
                    <h4>Folio</h4>
                    {folio.length === 0 && <p className={styles.hzHint}>No charges posted yet.</p>}
                    {folio.length > 0 && (
                      <div className={styles.hzGvTbl}>
                        {folio.map((c) => (<div key={String(c.id)}><span>{fshort(String(c.date))}</span><span>{String(c.desc)}</span><span>{String(c.dept)}</span><span>{c.kind === "Payment" ? "−" : ""}{money(num(c.amount))}</span></div>))}
                      </div>
                    )}
                  </div>
                </div>
              )}
              {tab === "Related" && (
                <div className={styles.hzGvGrid}>
                  <div className={`${styles.hzGvCard} ${styles.hzGvWide}`}>
                    <h4>Other stays by {String(g.name).split(" ")[0]}</h4>
                    {mine.length <= 1 && <p className={styles.hzHint}>This is their only stay.</p>}
                    <div className={styles.hzGvList}>
                      {mine.filter((r) => r.id !== res.id).map((r) => (
                        <div key={String(r.id)} role="button" tabIndex={0} onClick={() => onOpen(String(r.id))} onKeyDown={(e) => { if (e.key === "Enter") onOpen(String(r.id)); }}>
                          <strong>{fdate(String(r.arrive))}</strong><span>{nightsOf(r)} night{nightsOf(r) > 1 ? "s" : ""} · {nameOf(d, "roomtypes", r.roomType)}{r.room ? ` · Room ${String(r.room)}` : ""}</span><Pill text={String(r.status)} />
                        </div>
                      ))}
                    </div>
                  </div>
                  {([["Company", corp ? String(corp.name) : "", "Corporate account"], ["Travel agent", agent ? String(agent.name) : "", "Agent"], ["Room", res.room ? `Room ${String(res.room)}` : "", typeName]] as [string, string, string][]).map(([k, v, s]) => (
                    <div key={k} className={styles.hzGvCard}><h4>{k}</h4>{v ? <><strong className={styles.hzGvBig}>{v}</strong><small className={styles.hzGvSub}>{s}</small></> : <p className={styles.hzHint}>None linked.</p>}</div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {dlg && <BookingDialog key={dlg} mode={dlg} selfId={String(res.id)} bk={bkFromRes(d, res, bkInit(d))} onClose={() => setDlg(null)} onApply={apply} />}
      {toast && <div className={`${styles.hzToast} ${styles.hzToastFix}`} role="status" aria-live="polite">{toast}</div>}
    </div>
  );
};
const HospitalityManagement: React.FC = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isDrawawerOpen, setIsDrawerOpen] = useState(false);
  const [arrivals, setArrivals] = useState<Reservation[] | null>(null);
  const [reservationMsg, setReservationMsg] = useState<{ text: string; error: boolean } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [activeDiv, setActiveDiv] = useState<number | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState<Required<DrawerProps>["position"]>("start");
  const [selectedAccountingDate, setSelectedAccountingDate] = useState(new Date());
  const [selectedStartDate, setSelectedStartDate] = useState<Date | null>(new Date());
  const [selectedEndDate, setSelectedEndDate] = useState<Date | null>(new Date());
  const datePickerRef = useRef<any>(null); // Ref for DatePicker
  const [datePickers, setDatePickers] = useState<{ [key: string]: boolean }>({});
  const [guestDetails, setGuestDetails] = useState<Guest>(initializedGuest);
  const [guestInput, setGuestInput] = useState(""); // Tracks user input
  const [roomInput, setRoomInput] = useState(""); // Tracks user input
  const [roomOffer, setRoomOffer] = useState<boolean>(false);
  const [company, setCompany] = useState<Company[]>([]);
  const [roomCategory, setRoomCategory] = useState<Category[]>([]);
  const [roomTypes, setRoomTypes] = useState<HotelRoomType[]>([]);
  const [selectedRoomTypesInput, setSelectedRoomTypesInput] = useState<RoomType | null>(null);
  const [addNewRoom, setAddNewRoom] = useState<Room>(InitRoom);
  const [rooms, setRooms] = useState<Room[]>([]);
  const [selectedRoomTypeInput, setSelectedRoomTypeInput] = useState<string>("");
  const [visiblePicker, setVisiblePicker] = useState<string | null>(null);
  const [roomTypeInput, setRoomTypeInput] = useState(""); // Tracks user input
  const [selectedRoomType, setSelectedRoomType] = useState<string>("");
  const [selectedHotelRoom, setSelectedHotelRoom] = useState<string>("");
  const [isTabValueVisible, setIsTabValueVisible] = useState<string>("demography");
  const [bookingAction, setBookingAction] = useState<string>("New Reservation");
  const [hospitalityTabsDisplay, setHospitalityTabsDisplay] = useState<string>("HMS");
  const [guestInfo, setGuestInfo] = useState<string>("Guest Info");
  const [expandedCard, setExpandedCard] = useState<{ [key: string]: boolean }>({});
  const [propertyLocation, setPropertyLocation] = useState<HProperty[]>([]);
   const [selectedLocation, setSelectedLocation] = useState<string[]>([""]);
   const [selectedcompany, setSelectedcompany] = useState<string[]>([""]);
  const [selectedCompany, setSelectedCompany] = useState<Company | undefined>(undefined);
  const accessToken = localStorage.getItem('authToken');
  const [activeButton, setActiveButton] = useState("HMS"); // default active tab
  const [hzQuick, setHzQuick] = useState<string | null>(null);
  const [modulesDrawer, setModulesDrawer] = useState(false);
  const [hzD] = useHzData();
  const [bk, setBk] = useState<Bk>(() => bkInit(hzD));
  const [bkDlg, setBkDlg] = useState<BkMode | null>(null);
  const [bkToast, setBkToast] = useState<string | null>(null);
  useEffect(() => {
    if (!bkToast) return;
    const t = window.setTimeout(() => setBkToast(null), 3500);
    return () => window.clearTimeout(t);
  }, [bkToast]);
  const [isContactFormVisible, setIsContactFormVisible] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>("");
  const [activeWorkFlow, setActiveWorkFlow] = useState<string>("");
  const [searchQuery, setSearchQuery] = useState('');
  const [alwaysShow, setAlwaysShow] = useState<boolean>(true);
  //const [selectedWorkflow, setSelectedWorkflow] = useState<WorkflowTab | null>(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUserDetails, setSelectedUserDetails] = useState<string>("");
  const { user } = useAuth(); // Extract `refreshLogin`
  // the HMS tab reads the same database as the other tabs: load it here too (shared, so it is fetched once)
  const hzBoot = useHzBoot({ token: user?.token ?? localStorage.getItem("authToken") ?? undefined });
  const hzLoadingFirst = hzBoot.loading && !hzBoot.loadedAt; // first load: show skeletons instead of zeros
  const hzNum = (n: number) => hzLoadingFirst
    ? <Skeleton aria-hidden><SkeletonItem shape="rectangle" size={24} style={{ width: 28 }} /></Skeleton>
    : <>{n}</>;
  const hzProblem = hzBoot.error
    ? `The server could not be reached or refused the request: ${hzBoot.error}`
    : hzBoot.loadedAt && hzBoot.denied.includes("reservations")
      ? "Your account is not allowed to read reservations (permission RES.READ), so the days show 0."
      : hzBoot.loadedAt && rows(hzD, "reservations").length === 0
        ? `The database holds no reservations for property ${hzBoot.propertyId ?? ""}, so the days show 0. Create one with New Reservation, or load the demo data.`
        : "";
  const scrollRef = React.useRef<HTMLDivElement>(null);
  const [selectedTabId, setSelectedTabId] = useState<number | null>(1);
  const [bkEdited, setBkEdited] = useState(false); // the user changed the panel (New Reservation / Edit), so show it
  const bkv = bkView(hzD, bk, !bkEdited && !bkHasRes(hzD, off(Number(selectedTabId ?? 2) - 2)));
  const [isLeftselectedTab, setIsLeftselectedTab] = useState<number | null>(1);
  const [authToken, setAuthToken] = useState<string | null>(localStorage.getItem('authToken'));
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemWidth, setItemWidth] = useState(0);
  const itemRef = useRef<HTMLDivElement>(null);
  const carouselHostRef = useRef<HTMLDivElement>(null);
  const [hostWidth, setHostWidth] = useState(0);
  // Cards keep the size your CSS gives them. As many whole cards as fit are shown (at least 1); the gap between them is
  // shared out so the first card starts on the panel's left edge and the last one ends exactly on its right edge.
  // The gap stays between 4px and 16px (your design uses 10px), so the cards never look stretched or squeezed.
  const GAP_MIN = 4;
  const GAP_MAX = 16;
  const visibleCount = itemWidth > 0 && hostWidth > 0
    ? Math.min(CarouselItems.length, Math.max(1, Math.floor((hostWidth + GAP_MIN) / (itemWidth + GAP_MIN))))
    : 6;
  const CARD_GAP = visibleCount > 1 && itemWidth > 0 && hostWidth > 0
    ? Math.min(GAP_MAX, Math.max(GAP_MIN, (hostWidth - visibleCount * itemWidth) / (visibleCount - 1)))
    : 10;
  const stripWidth = itemWidth > 0 ? visibleCount * itemWidth + (visibleCount - 1) * CARD_GAP : undefined;
  const maxIndex = Math.max(CarouselItems.length - visibleCount, 0);
  const scrollRefH = useRef<HTMLDivElement>(null);
  const [canScrollLeftH, setCanScrollLeftH] = useState(false);
  const [canScrollRightH, setCanScrollRightH] = useState(false);
  const [guestTabsDisplay, setGuestTabsDisplay] = useState<string>("0");
    // initial item is "Upcoming"
  const [selectedRightTabItem, setSelectedRightTabItem] = useState<WorkflowCategory>(
  WorkflowCategories.Upcoming
);
const [workflowTabsState, setWorkflowTabs] = useState<WorkflowTab[]>(workflowTabs);
const [reservationPayload, setReservationPayload] = useState<Reservation>(initializedReservation)
 const [selectedRoomOptions, setSelectedRoomOptions] = useState<string[]>([""]);
 const [selectedGuestOptions, setSelectedGuestOptions] = useState<string[]>([""]);
 const [guestsDataset, setGuestsDataset] = useState<Guest[]>([]);
 const [totalNumberOfNights, setTotalNumberOfNights] = useState<Number>(0);
 const [arrivalDate, setArrivalDate] = useState<Date | null>(null);
const [departureDate, setDepartureDate] = useState<Date | null>(null);
const [iswitchChecked, setIswitchChecked] = useState<boolean>(false);

  /**
   * * Carousel State and Handlers
   * *
   */



  useEffect(() => {
    const measure = () => {
      if (itemRef.current) setItemWidth(itemRef.current.offsetWidth);
      if (carouselHostRef.current) setHostWidth(carouselHostRef.current.clientWidth);
    };
    measure();
    const ro = typeof ResizeObserver !== "undefined" ? new ResizeObserver(measure) : null;
    if (ro && carouselHostRef.current) ro.observe(carouselHostRef.current);
    window.addEventListener("resize", measure);
    return () => {
      ro?.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [guestTabsDisplay]);
  useEffect(() => {
    if (currentIndex > maxIndex) setCurrentIndex(maxIndex);
  }, [maxIndex]);

  const handleNext = () => {
    if (currentIndex < maxIndex) {
      setCurrentIndex(prev => prev + 1);
      setSelectedTabId(null);
      setIsLeftselectedTab(null);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(prev => prev - 1);
      setSelectedTabId(null);
      setIsLeftselectedTab(null);
    } else {
      setSelectedTabId(1);
      setIsLeftselectedTab(1);
    }
  };
  const scrollOffset = Math.min(currentIndex, maxIndex) * (itemWidth + CARD_GAP);
  // Scroll functions for the carousel  
  const scrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -120, behavior: "smooth" });
  };
  const scrollRight = () => {
    scrollRef.current?.scrollBy({ left: 120, behavior: "smooth" });
  };

  // One function to toggle expansion based on card ID
  const toggleExpand = (id: any) => {
    setExpandedCard((prev) => ({
      ...prev, // Keep previous state
      [id]: !prev[id], // Toggle only the clicked card
    }));
  };

  const [numberofNights, setNumberofNights] = useState<number>(0);
  // **Define a reusable function to format dates**
  const formatDate = (date: Date | null): { day: string; monthYear: string; fullDate: string } => {
    if (!date) return { day: "??", monthYear: "Select Date", fullDate: "" };
    return {
      day: dayjs(date).format("DD"), // Day (e.g., "22")
      monthYear: dayjs(date).format("MMM-YYYY"), // Month & Year (e.g., "Feb-2025")
      fullDate: dayjs(date).format("dddd, hh:mm A"), // Full formatted date (e.g., "Saturday, 11:00 AM")
    };
  };

  const PropertyLocations = ["Abuja", "Lagos", "Imo", "Abia", "Enugu", "Anambra"];
  const onClickStartButton = useCallback(() => {
    setPosition("start");
    setIsOpen(true);
  }, []);

  const onClickEndButton = useCallback(() => {
    setPosition("end");
    setIsOpen(true);
  }, []);

  const onClickBottomButton = useCallback(() => {
    setPosition("bottom");
    setIsOpen(true);
  }, []);



  let dateString = new Date().toISOString().split('T')[0];
  const [selectedDate, setSelectedDate] = React.useState<
    Date | null | undefined
  >(null);

  const goPrevious = React.useCallback(() => {
    setSelectedDate((prevSelectedDate) =>
      prevSelectedDate ? addDays(prevSelectedDate, -1) : null
    );
  }, []);

  const goNext = React.useCallback(() => {
    setSelectedDate((prevSelectedDate) =>
      prevSelectedDate ? addDays(prevSelectedDate, 1) : null
    );
  }, []);
  const toggleDrawer = () => {
    setIsDrawerOpen(prevIsOpen => !prevIsOpen);
  };


  //Booking form controls

  /**
   * Toggle handler for the "Walk-In" switch in the reservation form.
   *
   * Responsibilities:
   * - Updates the local UI switch state (`iswitchChecked`).
   * - Updates `reservationPayload.walkIn` using the functional updater to
   *   avoid race conditions with concurrent state updates.
   *
   * Behavior & guarantees:
   * - Synchronous, no network side effects.
   * - Preserves the rest of the `Reservation` object by spreading `prev`.
   *
   * Recommendations:
   * - Wrap with `useCallback` if this handler is passed to memoized children.
   * - If toggling requires additional side-effects (form validation, clearing
   *   dependent fields), perform them here or call a dedicated helper.
   * - Validate `reservationPayload` shape if your app mutates it elsewhere.
   *
   * @param e The change event from the walk-in checkbox/switch.
   */
const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setIswitchChecked(e.target.checked);
      setReservationPayload((prev: Reservation): Reservation => ({
      ...prev,
      walkIn: e.target.checked,
    }));
};

  const fetchCompany = async (access: any, ev: any) => {
    try {
      const tenantData = await apiCall({
        service: 'auth',
        endpoint: `Tenant/search?criteria=${ev}`,
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${access}`,
          'Content-Type': 'application/json'
        }
      });

      if (tenantData.error) {

      }

      return tenantData;
    } catch (error) {
      console.error('Error fetching arrivals:', error);

      return null;
    }
  };




    /**
     * Fetch details for a single RoomType by its identifier.
     *
     * Responsibilities:
     * - Calls the property service endpoint `RoomType/{id}` using the provided
     *   bearer token and returns a parsed `RoomType` on success.
     *
     * Behavior & guarantees:
     * - Uses the supplied `access` token (not an external `accessToken` variable)
     *   to build the Authorization header.
     * - Encodes the `id` when interpolating it into the endpoint to avoid URL
     *   encoding issues.
     * - If the API responds with an `error` property the function logs the
     *   issue and returns `null` (no exceptions leaked to the caller).
     * - Catches and logs unexpected network or parsing errors and returns `null`.
     *
     * Recommendations:
     * - Tighten parameter types (`access: string`, `id: number | string`) and
     *   return a typed promise `Promise<RoomType | null>` for compile-time safety.
     * - Consider throwing on non-recoverable API errors when callers need to
     *   distinguish error cases (4xx vs 5xx) instead of returning `null`.
     * - Use an AbortController/timeouts for long-running requests if needed.
     *
     * @param access Bearer token to use for the request (e.g., `user.token`).
     * @param id Identifier of the RoomType to fetch.
     * @returns {Promise<RoomType | null>} The RoomType object or `null` on error.
     */
    const fetchRoomTypes = async (access: any, id: any): Promise<any | null> => {
    try {
      const tenantData = await apiCall({
        service: 'property',
        endpoint: `RoomType/${encodeURIComponent(id)}`,
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${access}`,
          'Content-Type': 'application/json'
        }
      });

      if (tenantData?.error) {
        console.error('API error fetching room type:', tenantData.error);
        return null;
      }

      return tenantData;
    } catch (error) {
      console.error('Error fetching room types:', error);

      return null;
    }
  };

/**
 *  Fetch workflows based on category
 * @param accessToken 
 * @param category 
 * @returns 
 */

const fetchWorkflowsTabItems = async (
  accessToken: string,
  category: string
): Promise<GuestWorkflow[] | RoomWorkflow[] | null> => {
  try {
    const workflowData = await apiCall({
      service: "property",
      endpoint: `Workflow?category=${encodeURIComponent(category)}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    // Handle API errors if your apiCall returns { error: ... }
    if (workflowData.error) {
      console.error("API error:", workflowData.error);
      return null;
    }

    return workflowData as GuestWorkflow[] | RoomWorkflow[];
  } catch (error) {
    console.error("Error fetching workflows:", error);
    return null;
  }
};

/**
 * Loads workflow items for a given category and normalizes them into
 * the local `WorkflowTab` format consumed by the UI.
 *
 * Responsibilities:
 * - Calls `fetchWorkflowsTabItems` with the current user's token and the
 *   requested `category`.
 * - Maps API responses into a consistent `WorkflowTab[]` shape expected by
 *   `setWorkflowTabs` (guest workflows vs. room workflows are handled
 *   differently).
 * - Side-effects by updating `workflowTabs` via `setWorkflowTabs`.
 *
 * Behavior & guarantees:
 * - If `category` matches guest-oriented categories ("Upcoming", "Checked-In Guests",
 *   or "Checking Out Today"), the function will treat the response as
 *   `GuestWorkflow[]` and produce guest-mapped tabs.
 * - Otherwise the response is treated as `RoomWorkflow[]` and mapped accordingly.
 * - Uses `??` and fallback values to ensure UI fields are never undefined
 *   (e.g., `datetime`, `avatar`, `role`, `company`).
 * - If `fetchWorkflowsTabItems` returns falsy or errors, no state is mutated.
 *
 * Notes & recommendations:
 * - Consider returning the mapped array (or throwing on network errors) instead
 *   of only mutating state; this improves testability and separation of concerns.
 * - Prefer a tight type for `category` (e.g., `WorkflowCategory`) instead of `any`
 *   to catch invalid values at compile time.
 * - If performance becomes an issue, add pagination/limits to the API call and
 *   memoize mappings where appropriate.
 *
 * @param category The workflow category to load (string or enum value).
 * @returns {Promise<void>} Resolves after `workflowTabs` has been updated.
 */
const loadWorkflows = async (category: WorkflowCategory): Promise<WorkflowTab[]> => {
  const workflows = await fetchWorkflowsTabItems(user.token, category);

  // API wiring point: if the request fails or returns nothing we fall back to local sample data so the filter still works.
  if (!workflows || workflows.length === 0) return hzWorkflowTabs(hzD, category);

  if (category === WorkflowCategories.Upcoming || category === WorkflowCategories.CheckedInGuests || category === WorkflowCategories.CheckingOutToday) {
    const guests = workflows as GuestWorkflow[];
    return guests.map((g) => ({
      id: g.guestId.toString(),
      name: g.fullName,
      role: g.role ?? "",
      company: g.company ?? "",
      datetime: g.checkInTime ?? new Date().toISOString(),
      avatar: g.avatarUrl ?? ""
    }));
  }

  const rooms = workflows as RoomWorkflow[];
  return rooms.map((r) => ({
    id: r.roomId.toString(),
    name: `Room ${r.roomNumber}`,
    role: r.roomType,
    company: r.roomCategory,
    datetime: r.updatedAt ?? new Date().toISOString(),
    avatar: "" // rooms may not have avatars
  }));
};


/** * Fetch property locations based on search query
 * @param accessToken 
 * @param ev 
 * @returns 
 */
  const fetchPropertyLocation = async (accessToken: any, ev: any) => {
    try {
      const arrivalsData = await apiCall({
        service: 'property',
        endpoint: `hotels/search?query=${ev}`,
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        }
      });

      if (arrivalsData.error) {

      }

      return arrivalsData;
    } catch (error) {
      console.error('Error fetching arrivals:', error);

      return null;
    }
  };
  const retrievePropertyLocation = async (id: any) => {
    var locations = await fetchPropertyLocation(user.token, id);
    if (locations) {
      setLoading(false);
      setPropertyLocation(locations);
    }
  }

  const mapApiResponseToCompany = (apiResponse: any): Company[] => {
    if (!apiResponse?.$values || !Array.isArray(apiResponse.$values)) {
      return []; // Ensure safe handling if response is malformed
    }

    return apiResponse.$values.map((tenant: any) => ({
      id: tenant.id,
      name: tenant.name,
      tenantId: tenant.tenantId,
      contactEmail: tenant.contactEmail,
      contactPhone: tenant.contactPhone,
      address: tenant.address,
      city: tenant.city,
      state: tenant.state,
      country: tenant.country,
      postalCode: tenant.postalCode,
      createdAt: tenant.createdAt,
      updatedAt: tenant.updatedAt,
      subscriptionPlan: tenant.subscriptionPlan,
      subscriptionExpiry: tenant.subscriptionExpiry,
      isActive: tenant.isActive,
      billingContact: tenant.billingContact,
      billingAddress: tenant.billingAddress,
      paymentMethod: tenant.paymentMethod,
      isPaymentCurrent: tenant.isPaymentCurrent,
      redirectUri: tenant.redirectUri,
      industry: tenant.industry,
      size: tenant.size,
      notes: tenant.notes,
      receiveNewsletter: tenant.receiveNewsletter,
      preferredLanguage: tenant.preferredLanguage,
      technicalContact: tenant.technicalContact,
      administrativeContact: tenant.administrativeContact,
      configuration: tenant.configuration,
      userCount: tenant.userCount,
      lastLogin: tenant.lastLogin
    }));
  };





  const fetchArrivals = async (accessToken: any, date: string) => {
    try {
      const arrivalsData = await apiCall({
        service: 'property',
        endpoint: `Reservations/arrivals?date=${date}`,
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${user.token}`,
          'Content-Type': 'application/json'
        }
      });

      if (arrivalsData.error) {

      }

      return arrivalsData;
    } catch (error) {
      console.error('Error fetching arrivals:', error);

      return null;
    }
  };

  useEffect(() => {
    const getArrivals = async () => {
      try {
        const data = await fetchArrivals(accessToken, dateString);
        setArrivals(data);

      } catch (error) {
        console.log(error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 4458000);

      }
    };

    getArrivals();
  }, [accessToken, dateString]);

  const fetchCategories = React.useCallback(async (query: string) => {
    setLoading(true);
    const categories = await FetchAllRoomCategory(accessToken, query);
    setRoomCategory(categories);
    setLoading(false);
  }, [accessToken]);

  const FetchAllRoomCategory = async (accessToken: any, query: string) => {
    try {
      const response = await apiCall({
        service: 'property',
        endpoint: `RoomCategory?query=${query}`,
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        }
      });
      return response;
    } catch (error) {
      console.error('Error fetching room categories:', error);
      return null;
    }
  };

  // const handleGuestChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const inputValue = event.target.value.trim();
  //   setGuestInput(inputValue); // Update input value

  //   // Check if the entered value matches any existing guest
  //   const existingGuest = guestDetails.find(
  //     (guest) =>
  //       `${guest.firstName} ${guest.lastName}`.toLowerCase() === inputValue.toLowerCase()
  //   );

  //   setSelectedGuest(existingGuest || null);
  // };


  const handleShowsEndDate = (id: string) => {
    setVisiblePicker(id);
  }
  const handleClick = (index: number) => {
    setActiveDiv(index);
  };


  const handleRoomTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value.trim();
    setRoomTypeInput(inputValue); // Update user input value

    // Check if the entered value matches an existing room type
    const existingRoomType = roomCategory.find(
      (room) => room.categoryName.toLowerCase() === inputValue.toLowerCase()
    );

    setSelectedRoomType(existingRoomType ? existingRoomType.categoryId.toString() : inputValue);
  };


  const handleHotelRoomTypeChange = (event: React.ChangeEvent<any>) => {
    setSelectedRoomTypeInput(event.target.value);
  }



  const handleHotelRoomChange = (event: React.ChangeEvent<any>) => {
    setSelectedHotelRoom(event.target.value);
  }

  const handleTabControler = (id: any) => {
    setIsTabValueVisible(id);
  }


  /*****Hospitality tab */
  const handleHospitalityTablimit = (res: any) => {
    setActiveButton(res);
    setHospitalityTabsDisplay(res);
    if (res === "Modules") setModulesDrawer(true);
    console.log("Hospitality Tab Selected: ", res);
    
  };



  const handleBookingTemplate = (id: any) => {
    setBookingAction(id);
    setIsFormOpen(true)
  }


  const handleRoomOfferClose = () => {
    setRoomOffer(false);
  }


const handleLocationChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
  const value = e.target.value.trim();
  if (value.length <= 1) {
    setPropertyLocation([]);
    return;
  }

  setLoading(true);
  try {
    const data: HProperty[] =  await fetchPropertyLocation(user.token, value);
    if (Array.isArray(data) && data.length > 0) {
      setPropertyLocation(data);
    } else {
      // No matches: do not touch reservation; just clear suggestions (or show "no matches")
      setPropertyLocation([]);
      // Optionally: set a "no matches" state to inform the user
      // setRoomNoMatches(true);
    }
  } finally {
    setLoading(false);
  }
};




  const groupedTabs = workflowTabsState.reduce<Record<string, WorkflowTab[]>>((acc, tab) => {
    const date = parseISO(tab.datetime);
    const groupLabel = isToday(date)
      ? 'Today'
      : format(date, 'MMMM d');

    if (!acc[groupLabel]) {
      acc[groupLabel] = [];
    }
    acc[groupLabel].push(tab);
    return acc;
  }, {} as Record<string, WorkflowTab[]>);


  const sortedGroupedTabs = Object.entries(groupedTabs)
    .sort(([dateA], [dateB]) => {
      const parsedA = parse(dateA, 'MMMM d', new Date());
      const parsedB = parse(dateB, 'MMMM d', new Date());
      return parsedB.getTime() - parsedA.getTime(); // recent first
    });



  const handleSelectWorkFlow = (selectw: any, userid: any) => {
    setActiveWorkFlow(selectw);
    console.log("Contact Form Closed: ", isContactFormVisible);
    // Optional: show loading indicator here
    const userDetails = null;//await fetchUserDetails(id); // Your API or lookup function
    setSelectedUserDetails("1");
      setGuestTabsDisplay(userid);
    console.log("Selected User Details: ", selectedUserDetails);
  }

  // className={`${styles.clieTWU2Vc}

  const ButtonTabs = [
    { key: "HMS", label: "HMS", icon: <img src={hospitality} alt="HMS" height={22} width={22} /> },
    { key: "Reservations", label: "Reservations", icon: <Calendar16Regular /> },
    { key: "Operations", label: "Operations", icon: <ArrowSync16Regular /> },
    { key: "Guest", label: "Guest", icon: <Guest16Regular /> },
    { key: "Clients Relations", label: "Clients Relations", icon: <CalendarPerson16Regular /> },
    { key: "Booking", label: "Booking", icon: <BookOpen16Regular /> },
    { key: "Reports", label: "Reports", icon: <DocumentCheckmark16Regular /> },
    { key: "Inventory", label: "Inventory", icon: <Guest16Regular /> },
    { key: "Modules", label: "More modules", icon: <AppsBulletListRegular />},
    { key: "AI assistant", label: "AI assistant", icon: <HzSparkle20Regular /> },
  ];


  const handleRoomSelected = (id: any) => {
    setSelectedTabId(id);
    setIsLeftselectedTab(id);
    setBkEdited(false);
    setBk((b) => bkForDay(hzD, off(Number(id) - 2), b));
  }



  // Cubic Bézier easing function (implements the curve calculation)
  const cubicBezier = (x1: any, y1: any, x2: any, y2: any) => {
    return (t: any) => {
      if (t === 0 || t === 1) return t;
      let start = 0;
      let end = 1;
      while (end - start > 0.001) {
        const mid = (start + end) / 2;
        const x = 3 * mid * (1 - mid) * (1 - mid) * x1 + 3 * mid * mid * (1 - mid) * x2 + mid * mid * mid;
        if (x >= t) end = mid;
        else start = mid;
      }
      return 3 * end * (1 - end) * (1 - end) * y1 + 3 * end * end * (1 - end) * y2 + end * end * end;
    };
  };

  // Use ease-in-out curve: cubic-bezier(0.42, 0, 0.58, 1)
  // Adjust these values for different feels (e.g., 0.25, 0.1, 0.25, 1 for standard ease-in-out)
  const easing = cubicBezier(0.42, 0, 0.58, 1);

  const animateScroll = (element: any, delta: any, duration = 300) => {
    if (!element) return;
    const start = element.scrollLeft;
    const target = start + delta;
    const startTime = performance.now();

    const animate = (currentTime: any) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = easing(progress);
      element.scrollLeft = start + delta * easedProgress;

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        updateScrollButtons(); // Ensure buttons update after animation ends
      }
    };

    requestAnimationFrame(animate);
  };

  const scrollLeftH = () => {
    animateScroll(scrollRefH.current, -200); // Scroll left by 200px
  };

  const scrollRightH = () => {
    animateScroll(scrollRefH.current, 200); // Scroll right by 200px
  };

  const updateScrollButtons = () => {
    const el = scrollRefH.current;
    if (el) {
      const { scrollLeft, scrollWidth, clientWidth } = el;
      setCanScrollLeftH(scrollLeft > 0);
      setCanScrollRightH(scrollLeft + clientWidth < scrollWidth - 1);
    }
  };

  useEffect(() => {
    const el = scrollRefH.current;
    if (!el) return;
    updateScrollButtons();
    el.addEventListener("scroll", updateScrollButtons);
    window.addEventListener("resize", updateScrollButtons);
    return () => {
      el.removeEventListener("scroll", updateScrollButtons);
      window.removeEventListener("resize", updateScrollButtons);
    };
  }, []);



  useEffect(() => {
  let live = true;
  loadWorkflows(selectedRightTabItem).then((tabs) => {
    if (live) setWorkflowTabs(tabs);
  });
  return () => { live = false; };
  // loadedAt changes every time the database data is (re)loaded, so the list follows it
}, [selectedRightTabItem, hzBoot.loadedAt]);

// the first time the data arrives, show the selected day's booking in the Overview panel
const bkSeeded = useRef(false);
useEffect(() => {
  if (!hzBoot.loadedAt || bkSeeded.current) return;
  bkSeeded.current = true;
  setBk((b) => bkForDay(hzD, off(Number(selectedTabId ?? 2) - 2), b.roomType ? b : bkInit(hzD)));
}, [hzBoot.loadedAt]);


/** Generic handler for room option selection *

  function createRoomOptionSelectHandler<T>(
    setSelected: (values: string[]) => void,
    dataset: T[],
    key: keyof Rooms, // e.g. "amenityId" | "serviceId"
    matchFn: (item: T, selectedValue: string) => boolean,
    getValue: (item: T, selectedValue: string) => string
  ): ComboboxProps["onOptionSelect"] {
    return (ev, data) => {
      console.log("Selected value:", data.optionValue);
      const selectedValue = data.optionValue;
      setSelected(data.selectedOptions);

      if (!selectedValue) return;

      const match = dataset.find(item => matchFn(item, selectedValue));
      setReservationPayload({
    ...reservationPayload,
    room: {
      ...reservationPayload.room,
       [key]: match ? getValue(match, selectedValue) : selectedValue,
    },
  });
    };
  }
**/
/** Generic handler for guest option selection */

function createOptionSelectHandler<T>(
  setSelected: (values: string[]) => void,
  dataset: T[],
  target: "guest" | "room", // which nested object to update
  key: keyof Guest | keyof Room, // property inside guest or room
  matchFn: (item: T, selectedValue: string) => boolean,
  getValue: (item: T, selectedValue: string) => string
): ComboboxProps["onOptionSelect"] {
  return (ev, data) => {
    console.log("Selected value:", data.optionValue);
    const selectedValue = data.optionValue;
    setSelected(data.selectedOptions);

    if (!selectedValue) return;

    const match = dataset.find(item => matchFn(item, selectedValue));
    const newValue = match ? getValue(match, selectedValue) : selectedValue;

    setReservationPayload(prev => ({
      ...prev,
      [target]: {
        ...prev[target],
        [key]: newValue,
      },
    }));
  };
}





/**
 * Handles the selection of a Room and triggers retrieval of its associated RoomType details.
 *
 * This function is designed to be invoked when a user selects a Room option in the UI.
 * It performs the following responsibilities:
 *  1. Calls the backend service to fetch RoomType information for the selected Room.
 *  2. Updates the local state with the fetched RoomType data so that dependent components
 *     can react accordingly (e.g., display available room types, pricing, etc.).
 *  3. Provides robust error handling to ensure failures are logged without breaking the UI.
 *
 * @param match - The Room object selected by the user. Must contain a valid `roomType` identifier.
 *
 * @remarks
 * - This function is asynchronous and should not be awaited directly in synchronous event handlers.
 *   Instead, it can be invoked using `void handleTypesRoomSelection(...)` or wrapped in an async IIFE.
 * - Errors are caught and logged to the console for diagnostic purposes. In production, consider
 *   integrating with a centralized logging/monitoring solution (e.g., Application Insights, Sentry).
 */
const handleTypesRoomSelection = async (match: Room) => {
  try {
    // Fetch the RoomType details from the backend using the user's token and the selected roomType.
    const result = await fetchRoomTypes(user.token, Number(match.roomType));
       // Update state with the fetched RoomType so the UI reflects the new selection.
    setSelectedRoomTypesInput(result);
    console.log("Fetched RoomType:", selectedRoomTypesInput);
 
  } catch (error) {
    // Log the error for debugging. Replace with enterprise-grade logging in production.
    console.error("Failed to fetch room types:", error);
  }
};


/**
 * Handles option selection from the room combobox.
 *
 * - Updates the selected option state (`selectedRoomOptions`).
 * - Finds the matching room object from the dataset.
 * - Updates the reservation payload with the selected room.
 *
 * @param ev Combobox event
 * @param data Selected option data
 */
const roomHandler: ComboboxProps["onOptionSelect"] = (ev, data) => {
  setSelectedRoomOptions(data.selectedOptions);

  const selectedValue = data.optionValue;
  //const match = rooms.find(r => r.roomNumber === selectedValue);
  const match = rooms.find((f): f is Room => f.roomNumber === selectedValue);

  console.log("Selected room value:", match);
  if (match) {
    setReservationPayload(prev => ({
      ...prev,
      roomId: match.roomId,
      room: match,
    }));

    // Replace typed input with the selected room name
    setRoomInput(match.roomName);

    // Fire and forget async work
    void handleTypesRoomSelection(match);

  }
};



/**
 * Handles selection of a company from the company combobox.
 *
 * Responsibilities:
 * - Maps the selected `data.optionValue` (expected to be a stringified company id)
 *   to a Company entry from `company` state.
 * - Updates UI selection state via `setSelectedCompany` with the matched object.
 * - Atomically updates `reservationPayload` (functional updater) with `companyId`
 *   and `companyName` to avoid race conditions.
 *
 * Behavior & guarantees:
 * - Uses strict string comparison (`id.toString() === optionValue`) to reliably
 *   match values without unexpected coercion.
 * - If no match is found, no state mutation occurs (no accidental writes to
 *   `reservationPayload`).
 *
 * Edge cases & recommendations:
 * - Tolerant to missing or malformed `optionValue` (treated as a no-op).
 * - If `id` is guaranteed numeric, consider using `Number(optionValue)` for clarity
 *   and to avoid subtle mismatches when IDs are zero-padded or formatted.
 * - For high-integrity flows, validate selection against a server-side source of
 *   truth before persisting to backend systems.
 *
 * Side effects: calls `setSelectedCompany` and `setReservationPayload` (React state setters).
 */
const companyHandler: ComboboxProps["onOptionSelect"] = (ev, data) => {
  const selectedValue = data.optionValue;
  const match = company.find(c => c.id.toString() === selectedValue);
  if (match) {
    setSelectedCompany(match);
    setReservationPayload((prev: Reservation): Reservation => ({
      ...prev,
      company: match.name + " //" + match.id.toString(),
    }));
  }
};



/**
 * Handles the selection of a property from the property combobox.
 *
 * Responsibilities:
 * - Maps the selected `data.optionValue` (expected to be a stringified hotelId)
 *   to an item in `propertyLocation`.
 * - Updates local UI state via `setSelectedLocation` (stores the matched HProperty
 *   or `undefined` when no match exists).
 * - Atomically updates `reservationPayload` with the property's identifiers and
 *   location using the functional updater form to avoid race conditions.
 *
 * Behavior & guarantees:
 * - Uses strict string comparison (`hotelId.toString() === optionValue`) to match
 *   the selected option with a property entry.
 * - If a match is found, only the following reservation fields are updated:
 *     - `propertyId`, `propertyName`, `propertyLocation`.
 * - If no match is found, `selectedLocation` is cleared and `reservationPayload`
 *   is left unchanged (no accidental writes).
 *
 * Edge cases & recommendations:
 * - Tolerant to missing or falsy `optionValue` values (no-op when falsy).
 * - If hotelId is guaranteed numeric, consider parsing `optionValue` with `Number`
 *   for clarity and to avoid subtle mismatches.
 * - For authoritative selection in distributed environments, validate against the
 *   server-side source of truth before persisting.
 *
 * Side effects: calls `setSelectedLocation` and `setReservationPayload` (React state setters).
 */
const propertyHandler: ComboboxProps["onOptionSelect"] = (ev, data) => {
  const selectedValue = data.optionValue;
  const match = propertyLocation.find(p => p.hotelId.toString() === selectedValue);
  setSelectedLocation(match?.hotelName ? [match.hotelName] : [""]);
  console.log("Selected Property Location: " + JSON.stringify(match));
  if (match) {
    setReservationPayload((prev: Reservation): Reservation => ({
      ...prev,
      propertyId: match.hotelId,
      propertyName: match.hotelName,
      propertyLocation: match.location,
    }));
  } 
};


/**
 * Handles option selection for the guest combobox.
 *
 * - If a dataset match is found (user clicked an option), updates the reservation payload
 *   with the full guest object from `guestsDataset`.
 * - If no dataset match exists (user typed free‑text only), falls back to parsing the typed
 *   input into first/last name and updates the payload manually.
 *
 * @param ev Combobox event
 * @param data Selected option data
 */
const guestHandler: ComboboxProps["onOptionSelect"] = (ev, data) => {
  const selectedValue = data.optionValue;
  setSelectedGuestOptions(data.selectedOptions);

  // Try to find a dataset match
  const match = guestsDataset.find(g => g.guestId.toString() === selectedValue);

  if (match) {
    // User selected an existing guest
    setReservationPayload((prev: Reservation): Reservation => ({
      ...prev,
      guestId: match.guestId,
      guest: match,
    }));

    // Replace typed input with the selected guest’s full name
    setGuestInput(`${match.firstName} ${match.lastName}`);
  } else {
    // No dataset match → fallback to typed text
    const parts = guestInput.trim().split(" ");
    const firstName = parts[0] || "";
    const lastName = parts.slice(1).join(" ") || "";

    setReservationPayload((prev: Reservation): Reservation => ({
      ...prev,
      guestId: 0, // no dataset match
      guest: {
        guestId: 0,       // <-- explicitly required
        firstName,
        lastName,
        email: prev.email ?? "",   // safe defaults
        phone: prev.phoneNumber ?? "",
        address: "",               // or leave optional if you made Guest fields optional
        ...prev.guest,             // spread AFTER to preserve other fields if they exist
      },
    }));
  }
};




 //Fetch Rooms
  const autocompleteRoom = async (access: any, query:any) => {
    try {
      const response = await apiCall({
        service: "property",
        endpoint: `Rooms/autocomplete?query=${encodeURIComponent(query)}`, // Adjust the endpoint as needed
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });

      if (response.error) {
        console.error("Error fetching rooms:", response.error);
        return [];
      }

      return response;
    } catch (error) {
      console.error("Error fetching rooms:", error);
      return [];
    }
  };

/* Free‑text input handler for guest combobox */

const autocompleteGuest = async (access: any, query: any) => {
  try {
    const response = await apiCall({
      service: "property",
      endpoint: `Guests/autocomplete?query=${encodeURIComponent(query)}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${access}`,
        "Content-Type": "application/json",
      },
    });

    if (response.error) {
      console.error("Error fetching rooms:", response.error);
      return [];
    }

    return response; // <-- this is JSON already
  } catch (error) {
    console.error("Error fetching rooms:", error);
    return [];
  }
};


/**
 * Handles free‑text input for the guest combobox.
 * 
 * - Updates the local input state so the combobox reflects typed text.
 * - Calls the autocomplete API to fetch matching guests.
 * - If matches are found, updates the dataset for dropdown suggestions.
 * - If no matches are found, falls back to using the typed text
 *   and updates the reservation payload with first/last name.
 * 
 * @param e React change event from the combobox input
 */
const handleGuestCategoryChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
  const value = e.target.value;
  setGuestInput(value);

  if (!value) return;

  try {
    const results = await autocompleteGuest(user.token, value);

    if (results && results.length > 0) {
      setGuestsDataset(results);
    } else {
      const parts = value.trim().split(" ");
      const firstName = parts[0] || "";
      const lastName = parts.slice(1).join(" ") || "";
      const guestName = [firstName, lastName].filter(Boolean).join(" ");

      setReservationPayload((prev: Reservation): Reservation => ({
        ...prev,
        guestId: 0, // new guest
        guestName,
        guest: {
          ...prev.guest,
          guestId: 0,       // <-- ensure required field is present
          firstName,
          lastName,
        },
      }));
    }
  } catch (err) {
    console.error("Guest autocomplete failed:", err);
  }
};

/**
 * Handles free‑text input for the room combobox.
 *
 * - Updates the local input state (`roomInput`) so the combobox reflects what the user typed.
 * - If the input length is greater than 1 character, triggers an autocomplete API call
 *   to fetch matching rooms from the backend.
 * - Sets the `rooms` state with the returned dataset to populate dropdown options.
 * - Displays a loading indicator while the API request is in progress.
 * - If the input length is too short, clears the room suggestions.
 * - If no matches are found, falls back to using the typed text
 *   and updates the reservation payload with a partial room object.
 *
 * @param e React change event from the combobox input field
 */

const handleRoomCategoryChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
  const value = e.target.value.trim();
  setRoomInput(value);

  if (value.length <= 1) {
    setRooms([]);
    return;
  }

  setLoading(true);
  try {
    const data: Room[] = await autocompleteRoom(user.token, value);

    if (Array.isArray(data) && data.length > 0) {
      setRooms(data);
    } else {
      // No matches: do not touch reservation; just clear suggestions (or show "no matches")
      setRooms([]);
      // Optionally: set a "no matches" state to inform the user
      // setRoomNoMatches(true);
    }
  } finally {
    setLoading(false);
  }
};


/**
 * Handles user input changes for the company autocomplete field.
 *
 * Responsibilities:
 * - Reads the typed value from the input event, trims and validates it.
 * - If input length is short (<= 1), clears company suggestions and returns early
 *   to avoid unnecessary network calls.
 * - Sets a loading flag while performing an async autocomplete lookup using
 *   `fetchCompany` and updates `company` state with the returned suggestions.
 *
 * Behavior & guarantees:
 * - Operates on the trimmed input value to avoid accidental whitespace mismatches.
 * - Guarantees `setLoading(true)` runs before the network call and is cleared in
 *   `finally` so the UI won't get stuck in a loading state.
 * - If `fetchCompany` returns a non-array or an empty array, suggestions are
 *   safely cleared (`setCompany([])`).
 *
 * Edge cases & recommendations:
 * - Network race conditions: consider debouncing input and cancelling previous
 *   requests (AbortController) to avoid stale results overriding newer ones.
 * - Error handling: `fetchCompany` can return `null`; for production add explicit
 *   error logging and optionally surface user-friendly messages.
 * - Types: prefer a stricter signature for `fetchCompany` (e.g., `Promise<Company[]>`
 *   or `Promise<Company[] | null>`) and tighten the event type where possible.
 *
 * Side effects: updates `company` and `loading` React state values.
 *
 * @param e The native change event from the company input element.
 * @returns {Promise<void>} Resolves after suggestions are updated (or cleared).
 */
const handleCompanyChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
  const value = e.target.value.trim();
  console.log("Typed value:", value);

  if (value.length === 0) {
    setCompany([]);
    return;
  }

  setLoading(true);
  try {
    const raw = await fetchCompany(user.token, value);
    console.log("Raw fetched data:", raw);

    // unwrap $values
    const companies: Company[] = raw?.$values?.map((c: any) => ({
      ...c,
      tenantId: c.tenantId ?? null,
      socialProfiles: c.socialProfiles?.$values ?? []
    })) ?? [];

    if (companies.length > 0) {
      setCompany(companies);
    } else {
      setCompany([]);
    }
  } catch (err) {
    console.error("Error fetching company:", err);
    setCompany([]);
  } finally {
    setLoading(false);
  }
};


/// Generic handler for top-level reservation fields
const handleReservationFieldChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  field: keyof Reservation
) => {
  let value: string | number = e.target.value;

  // Auto-convert to number if the Reservation field is numeric
  if (["reservationId", "propertyId", "guestId", "roomId", "numberOfNights",
       "numberOfAdults", "numberOfChildren", "numberOfInfants", "totalAmount"].includes(field)) {
    value = Number(value);
  }

  setReservationPayload(prev => ({
    ...prev,
    [field]: value,
    booker: user.userId, // always set booker to current user
  }));
};


/**
 * Calculates the total number of nights between arrival and departure dates
 * and updates the reservation payload + local state for display.
 *
 * @param checkIn Date object for arrival
 * @param checkOut Date object for departure
 */
const updateNumberOfNights = async (checkIn: Date | null, checkOut: Date | null) => {
  if (!checkIn || !checkOut) {
    setTotalNumberOfNights(0);
    setReservationPayload(prev => ({
      ...prev,
      numberOfNights: 0,
    }));
    return;
  }

  // Difference in milliseconds
  const diffMs = checkOut.getTime() - checkIn.getTime();

  // Convert to days
  const nights = diffMs > 0 ? Math.ceil(diffMs / (1000 * 60 * 60 * 24)) : 0;

  setTotalNumberOfNights(nights);

  setReservationPayload(prev => ({
    ...prev,
    numberOfNights: nights,
    checkInDate: checkIn.toISOString(),
    checkOutDate: checkOut.toISOString(),
  }));


};

// Arrival
const handleArrivalDateChange =  (name: string) => (date: Date | null | undefined) => {
  if (date) {
    console.log(`The Date onSelectDate for ${name}`, date);
     setReservationPayload(prev => ({
    ...prev,
    name: date.toISOString(),
  }));
  void updateNumberOfNights(date, reservationPayload.checkInDate ? new Date(reservationPayload.checkOutDate) : null);
  }
};

// Departure

const handleDepartureDateChange =  (name: string) => (date: Date | null | undefined) => {
  if (date) {
    console.log(`The Date onSelectDate for ${name}`, date);
    setReservationPayload(prev => ({
    ...prev,
    [name]: date.toISOString(),
  }))
  void updateNumberOfNights(reservationPayload.checkInDate ? new Date(reservationPayload.checkOutDate) : null, date);
  }
};


  const ReservaRoom = async (access: any, reservationData: Reservation) => {
    try {
      const response = await apiCall({
        service: "property",
        endpoint: "Reservations", // Adjust the endpoint as needed
        method: "POST",
        headers: {
          Authorization: `Bearer ${access}`,
          "Content-Type": "application/json",
        },
        data: reservationData, // Include roomData in the request body
      });

      if (response.error) {
        console.error("Error registering room:", response.error);
            
        return null;
      }
      return response;
    } catch (error) {
      console.error("Error registering room:", error);
      
      return null;
    }
  };


/**
 * Submits the current `reservationPayload` to the backend and handles
 * post-submission UI updates.
 *
 * Responsibilities:
 * - Logs the payload for debugging during development.
 * - (Intended) calls `ReservaRoom` to perform the network POST of the
 *   reservation and handles the response (success / failure) accordingly.
 * - On success the form should be closed and any follow-up UI/cleanup
 *   should be executed (notifications, clearing local form state, etc.).
 *
 * Behavior & guarantees:
 * - This is an async function that returns a Promise<void>.
 * - Currently the network call is commented out for safety during local
 *   development; when enabling it, ensure proper error handling and
 *   user-facing feedback are added.
 *
 * Edge cases & recommendations:
 * - Validate `reservationPayload` (required fields, date ranges, numeric
 *   constraints) before calling the API to avoid needless network traffic.
 * - Add try/catch around the API call and surface friendly messages on
 *   failure (toast / inline warning) and use centralized logging for
 *   diagnostics.
 * - Consider optimistically updating the UI and rolling back on failure,
 *   or show a loading state to prevent duplicate submissions.
 * - When you re-enable the call to `ReservaRoom`, ensure the token used
 *   (`user.token`) is valid and handle 401/403 responses by prompting re-auth.
 */
  const handleReservationRegisters = async () => {
    const p = reservationPayload as any;
    const arrive = String(p.checkInDate ?? "").slice(0, 10);
    const depart = String(p.checkOutDate ?? "").slice(0, 10);
    const roomTypeId = Number((selectedRoomTypesInput as any)?.roomTypeId ?? (selectedRoomTypesInput as any)?.id ?? p.roomTypeId ?? 0);
    const existingGuest = Number(p.guestId) > 0;
    const guestName = `${p.guest?.firstName ?? ""} ${p.guest?.lastName ?? ""}`.trim() || String(p.guestName ?? "").trim();
    const problem = !existingGuest && !guestName ? "Choose a guest or enter the guest's name."
      : !roomTypeId ? "Choose a room type."
      : !arrive || !depart ? "Choose the arrival and departure dates."
      : depart <= arrive ? "Departure must be after arrival."
      : null;
    if (problem) { setReservationMsg({ text: problem, error: true }); return; }
    setReservationMsg({ text: "Saving…", error: false });
    try {
      await hzPost("/api/dashboard/reservations", {
        propertyId: hzPropertyId(),
        guestId: existingGuest ? Number(p.guestId) : null,
        guest: existingGuest ? null : { name: guestName, phone: p.guest?.phone || p.phoneNumber || null, email: p.guest?.email || p.email || null },
        roomTypeId,
        roomId: Number(p.roomId) > 0 ? Number(p.roomId) : null,
        arrive,
        depart,
        adults: Number(p.numberOfAdults) > 0 ? Number(p.numberOfAdults) : 1,
        children: Number(p.numberOfChildren) > 0 ? Number(p.numberOfChildren) : 0,
        source: p.walkIn ? "Walk-in" : "Direct",
      });
      await hzReload();
      setReservationMsg(null);
      handleClearReservation();
      setIsFormOpen(false);
    } catch (err) {
      setReservationMsg({ text: err instanceof Error ? err.message : "The reservation could not be saved.", error: true });
    }
  };

/**
 * Clears the reservation form state back to a safe default.
 *
 * Responsibilities:
 * - Resets `reservationPayload` and clears any selected guest/room options
 *   that were part of the in-progress booking.
 *
 * Behavior & guarantees:
 * - Resets `selectedGuestOptions` and `selectedRoomOptions` to empty arrays
 *   (no selections).
 * - Important: `setReservationPayload([])` currently assigns an empty array
 *   which is inconsistent with the expected `Reservation` object. This will
 *   break typing and downstream code that expects an object. Use the
 *   canonical initial reservation (e.g., `initializedReservation`) instead.
 *
 * Recommendations:
 * - Replace `setReservationPayload([])` with `setReservationPayload(initializedReservation)`
 *   to preserve type-safety and predictable defaults.
 * - If form state is complex, consider a dedicated `resetReservationForm()`
 *   helper that also clears derived state or validation errors.
 * - If clearing should be confirmed by the user (when non-empty), add a
 *   confirmation dialog to prevent accidental loss of entered data.
 *
 * Side effects: mutates multiple React state variables used by the reservation UI.
 */
  const handleClearReservation = () => {
    // NOTE: use the initialized reservation object to preserve types
    // and default values instead of an empty array.
    // setReservationPayload([]); // <- bad: breaks Reservation typing
    setReservationPayload(initializedReservation);
    setSelectedGuestOptions([]);
    setSelectedRoomOptions([]);
  };


  return (
    <>
      <div className={styles.gU1Tf}>
        <div className={styles.jUsfu}>
          <div className={styles.QIl4y}>
            <div className={`${styles.O0VOp1}`}>
              <div className={`${styles.VvU3MOvL}`}>
                <div className={`${styles.clieTWU2V}`}>
                  <div className={`${styles.clieTWU2Vc}`}>
                    {ButtonTabs.map((tab) => (
                      <Button
                        key={tab.key}
                        icon={tab.icon}
                        shape="circular"
                        size="small"
                        onClick={() => handleHospitalityTablimit(tab.key)}
                        className={`${styles.Tab6re} ${activeButton === tab.key ? styles.cgTactive : ""}`}
                      >
                        <span className={`${styles.ci_menu_brand} ${styles.dflex} ${styles.pe0}`}>
                          {tab.label}
                        </span>
                      </Button>
                    ))}


                  </div>
                  <div className={`${styles.clieTWU2Vc}`}>
                    <Button shape="circular" size="small"
                      className={`${styles.narTIl}`}>
                      <Menu>
                        <MenuTrigger disableButtonEnhancement>
                          <MenuButton
                            icon={<Settings16Regular />}
                            className={`${styles.narTIl}`}
                            menuIcon={<ChevronDown16Regular />}
                          >Actions</MenuButton>
                        </MenuTrigger>
                        <MenuPopover>
                          <MenuList>
                            <MenuItem icon={<ArrowDownloadRegular />}>Import Records </MenuItem>
                            <MenuItem icon={<DocumentArrowDownRegular />}>Spreadsheets</MenuItem>
                            <MenuItem icon={<DocumentFlowchartRegular />}>Insert View in article</MenuItem>
                            <MenuItem icon={<LinkRegular />}>Insert Link in article</MenuItem>
                            <MenuItem icon={<DocumentDataLinkRegular />}>Link Menu in spread sheet</MenuItem>
                          </MenuList>
                        </MenuPopover>
                      </Menu>
                    </Button>
                  </div>
                </div>
                <div className={`${styles.BHt3} ${activeButton !== "HMS" ? styles.hzHidden : ""}`}>
                  <div className={styles.YtRw}>
                    <div className={styles.WRe37}>
                      <div className={styles.DVEYbe}>
                        <div className={styles.HDs1}>
                          <span className={styles.HEwy}>
                            <i className="wc-icon-sidebar not-height fi fi-tr-book-open-reader wc-add-color"> </i>
                           {selectedRightTabItem}

                          </span>

                          <Menu positioning={{ autoSize: true }}>
                            <MenuTrigger disableButtonEnhancement>
                              <Button shape="circular" size="small" className={styles.MorE3} icon={<MoreHorizontalRegular />}></Button>
                            </MenuTrigger>

                            <MenuPopover>
                              <MenuList>
                            {menuItems.map((item, index) => (
                              <MenuItem
                                key={index}
                                onClick={() => setSelectedRightTabItem(item)}
                              >
                                {item}
                              </MenuItem>
                            ))}
                          </MenuList>

                            </MenuPopover>
                          </Menu>
                        </div>
                        <div className={styles.SRCcont}>
                          <SearchBox
                            className={styles.Fiwb}
                            placeholder="Search work flow"
                            appearance="filled-darker"
                            value={searchQuery}
                            onChange={(_, data) => setSearchQuery(data.value)}
                          />
                        </div>
                        <div className={styles.LOWqs}></div>
                        <div className={`${styles.LOWqs} ${styles.ILWY6g}`}>
                          {sortedGroupedTabs.length === 0 && hzLoadingFirst && (
                            <Skeleton aria-hidden style={{ display: "grid", gap: 14, padding: "12px 16px" }}>
                              {[0, 1, 2, 3, 4].map((i) => (
                                <div key={i} style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                  <SkeletonItem shape="circle" size={32} />
                                  <div style={{ display: "grid", gap: 6, flex: 1 }}>
                                    <SkeletonItem size={12} style={{ width: "60%" }} />
                                    <SkeletonItem size={12} style={{ width: "40%" }} />
                                  </div>
                                </div>
                              ))}
                            </Skeleton>
                          )}
                          {sortedGroupedTabs.length === 0 && !hzLoadingFirst && <p className={styles.hzHint} style={{ padding: "12px 16px" }}>{`No ${String(selectedRightTabItem).toLowerCase()} right now.`}</p>}
<TabList defaultSelectedValue="" className={`${styles.Jsrv} ${styles.LOWqs} ${styles.customScrollBar}`} vertical>
                            {sortedGroupedTabs.map(([dateGroup, tabs], index) => {
                              const filteredTabs = tabs.filter((tab) =>
                                [tab.id, tab.name, tab.role, tab.company]
                                  .some((field) => field.toLowerCase().includes(searchQuery.toLowerCase()))
                              );

                              if (filteredTabs.length === 0) return null;

                              return (
                                <div key={dateGroup} >
                                  {/* Show header and count */}
                                  <div className={styles.HJne5}>
                                    <div className={styles.Y5rV}>{dateGroup}</div>
                                    <div className={styles.Y5rYs}>{filteredTabs.length}</div>
                                  </div>

                                  {filteredTabs.map((tab) => {
                                    const timeString = format(parseISO(tab.datetime), 'h:mm a');

                                    return (
                                      <Tab
                                        key={tab.id}
                                        value={tab.id}
                                        onClick={() => handleSelectWorkFlow(tab.id, "1")}
                                        className={`${styles.Mvtuisvt} ${activeWorkFlow === tab.id ? styles.cgTactive : ""}`}
                                      >
                                        <div className={styles.Cgscf}>
                                          <span className={styles.Wrye}>
                                            <Persona
                                              name={tab.name}
                                              secondaryText={
                                                <span style={{ fontWeight: 500 }}>
                                                  {tab.role} <span style={{ fontSize: '1.2em', fontWeight: 'bold' }}>•</span> {tab.company}
                                                </span>
                                              }
                                              avatar={
                                                {
                                                  image: { src: tab.avatar },
                                                  color: "colorful"
                                                }}
                                            />
                                          </span>

                                          <span className={styles.NUWV6w}>{timeString}</span>
                                        </div>
                                      </Tab>
                                    );
                                  })}
                                </div>
                              );
                            })}
                          </TabList>
                        </div>
                      </div>
                    </div>
                    <div className={`${styles.Lbwe}`}>
                      <div className={styles.OTGceu}>


                        {/* header */}
                        <div className={`${styles.buttonContainer} ${styles.mHDs1}`}>

                          <Button
                            icon={<ChevronLeft16Regular />}
                            className={styles.scrollButton}
                            onClick={scrollLeftH}
                            disabled={!canScrollLeftH}
                          />


                          <div className={styles.sliderTrack} ref={scrollRefH}>
                            <Button
                              icon={<Add16Regular />}
                              shape="circular"
                              size="small"
                              className={styles.hmect}
                              onClick={() => handleBookingTemplate("New Reservation")}
                            >
                              New Reservation / Booking
                            </Button>
                            <Button icon={<CheckboxPerson16Regular />} shape="circular" size="small" className={styles.hmect} onClick={() => setHzQuick("checkin")}>
                              Check-In Guest
                            </Button>
                            <Button icon={<PeopleAdd16Regular />} shape="circular" size="small" className={styles.hmect} onClick={() => setHzQuick("checkout")}>
                              Check-Out Guest
                            </Button>
                            <Button icon={<FolderList16Regular />} shape="circular" size="small" className={styles.hmect} onClick={() => setHzQuick("discount")}>
                              Discount / Promo
                            </Button>
                            <Button icon={<PersonAdd16Regular />} shape="circular" size="small" className={styles.hmect} onClick={() => setHzQuick("roomstate")}>
                              Manage Room State
                            </Button>
                            <Button icon={<ShoppingBagTag16Regular />} shape="circular" size="small" className={styles.hmect} onClick={() => setHzQuick("service")}>
                              Add Service Charge
                            </Button>
                            <Button icon={<PersonAccount16Regular />} shape="circular" size="small" className={styles.hmect} onClick={() => setHzQuick("newguest")}>
                              Add New Guest
                            </Button>
                          </div>


                          <Button
                            icon={<ChevronRight16Regular />}
                            className={styles.scrollButton}
                            onClick={scrollRightH}
                            disabled={!canScrollRightH}
                          />

                        </div>
                        {/* <div className={`${styles.mHDs1} ${styles.buttonContainer}`}>
                          <Button icon={<ChevronLeft16Regular />} className={styles.scrollLeft} onClick={scrollLeft} />

                          <div className={`${styles.sliderTrack}`} ref={scrollRef}>
                            {/* Your buttons with your existing styles here                   
                            <Button icon={<Add16Regular />} shape="circular" size="small" className={styles.hmect} onClick={() => handleBookingTemplate("New Reservation")}>New Reservation / Booking</Button>
                            <Button icon={<BookDismiss16Regular />} shape="circular" size="small" className={styles.hmect}>Check-In Guest</Button>
                            <Button icon={<PeopleAdd16Regular />} shape="circular" size="small" className={styles.hmect}>Check-Out Guest</Button>
                            <Button icon={<FolderList16Regular />} shape="circular" size="small" className={styles.hmect}>Discount / Promo</Button>
                            <Button icon={<PersonAdd16Regular />} shape="circular" size="small" className={styles.hmect}>Manage Room State</Button>
                            <Button icon={<ShoppingBagTag16Regular />} shape="circular" size="small" className={styles.hmect}>Add Service Charge</Button>

                            <Menu>
                              <MenuTrigger disableButtonEnhancement>
                                <MenuButton className={styles.hmect} icon={<Share16Regular />} size="small" shape="circular">Share</MenuButton>
                              </MenuTrigger>
                              <MenuPopover>
                                <MenuList>
                                  <MenuItem>Item a</MenuItem>
                                  <MenuItem>Item b</MenuItem>
                                </MenuList>
                              </MenuPopover>
                            </Menu>
                          </div>

                          <Button icon={<ChevronRight16Regular />} className={styles.scrollRight} onClick={scrollRight} />
                        </div> */}

                        {/*#Region Dashboard  */}
                        {guestTabsDisplay === "0" && (
                          <div className={styles.YvsEV}>
                            {/* {hzProblem && (
                              <MessageBar intent={hzBoot.error ? "error" : "warning"} style={{ margin: "0 22px 8px" }}>
                                <MessageBarBody>{hzProblem}</MessageBarBody>
                                <MessageBarActions>
                                  <Button size="small" onClick={() => void hzReload()}>Retry</Button>
                                </MessageBarActions>
                              </MessageBar>
                            )} */}
                            {/* carousel freee slides */}
                            <div className={`${styles.GssDD} ${styles.cpnDSEntryPoint11} ${styles.CloudyN} ${styles.customScrollBar}`}>
                              <div className={`${styles.tabsContainerDSEntryPoint11}`} style={{ maxWidth: "none", width: "auto" }}>
                                <div className={styles.tabsContentDSEntryPoint11} ref={carouselHostRef} style={{ width: "auto" }}>
                                  {/* button carousel slide here */}
                                  {currentIndex > 0 && (
                                    <Button
                                      shape="circular"
                                      icon={<ChevronLeftRegular />}
                                      className={`${styles.carouselChevronButtonDSEntryPoint11} ${styles.carouselPrevButtonDSEntryPoint11}`}
                                      onClick={handlePrev}
                                    />
                                  )}




                                  {/* <Button shape="circular" icon={<ChevronRightRegular />} className={ `${styles.carouselChevronButtonDSEntryPoint11} ${styles.carouselNextButtonDSEntryPoint11}`}></Button> */}
                                  <div className={`${styles.tabsCarouselDSEntryPoint11}`} style={{ width: stripWidth }}>
                                    <div className={`${styles.tabsCarouselItemsDSEntryPoint11}`}
                                      style={{
                                        columnGap: CARD_GAP,
                                        transform: `translateX(-${scrollOffset}px)`,
                                        transition: 'transform 0.5s ease-in-out',
                                      }}>
                                      {CarouselItems.map((item, index) => (
                                        <div
                                          key={index}
                                          ref={index === 0 ? itemRef : null}
                                          className={`${styles.tabDailyItemDSEntryPoint11} ${selectedTabId === item.id ? styles.dailyTabSelected : ''
                                            } ${item.isOverview ? styles.dailyTabOverview : ''}`}
                                          onClick={() => handleRoomSelected(item.id)}
                                        >
                                          <div className={styles.tabDailyItemBgDSEntryPoint11}>
                                            <div className={styles.tabDailyItemBgContentDSEntryPoint11}></div>
                                          </div>
                                          <button className={`${styles.tabDailyButtonDSEntryPoint11} ${styles.dayCardV3}`}>
                                            <div className={styles.tabContentDSEntryPoint11}>
                                              <div className={styles.dateSectionDSEntryPoint11}>
                                                <div className={styles.dateLabelDSEntryPoint11}>{item.date}</div>
                                                <div className={styles.weekLabelDSEntryPoint11}>{item.weekLabel}</div>
                                              </div>
                                              <div className={styles.contentSectionDSEntryPoint11}>
                                                <div className={styles.conditionSectionDSEntryPoint11}>
                                                  <div className={styles.conditionHalfSectionDSEntryPoint11}>
                                                    <div className={`${styles.iconContainerDSEntryPoint11} ${styles.dayiconContainerDSEntryPoint11}`}>
                                                      <div className={styles.conditionIconDSEntryPoint11}>
                                                        <BedFilled className={`${styles.conditionImgDSEntryPoint11} ${styles.roomIcon}`} />
                                                      </div>
                                                    </div>
                                                    <div className={styles.hiTempDSEntryPoint11} aria-label={`${bkDayCounts(hzD, off(item.id - 2)).inHouse}`}>
                                                      {hzNum(bkDayCounts(hzD, off(item.id - 2)).inHouse)}<span className=""></span>
                                                    </div>
                                                  </div>
                                                  <div className={styles.conditionHalfSectionDSEntryPoint11} style={{ marginLeft: '12px' }}>
                                                    <div className={`${styles.iconContainerDSEntryPoint11} ${styles.nighticonContainerDSEntryPoint11}`}>
                                                      <div className={styles.conditionIconDSEntryPoint11}>
                                                        <AirplaneLandingFilled className={`${styles.conditionImgDSEntryPoint11} ${styles.arrivalIcon}`} />
                                                      </div>
                                                    </div>
                                                    <div className={styles.lowTempDSEntryPoint11} aria-label={`${bkDayCounts(hzD, off(item.id - 2)).arrivals}`}>
                                                      {hzNum(bkDayCounts(hzD, off(item.id - 2)).arrivals)}<span className=""></span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </button>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                  {currentIndex < maxIndex && (
                                    <Button
                                      shape="circular"
                                      icon={<ChevronRightRegular />}
                                      className={`${styles.carouselChevronButtonDSEntryPoint11} ${styles.carouselNextButtonDSEntryPoint11}`}
                                      onClick={handleNext}
                                    />
                                  )}
                                </div>
                              </div>
                              {/* detail sections fo selected item from the carousel */}
                              <div className={`${styles.detailsSectionDSEntryPoint11}`}>
                                <div
                                  className={`${styles.detailsContainerDSEntryPoint11} ${selectedTabId !== null && selectedTabId - 1 === currentIndex ? styles.theLeftSelectedTab : ''}`}
                                  // same idea as theLeftSelectedTab, for the right side: the last card in view joins the panel with a square corner
                                  style={selectedTabId !== null && selectedTabId - 1 === Math.min(currentIndex + visibleCount, CarouselItems.length) - 1 ? { borderTopRightRadius: 0 } : undefined}
                                >
                                  <div className={`${styles.detialsTrendChartSectionDSEntryPoint11}`}>
                                    <div>
                                      <div className={`${styles.trendChartContainerDSEntryPoint11} ${styles.EYEBJEIW}`}>
                                        <div className={`${styles.headerContainerDSEntryPoint11}`}>
                                          <div className={`${styles.headerTitleDSEntryPoint11}`}>📊 Overview </div>
                                          <div className={`${styles.selectorContainerDSEntryPoint11}`}>
                                            <div>
                                              <label className={`${styles.forecastCheckboxAreaDSEntryPoint11}`}>
                                                <span>👍 Feels like</span>
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                        <div className={`${styles.trendChartContentDSEntryPoint11} ${styles.trendChartAnimationDSEntryPoint11} ${styles.customScrollBar}`}>
                                          <div className={`${styles.backgroundContainerCompactDSEntryPoint11} ${styles.customScrollBar}`}>
                                            {/* Map the room details here */}
                                            <div className={`${styles.overallContainerDSEntryPoint11} ${styles.HTCIW}`}>
                                              <div className={`${styles.Klb7uj}`}>
                                                <div className={`${styles.PRJt}  ${styles.LsiwnlHJ}`}>
                                                  <Persona
                                                    size="small"
                                                    avatar={{ color: "colorful" }}
                                                    name={hzLoadingFirst ? "Loading" : bkv.guest}
                                                    secondaryText={hzLoadingFirst ? "" : bkv.guestSub}
                                                  />
                                                </div>
                                              </div>
                                              <div className={`${styles.detailContainerCompactDSEntryPoint11} ${styles.MEKEU2J2NS}`}>
                                                <div className={`${styles.detailItemLineCompactDSEntryPoint11}`}>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>
                                                        <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                          <AirplaneLandingRegular className={`${styles.MHEJ29YEB6g}`} />
                                                        </span>

                                                        <span data-id="CurrentDetailLineWindTitle" aria-hidden="true">Arrival</span>
                                                      </div>
                                                      <div data-id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span data-id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span data-id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles.___1jrfxqc} ${styles.f135dsb4} ${styles.f3z4w6d}`}>{bkv.arrDay}</span>
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div className={`${styles.S2NDX_798}`}>
                                                            <div className={`${styles.gCSJa} ${styles.XG5Jd}`}>
                                                              <div className={`${styles.ESO13} ${styles.gy2aJ} ${styles.CYQyC} ${styles.Ejrkd}`}>
                                                                <span>{bkv.arrMon}</span>
                                                              </div>
                                                            </div>
                                                            <div className={`${styles.nf3X_} ${styles.D8iyG} ${styles.Q19mi}`}>
                                                              <div className={`${styles.IjzWp} ${styles.XG5Jd} ${styles.gy2aJ} ${styles.Ejrkd} ${styles.lME98}`}>
                                                                <span className={`${styles.TtcXM}`}>{bkv.arrWd}</span>
                                                              </div>

                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>
                                                        <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                          <AirplaneTakeOffRegular className={`${styles.MHEJ29YEB6g}`} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Departure</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles.___1jrfxqc} ${styles.f135dsb4} ${styles.f6hvv1p}`}>{bkv.depDay}</span>
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div className={`${styles.S2NDX_798}`}>
                                                            <div className={`${styles.gCSJa} ${styles.XG5Jd}`}>
                                                              <div className={`${styles.ESO13} ${styles.gy2aJ} ${styles.CYQyC} ${styles.Ejrkd}`}>
                                                                <span title="hello@creately.com">{bkv.depMon}</span>
                                                              </div>
                                                            </div>
                                                            <div className={`${styles.nf3X_} ${styles.D8iyG} ${styles.Q19mi}`}>
                                                              <div className={`${styles.IjzWp} ${styles.XG5Jd} ${styles.gy2aJ} ${styles.Ejrkd} ${styles.lME98}`}>
                                                                <span className={`${styles.TtcXM}`}>{bkv.depWd}</span>
                                                              </div>

                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>
                                                        <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                          <WeatherMoonRegular className={`${styles.MHEJ29YEB6g}`} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Nights</span>
                                                      </div>
                                                      <div data-id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span data-id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span data-id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles.___1jrfxqc} ${styles.f135dsb4} ${styles.fkh7blw}`}>{bkv.nights}</span>
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div className={`${styles.S2NDX_798}`}>
                                                            <div className={`${styles.gCSJa} ${styles.XG5Jd}`}>
                                                              <div className={`${styles.ESO13} ${styles.gy2aJ} ${styles.CYQyC} ${styles.Ejrkd}`}>
                                                                <span></span>
                                                              </div>
                                                            </div>
                                                            <div className={`${styles.nf3X_} ${styles.D8iyG} ${styles.Q19mi}`}>
                                                              <div className={`${styles.IjzWp} ${styles.XG5Jd} ${styles.gy2aJ} ${styles.Ejrkd} ${styles.lME98}`}>
                                                                <span className={`${styles.TtcXM}`}></span>
                                                              </div>

                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>
                                                        <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                          <BedRegular className={`${styles.MHEJ29YEB6g}`} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Room Types</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.YENEKEH39}`}>
                                                          <span className={`${styles.beuewoqon2}`}>{bkv.type}</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>

                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11} ${styles.editPosition}`}>
                                                    <span role="button" tabIndex={0} onClick={() => setBkDlg("stay")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("stay"); } }} className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11} ${styles.DNFHRLS} ${styles.ALIEGN}`}>
                                                        <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                          <EditRegular className={`${styles.MHEJ29YEB}`} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Edit</span>
                                                      </div>

                                                    </span>
                                                  </div>
                                                </div>
                                                <div className={`${styles.detailItemLineCompactDSEntryPoint11} ${styles.NWU29WB2}`}>
                                                  <div role="button" tabIndex={0} onClick={() => setBkDlg("avail")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("avail"); } }} className={`${styles.DNFHRLS} ${styles.ALIEGN}`}>
                                                    <span className={`${styles.iconJEU}`}><BranchCompareRegular className={`${styles.MHEJ29YEB}`} /></span>
                                                    <span className={`${styles.NEIWGWKJEU}`}>Rate & Availability</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className={`${styles.detailContainerCompactDSEntryPoint11}  ${styles.HEGTL} ${styles.MEKEU2J2NS}`}>
                                                <div className={`${styles.detailItemLineCompactDSEntryPoint11}`}>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>
                                                        {/* <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                    <ConferenceRoomRegular className={`${styles.MHEJ29YEB6g}`} />
                                                  </span> */}

                                                        <span data-id="CurrentDetailLineWindTitle" aria-hidden="true">🛏️ Room</span>
                                                      </div>
                                                      <div data-id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span data-id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span data-id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles.___1jrfxqc} ${styles.f135dsb4}`}>{bkv.room}</span>
                                                              </span>
                                                            </div>
                                                          </div>
                                                          {/* <div className={`${styles.S2NDX_798}`}>
                                                <div className={`${styles.gCSJa} ${styles.XG5Jd}`}>
                                                  <div className={`${styles.ESO13} ${styles.gy2aJ} ${styles.CYQyC} ${styles.Ejrkd}`}>
                                                    <span></span>
                                                  </div>
                                                </div>
                                                <div className={`${styles.nf3X_} ${styles.D8iyG} ${styles.Q19mi}`}>
                                                  <div className={`${styles.IjzWp} ${styles.XG5Jd} ${styles.gy2aJ} ${styles.Ejrkd} ${styles.lME98}`}>
                                                    <span className={`${styles.TtcXM}`}></span>
                                                  </div>
                                                  
                                                </div>                                             
                                              </div> */}
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>
                                                        {/* <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                    {/* =<BedRegular className={`${styles.MHEJ29YEB6g}`} /> 
                                                    <PersonAddRegular className={`${styles.MHEJ29YEB6g}`} />
                                                  </span> */}

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">🧑 Adult</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.YENEKEH39}`}>
                                                          <span className={`${styles.beuewoqon2}`}>{bkv.adults}</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>
                                                        <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                          {/* <BedRegular className={`${styles.MHEJ29YEB6g}`} /> */}
                                                          <i className="fi fi-tr-child"></i>
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">🧒 Child</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.YENEKEH39}`}>
                                                          <span className={`${styles.beuewoqon2}`}>{bkv.children}</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>
                                                        {/* <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                    {/* <BedRegular className={`${styles.MHEJ29YEB6g}`} /> 
                                                    <i className="fi fi-ts-baby"></i>
                                                  </span> */}

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">👶 Infant</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.YENEKEH39}`}>
                                                          <span className={`${styles.beuewoqon2}`}>{bkv.infants}</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>

                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span role="button" tabIndex={0} onClick={() => setBkDlg("guests")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("guests"); } }} className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11} ${styles.DNFHRLS} ${styles.ALIEGN}`}>
                                                        <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                          <EditRegular className={`${styles.MHEJ29YEB}`} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Edit</span>
                                                      </div>

                                                    </span>
                                                  </div>
                                                </div>
                                                <div className={`${styles.detailItemLineCompactDSEntryPoint11} ${styles.MABVETU} ${styles.wwu82}`}>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>


                                                        <span data-id="CurrentDetailLineWindTitle" aria-hidden="true">💰 Rate Code</span>
                                                      </div>
                                                      <div data-id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span data-id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span data-id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles.___1jrfxqc} ${styles.f135dsb4}`}>{bkv.code}</span>
                                                              </span>
                                                            </div>
                                                          </div>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">🍽️ Meal Plan</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.YENEKEH39}`}>
                                                          <span className={`${styles.beuewoqon2}`}>{bkv.meal}</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">🧩 Add-ons</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.YENEKEH39}`}>
                                                          <span className={`${styles.beuewoqon2}`}>{bkv.addons}</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">🏷️ Discount</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.YENEKEH39}`}>
                                                          <span className={`${styles.beuewoqon2}`}>{bkv.discount}</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">🧾Tax</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.YENEKEH39}`}>
                                                          <span className={`${styles.beuewoqon2}`}>{bkv.tax}</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>

                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span role="button" tabIndex={0} onClick={() => setBkDlg("rate")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("rate"); } }} className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11} ${styles['DN-FHRLS']} ${styles.ALIEGN}`}>
                                                        <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                          <EditRegular className={`${styles.MHEJ29YEB}`} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Edit</span>
                                                      </div>

                                                    </span>
                                                  </div>
                                                </div>
                                                <div className={`${styles.detailItemLineCompactDSEntryPoint11} ${styles.NWU29WB2} ${styles.MABVETU}`}>
                                                  <div role="button" tabIndex={0} onClick={() => setBkDlg("guest")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("guest"); } }} className={`${styles.DNFHRLS} ${styles.ALIEGN}`}>
                                                    <span className={`${styles.iconJEU}`}><BedRegular className={`${styles.MHEJ29YEB}`} /></span>
                                                    <span className={`${styles.NEIWGWKJEU}`}>Guest Details</span>
                                                  </div>
                                                </div>
                                              </div>

                                            </div>

                                            <div className={`${styles.overallContainerDSEntryPoint11} ${styles.HTCIW}`}>
                                              <div className={`${styles.detailContainerCompactDSEntryPoint11} ${styles.MEKEU2J2NS}`}>
                                                <div className={`${styles.detailItemLineCompactDSEntryPoint11}`}>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>
                                                        {/* <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                    <AirplaneLandingRegular className={`${styles.MHEJ29YEB6g}`} />
                                                  </span> */}

                                                        <span data-id="CurrentDetailLineWindTitle" aria-hidden="true">🛬 Arrival</span>
                                                      </div>
                                                      <div data-id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span data-id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span data-id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles.___1jrfxqc} ${styles.f135dsb4} ${styles.f3z4w6d}`}>{bkv.arrDay}</span>
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div className={`${styles.S2NDX_798}`}>
                                                            <div className={`${styles.gCSJa} ${styles.XG5Jd}`}>
                                                              <div className={`${styles.ESO13} ${styles.gy2aJ} ${styles.CYQyC} ${styles.Ejrkd}`}>
                                                                <span>{bkv.arrMon}</span>
                                                              </div>
                                                            </div>
                                                            <div className={`${styles.nf3X_} ${styles.D8iyG} ${styles.Q19mi}`}>
                                                              <div className={`${styles.IjzWp} ${styles.XG5Jd} ${styles.gy2aJ} ${styles.Ejrkd} ${styles.lME98}`}>
                                                                <span className={`${styles.TtcXM}`}>{bkv.arrWd}</span>
                                                              </div>

                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>
                                                        {/* <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                    <AirplaneTakeOffRegular className={`${styles.MHEJ29YEB6g}`} />
                                                  </span> */}

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">🛫 Departure</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles.___1jrfxqc} ${styles.f135dsb4} ${styles.f6hvv1p}`}>{bkv.depDay}</span>
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div className={`${styles.S2NDX_798}`}>
                                                            <div className={`${styles.gCSJa} ${styles.XG5Jd}`}>
                                                              <div className={`${styles.ESO13} ${styles.gy2aJ} ${styles.CYQyC} ${styles.Ejrkd}`}>
                                                                <span title="hello@creately.com">{bkv.depMon}</span>
                                                              </div>
                                                            </div>
                                                            <div className={`${styles.nf3X_} ${styles.D8iyG} ${styles.Q19mi}`}>
                                                              <div className={`${styles.IjzWp} ${styles.XG5Jd} ${styles.gy2aJ} ${styles.Ejrkd} ${styles.lME98}`}>
                                                                <span className={`${styles.TtcXM}`}>{bkv.depWd}</span>
                                                              </div>

                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>
                                                        {/* <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                    <WeatherMoonRegular className={`${styles.MHEJ29YEB6g}`} />
                                                  </span> */}

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">🌙 Nights</span>
                                                      </div>
                                                      <div data-id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span data-id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span data-id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles.___1jrfxqc} ${styles.f135dsb4} ${styles.fkh7blw}`}>{bkv.nights}</span>
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div className={`${styles.S2NDX_798}`}>
                                                            <div className={`${styles.gCSJa} ${styles.XG5Jd}`}>
                                                              <div className={`${styles.ESO13} ${styles.gy2aJ} ${styles.CYQyC} ${styles.Ejrkd}`}>
                                                                <span></span>
                                                              </div>
                                                            </div>
                                                            <div className={`${styles.nf3X_} ${styles.D8iyG} ${styles.Q19mi}`}>
                                                              <div className={`${styles.IjzWp} ${styles.XG5Jd} ${styles.gy2aJ} ${styles.Ejrkd} ${styles.lME98}`}>
                                                                <span className={`${styles.TtcXM}`}></span>
                                                              </div>

                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>
                                                        <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                          <Bed16Regular className={`${styles.MHEJ29YEB6g}`} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Room Types</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.YENEKEH39}`}>
                                                          <span className={`${styles.beuewoqon2}`}>{bkv.type}</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>

                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span role="button" tabIndex={0} onClick={() => setBkDlg("stay")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("stay"); } }} className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11} ${styles['DN-FHRLS']} ${styles.ALIEGN}`}>
                                                        <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                          <EditRegular className={`${styles.MHEJ29YEB}`} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Edit</span>
                                                      </div>

                                                    </span>
                                                  </div>
                                                </div>
                                                <div className={`${styles.detailItemLineCompactDSEntryPoint11} ${styles.NWU29WB2}`}>
                                                  <div role="button" tabIndex={0} onClick={() => setBkDlg("avail")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("avail"); } }} className={`${styles['DN-FHRLS']} ${styles.ALIEGN}`}>
                                                    <span className={`${styles['icon-JEU']}`}><BranchCompareRegular className={`${styles.MHEJ29YEB}`} /></span>
                                                    <span className={`${styles['NEIWGWK-JEU']}`}>Compare rate & Availability</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className={`${styles.detailContainerCompactDSEntryPoint11}  ${styles.HEGTL} ${styles.MEKEU2J2NS}`}>
                                                <div className={`${styles.detailItemLineCompactDSEntryPoint11}`}>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>
                                                        <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                          <ConferenceRoomRegular className={`${styles.MHEJ29YEB6g}`} />
                                                        </span>

                                                        <span data-id="CurrentDetailLineWindTitle" aria-hidden="true">Room</span>
                                                      </div>
                                                      <div data-id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span data-id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span data-id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles.___1jrfxqc} ${styles.f135dsb4}`}>{bkv.room}</span>
                                                              </span>
                                                            </div>
                                                          </div>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>
                                                        <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                          {/* <BedRegular className={`${styles.MHEJ29YEB6g}`} /> */}
                                                          <PersonAddRegular className={`${styles.MHEJ29YEB6g}`} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Adult</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.YENEKEH39}`}>
                                                          <span className={`${styles.beuewoqon2}`}>{bkv.adults}</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>
                                                        <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                          {/* <BedRegular className={`${styles.MHEJ29YEB6g}`} /> */}
                                                          <i className="fi fi-tr-child"></i>
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Child</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.YENEKEH39}`}>
                                                          <span className={`${styles.beuewoqon2}`}>{bkv.children}</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>
                                                        <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                          {/* <BedRegular className={`${styles.MHEJ29YEB6g}`} /> */}
                                                          <i className="fi fi-ts-baby"></i>
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Infant</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.YENEKEH39}`}>
                                                          <span className={`${styles.beuewoqon2}`}>{bkv.infants}</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>

                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span role="button" tabIndex={0} onClick={() => setBkDlg("guests")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("guests"); } }} className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11} ${styles['DN-FHRLS']} ${styles.ALIEGN}`}>
                                                        <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                          <EditRegular className={`${styles.MHEJ29YEB}`} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Edit</span>
                                                      </div>

                                                    </span>
                                                  </div>
                                                </div>
                                                <div className={`${styles.detailItemLineCompactDSEntryPoint11} ${styles.MABVETU} ${styles.wwu82}`}>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>


                                                        <span data-id="CurrentDetailLineWindTitle" aria-hidden="true">Rate Code</span>
                                                      </div>
                                                      <div data-id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span data-id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span data-id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles.___1jrfxqc} ${styles.f135dsb4}`}>{bkv.code}</span>
                                                              </span>
                                                            </div>
                                                          </div>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Meal Plan</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.YENEKEH39}`}>
                                                          <span className={`${styles.beuewoqon2}`}>{bkv.meal}</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Addons</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.YENEKEH39}`}>
                                                          <span className={`${styles.beuewoqon2}`}>{bkv.addons}</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Discount</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.YENEKEH39}`}>
                                                          <span className={`${styles.beuewoqon2}`}>{bkv.discount}</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11}`}>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Tax</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.YENEKEH39}`}>
                                                          <span className={`${styles.beuewoqon2}`}>{bkv.tax}</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>

                                                  <div className={`${styles.detailItemGridCompactDSEntryPoint11}`}>
                                                    <span role="button" tabIndex={0} onClick={() => setBkDlg("rate")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("rate"); } }} className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11} ${styles['DN-FHRLS']} ${styles.ALIEGN}`}>
                                                        <span aria-hidden="true" className={`${styles.slugInfoSpaceDSEntryPoint11}`}>
                                                          <EditRegular className={`${styles.MHEJ29YEB}`} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Edit</span>
                                                      </div>

                                                    </span>
                                                  </div>
                                                </div>
                                                <div className={`${styles.detailItemLineCompactDSEntryPoint11} ${styles.NWU29WB2} ${styles.MABVETU}`}>
                                                  <div role="button" tabIndex={0} onClick={() => setBkDlg("guest")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("guest"); } }} className={`${styles['DN-FHRLS']} ${styles.ALIEGN}`}>
                                                    <span className={`${styles['icon-JEU']}`}><BedRegular className={`${styles.MHEJ29YEB}`} /></span>
                                                    <span className={`${styles['NEIWGWK-JEU']}`}>Guest Details</span>
                                                  </div>
                                                </div>
                                              </div>

                                            </div>
                                            {/* all the details of each room */}

                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className={`${styles.detailsContainerDSEntryPoint11} ${styles.HTCIW}`}>
                                  <div className={`${styles.detialsTrendChartSectionDSEntryPoint11}`}>
                                    <div>
                                      <div className={`${styles.trendChartContainerDSEntryPoint11} ${styles.EYEBJEIW}`}>
                                        <div className={`${styles.headerContainerDSEntryPoint11}`}>
                                          <div className={`${styles.headerTitleDSEntryPoint11}`}> Room status </div>
                                          <div className={`${styles.selectorContainerDSEntryPoint11}`}>
                                            <div>
                                              <label className={`${styles.forecastCheckboxAreaDSEntryPoint11}`}>
                                                <span>Feels like</span>
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                        <div className={`${styles.trendChartContentDSEntryPoint11} ${styles.trendChartAnimationDSEntryPoint11} ${styles.customScrollBar}`}>
                                          <div className={`${styles.backgroundContainerCompactDSEntryPoint11} ${styles.customScrollBar}`}>
                                            {/* Map the room details here */}
                                            <div className={`${styles.overallContainerDSEntryPoint11} ${styles.HTCIW}`}>
                                              <div className={`${styles.detailContainerCompactDSEntryPoint11} ${styles.MEKEU2J2NS}`}>
                                                <div className={styles.detailItemLineCompactDSEntryPoint11}>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          <AirplaneLandingRegular className={styles.MHEJ29YEB6g} />
                                                        </span>

                                                        <span data-id="CurrentDetailLineWindTitle" aria-hidden="true">Arrival</span>
                                                      </div>
                                                      <div data-id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span data-id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span data-id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles['___1jrfxqc']} ${styles.f135dsb4} ${styles.f3z4w6d}`}>{bkv.arrDay}</span>
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div className={styles.S2NDX_798}>
                                                            <div className={`${styles.gCSJa} ${styles.XG5Jd}`}>
                                                              <div className={`${styles.ESO13} ${styles.gy2aJ} ${styles.CYQyC} ${styles.Ejrkd}`}>
                                                                <span>{bkv.arrMon}</span>
                                                              </div>
                                                            </div>
                                                            <div className={`${styles.nf3X_} ${styles.D8iyG} ${styles.Q19mi}`}>
                                                              <div className={`${styles.IjzWp} ${styles.XG5Jd} ${styles.gy2aJ} ${styles.Ejrkd} ${styles.lME98}`}>
                                                                <span className={styles.TtcXM}>Saturday, 11:00 AM</span>
                                                              </div>

                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          <AirplaneTakeOffRegular className={styles.MHEJ29YEB6g} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Departure</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles['___1jrfxqc']} ${styles.f135dsb4} ${styles.f6hvv1p}`}>{bkv.depDay}</span>
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div className={styles.S2NDX_798}>
                                                            <div className={`${styles.gCSJa} ${styles.XG5Jd}`}>
                                                              <div className={`${styles.ESO13} ${styles.gy2aJ} ${styles.CYQyC} ${styles.Ejrkd}`}>
                                                                <span title="hello@creately.com">{bkv.depMon}</span>
                                                              </div>
                                                            </div>
                                                            <div className={`${styles.nf3X_} ${styles.D8iyG} ${styles.Q19mi}`}>
                                                              <div className={`${styles.IjzWp} ${styles.XG5Jd} ${styles.gy2aJ} ${styles.Ejrkd} ${styles.lME98}`}>
                                                                <span className={styles.TtcXM}>Saturday, 11:00 AM</span>
                                                              </div>

                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          <WeatherMoonRegular className={styles.MHEJ29YEB6g} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Nights</span>
                                                      </div>
                                                      <div data-id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span data-id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span data-id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles['___1jrfxqc']} ${styles.f135dsb4} ${styles.fkh7blw}`}>{bkv.nights}</span>
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div className={styles.S2NDX_798}>
                                                            <div className={`${styles.gCSJa} ${styles.XG5Jd}`}>
                                                              <div className={`${styles.ESO13} ${styles.gy2aJ} ${styles.CYQyC} ${styles.Ejrkd}`}>
                                                                <span></span>
                                                              </div>
                                                            </div>
                                                            <div className={`${styles.nf3X_} ${styles.D8iyG} ${styles.Q19mi}`}>
                                                              <div className={`${styles.IjzWp} ${styles.XG5Jd} ${styles.gy2aJ} ${styles.Ejrkd} ${styles.lME98}`}>
                                                                <span className={styles.TtcXM}></span>
                                                              </div>

                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          <BedRegular className={styles.MHEJ29YEB6g} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Room Types</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={styles.YENEKEH39}>
                                                          <span className={styles.beuewoqon2}>Delux Non smoking King Bed</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>

                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span role="button" tabIndex={0} onClick={() => setBkDlg("stay")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("stay"); } }} className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11} ${styles.DNFHRLS} ${styles.ALIEGN}`}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          <EditRegular className={styles.MHEJ29YEB} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Edit</span>
                                                      </div>

                                                    </span>
                                                  </div>
                                                </div>
                                                <div className={`${styles.detailItemLineCompactDSEntryPoint11} ${styles.NWU29WB2}`}>
                                                  <div role="button" tabIndex={0} onClick={() => setBkDlg("avail")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("avail"); } }} className={`${styles.DNFHRLS} ${styles.ALIEGN}`}>
                                                    <span className={styles.iconJEU}><BranchCompareRegular className={styles.MHEJ29YEB} /></span>
                                                    <span className={styles.NEIWGWKJEU}>Rate & Availability</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className={`${styles.detailContainerCompactDSEntryPoint11}  ${styles.HEGTL} ${styles.MEKEU2J2NS}`}>
                                                <div className={styles.detailItemLineCompactDSEntryPoint11}>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          <ConferenceRoomRegular className={styles.MHEJ29YEB6g} />
                                                        </span>

                                                        <span data-id="CurrentDetailLineWindTitle" aria-hidden="true">Room</span>
                                                      </div>
                                                      <div data-id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span data-id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span data-id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles['___1jrfxqc']} ${styles.f135dsb4}`}>{bkv.room}</span>
                                                              </span>
                                                            </div>
                                                          </div>
                                                          {/* <div className="S2NDX===">
                                                          <div className="gCSJa XG5Jd">
                                                            <div className="ESO13 gy2aJ CYQyC Ejrkd">
                                                              <span></span>
                                                            </div>
                                                          </div>
                                                          <div className="nf3X_ D8iyG Q19mi">
                                                            <div className="IjzWp XG5Jd gy2aJ Ejrkd lME98">
                                                              <span className="TtcXM"></span>
                                                            </div>
                                                            
                                                          </div>                                             
                                                        </div> */}
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          {/* <BedRegular className="MHEJ29YEB-6g" /> */}
                                                          <PersonAddRegular className={styles.MHEJ29YEB6g} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Adult</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={styles.YENEKEH39}>
                                                          <span className={styles.beuewoqon2}>1</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          {/* <BedRegular className="MHEJ29YEB-6g" /> */}
                                                          <i className="fi fi-tr-child"></i>
                                                        </span>
                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Child</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={styles.YENEKEH39}>
                                                          <span className={styles.beuewoqon2}>0</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          {/* <BedRegular className="MHEJ29YEB-6g" /> */}
                                                          <i className="fi fi-ts-baby"></i>
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Infant</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={styles.YENEKEH39}>
                                                          <span className={styles.beuewoqon2}>0</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>

                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span role="button" tabIndex={0} onClick={() => setBkDlg("guests")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("guests"); } }} className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11} ${styles.DNFHRLS} ${styles.ALIEGN}`}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          <EditRegular className={styles.MHEJ29YEB} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Edit</span>
                                                      </div>

                                                    </span>
                                                  </div>
                                                </div>
                                                <div className={`${styles.detailItemLineCompactDSEntryPoint11} ${styles.MABVETU} ${styles.wwu82}`}>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span data-id="CurrentDetailLineWindTitle" aria-hidden="true">Rate Code</span>
                                                      </div>
                                                      <div data-id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span data-id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span data-id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles['___1jrfxqc']} ${styles.f135dsb4}`}>{bkv.code}</span>
                                                              </span>
                                                            </div>
                                                          </div>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Meal Plan</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={styles.YENEKEH39}>
                                                          <span className={styles.beuewoqon2}>AMP</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Addons</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={styles.YENEKEH39}>
                                                          <span className={styles.beuewoqon2}>-</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Discount</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={styles.YENEKEH39}>
                                                          <span className={styles.beuewoqon2}>50</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Tax</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={styles.YENEKEH39}>
                                                          <span className={styles.beuewoqon2}>27.00</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>

                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span role="button" tabIndex={0} onClick={() => setBkDlg("rate")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("rate"); } }} className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11} ${styles.DNFHRLS} ${styles.ALIEGN}`}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          <EditRegular className={styles.MHEJ29YEB} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Edit</span>
                                                      </div>

                                                    </span>
                                                  </div>
                                                </div>
                                                <div className={`${styles.detailItemLineCompactDSEntryPoint11} ${styles.NWU29WB2} ${styles.MABVETU}`}>
                                                  <div role="button" tabIndex={0} onClick={() => setBkDlg("guest")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("guest"); } }} className={`${styles.DNFHRLS} ${styles.ALIEGN}`}>
                                                    <span className={styles.iconJEU}><BedRegular className={styles.MHEJ29YEB} /></span>
                                                    <span className={styles.NEIWGWKJEU}>Guest Details</span>
                                                  </div>
                                                </div>
                                              </div>

                                            </div>

                                            <div className={`${styles.overallContainerDSEntryPoint11} ${styles.HTCIW}`}>
                                              <div className={`${styles.detailContainerCompactDSEntryPoint11} ${styles.MEKEU2J2NS}`}>
                                                <div className={styles.detailItemLineCompactDSEntryPoint11}>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          <AirplaneLandingRegular className={styles.MHEJ29YEB6g} />
                                                        </span>

                                                        <span data-id="CurrentDetailLineWindTitle" aria-hidden="true">Arrival</span>
                                                      </div>
                                                      <div data-id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span data-id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span data-id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles['___1jrfxqc']} ${styles.f135dsb4} ${styles.f3z4w6d}`}>{bkv.arrDay}</span>
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div className={styles.S2NDX_798}>
                                                            <div className={`${styles.gCSJa} ${styles.XG5Jd}`}>
                                                              <div className={`${styles.ESO13} ${styles.gy2aJ} ${styles.CYQyC} ${styles.Ejrkd}`}>
                                                                <span>{bkv.arrMon}</span>
                                                              </div>
                                                            </div>
                                                            <div className={`${styles.nf3X_} ${styles.D8iyG} ${styles.Q19mi}`}>
                                                              <div className={`${styles.IjzWp} ${styles.XG5Jd} ${styles.gy2aJ} ${styles.Ejrkd} ${styles.lME98}`}>
                                                                <span className={styles.TtcXM}>Saturday, 11:00 AM</span>
                                                              </div>

                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          <AirplaneTakeOffRegular className={styles.MHEJ29YEB6g} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Departure</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles['___1jrfxqc']} ${styles.f135dsb4} ${styles.f6hvv1p}`}>{bkv.depDay}</span>
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div className={styles.S2NDX_798}>
                                                            <div className={`${styles.gCSJa} ${styles.XG5Jd}`}>
                                                              <div className={`${styles.ESO13} ${styles.gy2aJ} ${styles.CYQyC} ${styles.Ejrkd}`}>
                                                                <span title="hello@creately.com">{bkv.depMon}</span>
                                                              </div>
                                                            </div>
                                                            <div className={`${styles.nf3X_} ${styles.D8iyG} ${styles.Q19mi}`}>
                                                              <div className={`${styles.IjzWp} ${styles.XG5Jd} ${styles.gy2aJ} ${styles.Ejrkd} ${styles.lME98}`}>
                                                                <span className={styles.TtcXM}>Saturday, 11:00 AM</span>
                                                              </div>

                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          <WeatherMoonRegular className={styles.MHEJ29YEB6g} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Nights</span>
                                                      </div>
                                                      <div data-id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span data-id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span data-id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles['___1jrfxqc']} ${styles.f135dsb4} ${styles.fkh7blw}`}>{bkv.nights}</span>
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div className={styles.S2NDX_798}>
                                                            <div className={`${styles.gCSJa} ${styles.XG5Jd}`}>
                                                              <div className={`${styles.ESO13} ${styles.gy2aJ} ${styles.CYQyC} ${styles.Ejrkd}`}>
                                                                <span></span>
                                                              </div>
                                                            </div>
                                                            <div className={`${styles.nf3X_} ${styles.D8iyG} ${styles.Q19mi}`}>
                                                              <div className={`${styles.IjzWp} ${styles.XG5Jd} ${styles.gy2aJ} ${styles.Ejrkd} ${styles.lME98}`}>
                                                                <span className={styles.TtcXM}></span>
                                                              </div>

                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          <BedRegular className={styles.MHEJ29YEB6g} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Room Types</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={styles.YENEKEH39}>
                                                          <span className={styles.beuewoqon2}>Delux Non smoking King Bed</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>

                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span role="button" tabIndex={0} onClick={() => setBkDlg("stay")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("stay"); } }} className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11} ${styles.DNFHRLS} ${styles.ALIEGN}`}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          <EditRegular className={styles.MHEJ29YEB} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Edit</span>
                                                      </div>

                                                    </span>
                                                  </div>
                                                </div>
                                                <div className={`${styles.detailItemLineCompactDSEntryPoint11} ${styles.NWU29WB2}`}>
                                                  <div role="button" tabIndex={0} onClick={() => setBkDlg("avail")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("avail"); } }} className={`${styles.DNFHRLS} ${styles.ALIEGN}`}>
                                                    <span className={styles.iconJEU}><BranchCompareRegular className={styles.MHEJ29YEB} /></span>
                                                    <span className={styles.NEIWGWKJEU}>Rate & Availability</span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className={`${styles.detailContainerCompactDSEntryPoint11}  ${styles.HEGTL} ${styles.MEKEU2J2NS}`}>
                                                <div className={styles.detailItemLineCompactDSEntryPoint11}>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          <ConferenceRoomRegular className={styles.MHEJ29YEB6g} />
                                                        </span>

                                                        <span data-id="CurrentDetailLineWindTitle" aria-hidden="true">Room</span>
                                                      </div>
                                                      <div data-id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span data-id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span data-id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles['___1jrfxqc']} ${styles.f135dsb4}`}>{bkv.room}</span>
                                                              </span>
                                                            </div>
                                                          </div>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          {/* <BedRegular className="MHEJ29YEB-6g" /> */}
                                                          <PersonAddRegular className={styles.MHEJ29YEB6g} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Adult</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={styles.YENEKEH39}>
                                                          <span className={styles.beuewoqon2}>1</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          {/* <BedRegular className="MHEJ29YEB-6g" /> */}
                                                          <i className="fi fi-tr-child"></i>
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Child</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={styles.YENEKEH39}>
                                                          <span className={styles.beuewoqon2}>0</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          {/* <BedRegular className="MHEJ29YEB-6g" /> */}
                                                          <i className="fi fi-ts-baby"></i>
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Infant</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={styles.YENEKEH39}>
                                                          <span className={styles.beuewoqon2}>0</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>

                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span role="button" tabIndex={0} onClick={() => setBkDlg("guests")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("guests"); } }} className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11} ${styles.DNFHRLS} ${styles.ALIEGN}`}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          <EditRegular className={styles.MHEJ29YEB} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Edit</span>
                                                      </div>

                                                    </span>
                                                  </div>
                                                </div>
                                                <div className={`${styles.detailItemLineCompactDSEntryPoint11} ${styles.MABVETU} ${styles.wwu82}`}>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span data-id="CurrentDetailLineWindTitle" aria-hidden="true">Rate Code</span>
                                                      </div>
                                                      <div data-id="CurrentDetailLineWindValue">
                                                        <div className={`${styles.XG5Jd} ${styles.TszOG}`}>
                                                          <div className={`${styles.ZfoST} ${styles.VlT6S} ${styles.azUpZ}`}>
                                                            <div className={`${styles.XG5Jd} ${styles.WNvBZ} ${styles.TBtad} ${styles.q0f8X} ${styles.XW8cf} ${styles.DoCKv} ${styles.vbEPJ}`}>
                                                              <span data-id="avatar-re" className={`${styles['fui-Avatar']} ${styles.r81b29z} ${styles.mP9b0}`}>
                                                                <span data-id="avatar-re__initials" className={`${styles['fui-Avatar__initials']} ${styles.rip04v} ${styles['___1jrfxqc']} ${styles.f135dsb4}`}>{bkv.code}</span>
                                                              </span>
                                                            </div>
                                                          </div>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Meal Plan</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={styles.YENEKEH39}>
                                                          <span className={styles.beuewoqon2}>AMP</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Addons</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={styles.YENEKEH39}>
                                                          <span className={styles.beuewoqon2}>-</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Discount</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={styles.YENEKEH39}>
                                                          <span className={styles.beuewoqon2}>50</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={styles.detailLabelHintDSEntryPoint11}>
                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Tax</span>
                                                      </div>
                                                      <div id="CurrentDetailLineWindValue">
                                                        <div className={styles.YENEKEH39}>
                                                          <span className={styles.beuewoqon2}>27.00</span>

                                                        </div>
                                                      </div>
                                                    </span>
                                                  </div>

                                                  <div className={styles.detailItemGridCompactDSEntryPoint11}>
                                                    <span role="button" tabIndex={0} onClick={() => setBkDlg("rate")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("rate"); } }} className={`${styles.detailItemGroupDSEntryPoint11} ${styles.detailItemGroupHoverDSEntryPoint11}`}>
                                                      <div className={`${styles.detailLabelHintDSEntryPoint11} ${styles.DNFHRLS} ${styles.ALIEGN}`}>
                                                        <span aria-hidden="true" className={styles.slugInfoSpaceDSEntryPoint11}>
                                                          <EditRegular className={styles.MHEJ29YEB} />
                                                        </span>

                                                        <span id="CurrentDetailLineWindTitle" aria-hidden="true">Edit</span>
                                                      </div>

                                                    </span>
                                                  </div>
                                                </div>
                                                <div className={`${styles.detailItemLineCompactDSEntryPoint11} ${styles.NWU29WB2} ${styles.MABVETU}`}>
                                                  <div role="button" tabIndex={0} onClick={() => setBkDlg("guest")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setBkDlg("guest"); } }} className={`${styles.DNFHRLS} ${styles.ALIEGN}`}>
                                                    <span className={styles.iconJEU}><BedRegular className={styles.MHEJ29YEB} /></span>
                                                    <span className={styles.NEIWGWKJEU}>Guest Details</span>
                                                  </div>
                                                </div>
                                              </div>

                                            </div>
                                            {/* all the details of each room */}

                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>


                                </div>



                              </div>
                            </div>
                            {/* Room content here */}

                          </div>
                        )}

                        {/*#EndRegion Dashboard  */}
                        {/* #Region Guest View */}
                        {guestTabsDisplay === "1" && <GuestPanel id={activeWorkFlow} onOpen={(rid) => handleSelectWorkFlow(rid, "1")} />}
                        {/* #EndRegion Guest View */}
                      </div>
                    </div>
                    <div className={`${styles.Hret}`}></div>
                  </div>
                </div>
                {activeButton !== "HMS" && activeButton !== "Modules" && <HospitalityPages tab={activeButton} />}
                {activeButton === "Modules" && <ModulesHub token={user?.token ?? accessToken ?? undefined} drawerOpen={modulesDrawer} onDrawerOpenChange={setModulesDrawer} />}
                <HzQuick action={hzQuick} onClose={() => setHzQuick(null)} />
                {bkDlg && <BookingDialog key={bkDlg} mode={bkDlg} bk={bk} onClose={() => setBkDlg(null)} onApply={(next, msg) => { setBk(next); setBkEdited(true); setBkDlg(null); setBkToast(msg); }} />}
                {bkToast && <div className={`${styles.hzToast} ${styles.hzToastFix}`} role="status" aria-live="polite">{bkToast}</div>}
              </div>

            </div>
          </div>
        </div>
      </div>
      {/* reservation form */}
      <div className="cemhrt css-YWEN2">
        <OverlayDrawer
          className="drw-268Frm"
          position={"bottom"}
          open={isFormOpen}
          onOpenChange={(_, { open }) => setIsFormOpen(open)}
        >
          <div className="p-ia4_top_nav sk-client-theme--light-inverted-sidebar UITESXCVJYTF p-ia4_top_nav--windows">
            <div className="p-ia4_top_nav__container_wrapper">
              <div className="p-ia4_top_nav__left_container">
                <div className="p-ia4_top_nav__left_container--start">
                  <div className="p-ia4_top_nav__left_container--end">
                    <div className="p-ia4_history_buttons">
                      <Button style={{ color: ' color: rgba(255, 255, 255, 1) !important;', fontSize: '19px' }} icon={<ChevronRightRegular />}>
                        {bookingAction}</Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-ia4_top_nav__middle_container notdraggable">
                <div className="p-top_nav__search__container uioetp">
                  <span className="HUP-Text">Property/Location</span>
                  <Combobox
                    name="Location"
                    id="Location"
                    placeholder="Select location"
                    appearance="underline"
                    onInput={handleLocationChange}   // ✅ no fetch here
                    onOptionSelect={propertyHandler}      // ✅ new handler>
                    value={selectedLocation[0]} // ✅ always shows typed text or selected option
                    selectedOptions={selectedLocation[0] ? selectedLocation : []}>
                    {loading ? (
                      <Option key="loading" value="" disabled text="Loading...">
                        <Spinner size="extra-tiny" label="Loading..." />
                      </Option>
                    ) : (
                      Array.isArray(propertyLocation) && propertyLocation.map((option) => (
                        <Option
                          key={option.hotelId.toString()}
                          value={`${option.hotelId}`}
                          text={`${option.hotelName}`} // Ensuring the required `text` prop
                        >
                          <Persona
                            avatar={{ color: "colorful", "aria-hidden": true }}
                            name={`${option.hotelName}`}
                            secondaryText={option.location}
                          />
                        </Option>
                      ))
                    )}
                  </Combobox>

                </div>
              </div>
              <Divider vertical style={{ height: "100%" }}></Divider>
              <div className="p-ia4_top_nav__right_container">
                <div className="align_items_center display_flex uioetp">
                  <span className="HUP-Text">Accounting Date</span>
                  <DatePicker
                  style={{marginLeft: '5px'}}
                    className={styles.control}
                    value={selectedAccountingDate}
                    today={new Date()}
                  />
                </div>

              </div>
              <div className="p-ia4_top_nav__right_container">
                <div className="align_items_center display_flex">
                  <Button onClick={() => setIsFormOpen(false)} icon={<DismissRegular />}></Button>
                </div>

              </div>
            </div>
          </div>
          {/* Body here */}
          <div className={`${styles['p-client_workspace_wrappers']} ${styles.OPERYB}`}>
            <div className={`${styles.RESERVUHEN} ${styles.customScrollBar}`}>
              <div className={`${styles['book-user-inpute']} ${styles['padding-5']}`}>
                <div className={`${styles['input-content']} ${styles.NHWEY}`}>
                  <div className={styles['Hu7ebnje-wygh']}>
                    <Button icon={<PersonRegular />}></Button>
                    <div className="form-group">

                      <span className={styles['HUP-Text']}>Guest Name</span>
                      <div className={styles['input-container']}>
                        <Combobox
                          name="guest"
                          id="guest"
                          placeholder="Guest Names"
                          appearance="underline"
                           value={guestInput} // ✅ always shows typed text or selected option
                           onInput={handleGuestCategoryChange}   // no fetch here
                           onOptionSelect={guestHandler}      // new handler>
                           selectedOptions={selectedGuestOptions}>
                          {loading ? (
                            <Option key="loading" value="" disabled text="Loading...">
                              <Spinner size="extra-tiny" label="Loading..." />
                            </Option>
                          ) : (
                            guestsDataset.map((g) => (
                              <Option
                                key={g.guestId.toString()}
                                value={`${g.firstName} ${g.lastName}`}
                                text={`${g.firstName} ${g.lastName}`} // Ensuring the required `text` prop
                              >
                                <Persona
                                  avatar={{ color: "colorful" }}
                                  name={`${g.firstName} ${g.lastName}`}
                                  presence={{
                                    status: "available",
                                  }}
                                  secondaryText={g.email}
                                />
                              </Option>
                            ))
                          )}
                        </Combobox>

                      </div>
                    </div>
                  </div>
                  <div className={styles['Hu7ebnje-wygh']}>
                    <Button icon={<PhoneShakeRegular />}></Button>
                    <div className="form-group">

                      <span className={styles['HUP-Text']}>Phone Number</span>
                      <div className={styles['input-container']}>
                       <Input
                      appearance="underline"
                      type="text"
                      id="phoneNumber"
                      name="phoneNumber"
                      placeholder="Enter Guest Number"
                      onChange={(event, data) => handleReservationFieldChange(event, "phoneNumber")}
                    />
                      </div>
                    </div>
                  </div>
                  <div className={styles['Hu7ebnje-wygh']}>
                    <Button icon={<MailAddRegular />}></Button>
                    <div className="form-group">

                      <span className={styles['HUP-Text']}>Email</span>
                      <div className={styles['input-container']}>
                        <Input
                          appearance="underline"
                          type="text"
                          id="email"
                          name="email"
                          onChange={(event, data) => handleReservationFieldChange(event, "email")}
                          placeholder="Enter Email" />

                      </div>
                    </div>
                  </div>
                  <div className={styles['Hu7ebnje-wygh']}>
                    <Button icon={<PersonSupportRegular />}></Button>
                    <div className="form-group">

                      <span className={styles['HUP-Text']}>Travel Agent</span>
                      <div className={styles['input-container']}>
                        <Input
                          appearance="underline"
                          type="text"
                          id="travelAgent"
                          name="travelAgent"
                          onChange={(event, data) => handleReservationFieldChange(event, "travelAgent")}
                          placeholder="Travel Agent" />

                      </div>
                    </div>
                  </div>

                </div>
                <div className={`${styles['input-content']} ${styles.UIENo}`}>
                  <div className={styles['Hu7ebnje-wygh']}>
                    <Button icon={<BuildingRegular />}></Button>
                    <div className="form-group">

                      <span className={styles['HUP-Text']}>Company</span>
                      <div className={styles['input-container']}>
                        <Combobox
                          name="company"
                          id="company"
                          placeholder="Select Company"
                          appearance="underline"
                        onInput={handleCompanyChange}   // ✅ no fetch here
                        onOptionSelect={companyHandler}      // ✅ new handler>
                        selectedOptions={selectedcompany[0] ? selectedcompany : []}
                        >
                          {(
                            Array.isArray(company) && company.length > 0 ? (
                              company.map((option) => (
                                <Option key={option.id} value={option.id.toString()} text={option.name}>
                                  <Persona 
                                  name={option.name} 
                                   secondaryText={option.contactEmail}
                                    avatar={{
                                      image: {
                                        src: option.logopath,
                                      },
                                    }} />
                                </Option>
                              ))
                            ) : (
                              <Option key="loading" value="" disabled text="Loading...">
                                <Spinner size="extra-tiny" label="Loading..." />
                              </Option>
                            )
                          )}
                        </Combobox>
                      </div>
                    </div>
                  </div>
                  <div className={styles['Hu7ebnje-wygh']}>
                    <Button icon={<PersonVoiceRegular />}></Button>
                    <div className="form-group">

                      <span className={styles['HUP-Text']}>Booker</span>
                      <div className={styles['input-container']}>
                        <Input
                          appearance="underline"
                          type="text"
                          id="booker"
                          name="booker"
                          value={user.firstName + " " + user.lastName}
                          onChange={(event, data) => handleReservationFieldChange(event, "booker")}
                          placeholder="Travel Agent" />

                      </div>
                    </div>
                  </div>
                  <div className={styles['Hu7ebnje-wygh']}>
                    <Button icon={<PeopleTeamRegular />}></Button>
                    <div className="form-group">

                      <span className={styles['HUP-Text']}>Group code</span>
                      <div className={styles['input-container']}>
                        <Input
                          appearance="underline"
                          type="text"
                          id="groupCode"
                          name="groupCode"
                          onChange={(event, data) => handleReservationFieldChange(event, "groupCode")}
                          placeholder="e.g UB47HJ" />

                      </div>
                    </div>
                  </div>
                  <div className="form-group">

                    <span className={styles['HUP-Text']}>Group Name</span>
                    <div className={styles['input-container']}>
                      <Input
                        appearance="underline"
                        type="text"
                        id="groupName"
                        name="groupName"
                        onChange={(event, data) => handleReservationFieldChange(event, "groupName")}
                        placeholder="Sources" />
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.butKRT}>
                <Switch
                  checked={iswitchChecked}
                  label={`Walk-In`}
                  labelPosition="before"
                  onChange={onChange}
                />
                <Button appearance="primary"
                size="small"
                  icon={<AddRegular />}
                  className={styles['btn-save']}
                  onClick={() => setRoomOffer(true)}>Add Offer</Button>
              </div>
              <div className={`${styles['book-user-inpute']} ${styles.TERGnbe}`}>
                <div className={`${styles.YTRUiowb} ${styles.UIROge}`}>
                  <Button appearance="transparent">Stay Information</Button>
                  <Button appearance="transparent" icon={<MoreHorizontalRegular />}></Button>
                </div>
                <div className={`${styles.wehtRHWK} ${styles.ktrose}`}>
                  <div className={`${styles['input-content']} ${styles.NHWEY} ${styles.UI3628HEB}`}>
                    <div className={styles['Hu7ebnje-wygh']}>
                      <div className="form-group">
                        <Button appearance="transparent" icon={<AirplaneLandingRegular />}> Arrival</Button>
                        <div className={styles['input-container']}>
                          <div className={styles.CurrentDetailLineWindValue}>
                           <DatePicker
                              appearance="underline"
                              placeholder="Chickin date"
                              id="checkInDate"
                              name="checkInDate"
                              className={styles.control}
                              value={arrivalDate}
                              today={new Date()}
                              onSelectDate={(date) => handleArrivalDateChange("checkInDate")(date)}
                            />

                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={styles['Hu7ebnje-wygh']}>
                      <div className="form-group">
                        <Button appearance="transparent" icon={<AirplaneTakeOffRegular />}> Departure</Button>
                        <div className={styles['input-container']} onClick={() => handleShowsEndDate("endDate")}>
                          <div className={styles.CurrentDetailLineWindValue}>
                           <DatePicker
                            appearance="underline"
                            placeholder="Check out date"
                            name="checkOutDate"
                            id="checkOutDate"
                            className={styles.control}
                            value={departureDate}
                            today={new Date()}
                            onSelectDate={(date) => handleDepartureDateChange("checkOutDate")(date)}
                          />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={styles['Hu7ebnje-wygh']}>
                      <div className="form-group">
                        <Button appearance="transparent" icon={<WeatherMoonRegular />}> Number of Nights</Button>
                        <div className={styles['input-container']}>
                          <div className={styles.CurrentDetailLineWindValue}>
                            <Input
                              disabled={true}
                              id="numberOfNights"
                              name="numberOfNights"                           
                              appearance="underline"
                              value={totalNumberOfNights.toString()}                         
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={styles['Hu7ebnje-wygh']}>
                      <div className="form-group">
                        <Button appearance="transparent" icon={<AirplaneLandingRegular />}> Room Types</Button>
                        <div className={styles['input-container']}>
                         <div className={styles.CurrentDetailLineWindValue}>
                            <Input
                              disabled={true}
                              id="roomTypeName"
                              name="roomTypeName"
                              appearance="underline"
                              value={selectedRoomTypesInput?.roomTypeName || ''}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* 
            <div className="Hu7ebnje-wygh">
              <div className="form-group MABEERGRV">
                <Button appearance="transparent" icon={<EditRegular />}> Edit</Button>
              </div>
            </div> */}
                  </div>
                  <div className={`${styles['input-content']} ${styles.NHWEY} ${styles.UI3628HEB}`}>
                    <div className={styles['Hu7ebnje-wygh']}>
                      <div className="form-group">
                        <Button appearance="transparent" icon={<ConferenceRoomRegular />}>Room</Button>
                        <div className={styles['input-container']}>
                          <div className={styles.CurrentDetailLineWindValue}>
                            <Combobox
                              name="room"
                              id="room"
                              placeholder="Select Room"
                              appearance="underline"         
                              onInput={handleRoomCategoryChange}   // ✅ no fetch here
                              onOptionSelect={roomHandler}      // ✅ new handler>
                               selectedOptions={selectedRoomOptions}>
                              {loading ? (
                                <Option key="loading" value="" disabled text="Loading...">
                                  <Spinner size="extra-tiny" label="Loading..." />
                                </Option>
                              ) : (
                                rooms.map((option) => (
                                  <Option
                                    key={option.roomId}
                                    value={option.roomNumber}
                                    text={option.roomName} // Required `text` prop
                                  >
                                    <Persona
                                      avatar={{ color: "colorful", "aria-hidden": true }}
                                      name={option.roomName}
                                      presence={{
                                        status: "available",
                                      }}
                                      secondaryText={option.roomCategory}
                                    />
                                  </Option>
                                ))
                              )}
                            </Combobox>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={styles['Hu7ebnje-wygh']}>
                      <div className="form-group">
                        <Button appearance="transparent" icon={<PersonRegular />}>Adults</Button>
                        <div className={styles['input-container']}>
                          <div className={styles.CurrentDetailLineWindValue}>
                            <Input
                              appearance="underline"
                              type="text"
                              id="numberOfAdults"
                              name="numberOfAdults"
                              onChange={(event, data) => handleReservationFieldChange(event, "numberOfAdults")}
                              placeholder="2" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={styles['Hu7ebnje-wygh']}>
                      <div className="form-group">
                        <Button appearance="transparent" icon={<PersonRegular />}>Childs</Button>
                        <div className={styles['input-container']}>
                          <div className={styles.CurrentDetailLineWindValue}>
                            <Input
                              id="numberOfChildren"
                              name="numberOfChildren"
                              onChange={(event, data) => handleReservationFieldChange(event, "numberOfChildren")}
                              appearance="underline"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={styles['Hu7ebnje-wygh']}>
                      <div className="form-group">
                        <Button appearance="transparent" icon={<PersonRegular />}>Infants</Button>
                        <div className={styles['input-container']}>
                          <div className={styles.CurrentDetailLineWindValue}>
                            <Input
                              id="numberOfInfants"
                              name="numberOfInfants"
                              onChange={(event, data) => handleReservationFieldChange(event, "numberOfInfants")}
                              appearance="underline"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`${styles['book-user-inpute']} ${styles.TERGnbe} ${styles.UETBWGW_LASTE}`}>
                <div className={styles.YTRUiowb}>
                  <TabList defaultSelectedValue="tab1">
                    <Tab value="tab1" onClick={() => handleTabControler("demography")} icon={<ConnectedRegular />}>

                      Demography
                    </Tab>
                    {/* <Tab value="tab2" onClick={() => handleTabControler("Payment Option")} icon={<PaymentWirelessRegular />}>

                      Payment Option
                    </Tab> */}
                    <Tab value="tab3" onClick={() => handleTabControler("Additional Details")} icon={<ClipboardTextEditRegular />}>
                      Additional Details
                    </Tab>
                    <Tab value="tab4" onClick={() => handleTabControler("Document")} icon={<DocumentRegular />}>

                      Document</Tab>
                  </TabList>
                </div>
                <div className={styles.CYEOKMNW}>
                  {(isTabValueVisible === "demography" &&
                    <div className={styles.wehtRHWK}>
                      <div className={`${styles['input-content']} ${styles.NHWEY}`}>
                        <div className={styles['Hu7ebnje-wygh']}>
                          <div className="form-group">

                            <span className={styles['HUP-Text']}>Age</span>
                            <div className={styles['input-container']}>
                              <Input
                                id="age"
                                appearance="underline"
                                placeholder="30 Years"
                                type="number"
                                name="age"
                                 onChange={(event, data) => handleReservationFieldChange(event, "age")}
                              />
                            </div>
                          </div>
                        </div>
                        <div className={styles['Hu7ebnje-wygh']}>
                          <div className="form-group">

                            <span className={styles['HUP-Text']}>Gender</span>
                            <div className={styles['input-container']}>
                              <Input
                                id="gender"
                                placeholder="Male/Female"
                                type="text"
                                appearance="underline"
                                name="gender"
                                 onChange={(event, data) => handleReservationFieldChange(event, "gender")}
                              />
                            </div>
                          </div>
                        </div>
                        <div className={styles['Hu7ebnje-wygh']}>
                          <div className="form-group">

                            <span className={styles['HUP-Text']}>Occupation</span>
                            <div className={styles['input-container']}>
                              <Input
                                id="occupation"
                                placeholder="Banker"
                                type="text"
                                appearance="underline"
                                name="occupation"
                                onChange={(event, data) => handleReservationFieldChange(event, "occupation")}
                              />
                            </div>
                          </div>
                        </div>
                        <div className={styles['Hu7ebnje-wygh']}>
                          <div className="form-group">

                            <span className={styles['HUP-Text']}>Marital Status</span>
                            <div className={styles['input-container']}>
                              <Input
                                id="Utheiehr"
                                placeholder="Maried/Single"
                                type="text"
                                appearance="underline"
                                name="maritalStatus"
                                onChange={(event, data) => handleReservationFieldChange(event, "maritalStatus")}
                              />
                            </div>
                          </div>
                        </div>

                      </div>
                      <div className={`${styles['input-content']} ${styles.UIENo}`}>
                        <div className={styles['Hu7ebnje-wygh']}>
                          <div className="form-group">

                            <span className={styles['HUP-Text']}>Purpose of Stay</span>
                            <div className={styles['input-container']}>
                              <Input
                                id="purposeOfStay"
                                placeholder="Business, leisure, medical, or event-related."
                                type="text"
                                appearance="underline"
                                name="purposeOfStay"
                                onChange={(event, data) => handleReservationFieldChange(event, "purposeOfStay")}
                              />
                            </div>
                          </div>
                        </div>
                  
                      </div>
                    </div>
                  )}

                  {/* {isTabValueVisible === "Payment Option" && (
                    <div className={styles.wehtRHWK}>
                      <PaymentOptions />
                    </div>
                  )} */}
                  {isTabValueVisible === "Additional Details" && (
                    <div className={styles.wehtRHWK}>
                      <div className={`${styles['input-content']} ${styles.NHWEY}`}>
                        <div className={styles['Hu7ebnje-wygh']}>
                          <div className="form-group">

                            <span className={styles['HUP-Text']}>Special Requests</span>
                            <div className={styles['input-container']}>
                              <Input
                               
                                appearance="underline"
                                id="specialRequests"
                                name="specialRequests"
                                 onChange={(event, data) => handleReservationFieldChange(event, "specialRequests")}
                              />
                            </div>
                          </div>
                        </div>
                        <div className={styles['Hu7ebnje-wygh']}>
                          <div className="form-group">

                            <span className={styles['HUP-Text']}>Dietary Preference</span>
                            <div className={styles['input-container']}>
                              <Input
                                
                                placeholder="Vegetarian, Vegan, Gluten-Free"
                                type="text"
                                appearance="underline"
                                id="dietaryPreference"
                                name="dietaryPreference"
                                onChange={(event, data) => handleReservationFieldChange(event, "dietaryPreference")}
                              />
                            </div>
                          </div>
                        </div>
                        <div className={styles['Hu7ebnje-wygh']}>
                          <div className="form-group">

                            <span className={styles['HUP-Text']}>Arrival Time</span>
                            <div className={styles['input-container']}>
                              <Input
                               
                                placeholder="Banker"
                                type="text"
                                appearance="underline"
                                id="arrivalTime"
                                name="arrivalTime"
                                onChange={(event, data) => handleReservationFieldChange(event, "arrivalTime")}
                              />
                            </div>
                          </div>
                        </div>
                        <div className={styles['Hu7ebnje-wygh']}>
                          <div className="form-group">

                            <span className={styles['HUP-Text']}>Remarks</span>
                            <div className={styles['input-container']}>
                              <Input
                               
                                placeholder="Maried/Single"
                                type="text"
                                appearance="underline"
                                id="remarks"
                                name="remarks"
                                onChange={(event, data) => handleReservationFieldChange(event, "remarks")}

                              />
                            </div>
                          </div>
                        </div>

                      </div>
                      <div className={`${styles['input-content']} ${styles.UIENo}`}>
                        <div className={styles['Hu7ebnje-wygh']}>
                          <div className={`${styles['form-group']}`}>
                            <span className={styles['HUP-Text']}>Pickup Required</span>
                            <div className={styles['input-container']}>
                              <Input
                                placeholder="Business, leisure, medical, or event-related."
                                type="text"
                                appearance="underline"
                                id="pickupRequired"
                                name="pickupRequired"
                                onChange={(event, data) => handleReservationFieldChange(event, "pickupRequired")}
                              />
                            </div>
                          </div>
                        </div>
                        
                       

                      </div>
                    </div>
                  )}
                  {isTabValueVisible === "Document" && (
                  <div className={styles.wehtRHWK}>

    <Button size="small" appearance="secondary" icon={<Add16Regular />}>
  Upload Document
  <input type="file" hidden 
      id="fileUpload"
      accept=".pdf,.doc,.docx,.txt"
      className={styles.uploadInput}
      onChange={(e) => {
        const file = e.target.files?.[0];
        if (file) {
          console.log("Selected file:", file.name);
          // TODO: handle upload logic here (e.g., send to API or store in state)
        }
      }}
    />
</Button>
   
  </div>
                  )}
                </div>

              </div>
              <div className={`${styles['book-user-inpute']} ${styles.HEUETWJ} ${styles.opeytrb}`}>
                <div className={styles.tenabgujEJIK}>
                  {reservationMsg && <Text size={200} role={reservationMsg.error ? "alert" : "status"} style={{ color: reservationMsg.error ? "#b10e1c" : undefined, marginRight: 8 }}>{reservationMsg.text}</Text>}
                  <Button appearance="primary" size="small" icon={<DocumentAdd16Regular />} onClick={handleReservationRegisters} className={styles['btn-save']}>Submit</Button>
                <Button  size="small" icon={<CalendarCancel16Regular />} onClick={handleClearReservation} className={styles['btn-save']}>Cancel</Button>
             
                </div>
                 </div>
            </div>
          </div>
          {/* Extra form */}
          <div className="Manage-contact-ui83j">
            {roomOffer &&
              <RoomOffers onClose={handleRoomOfferClose} />
            }
          </div>
        </OverlayDrawer>
      </div>
    </>


  )
}


export default HospitalityManagement;